import React, { Component, createRef } from 'react'; //different
import './App.css';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import Banner from "./BannerSlider";
import Luckywhell from "./luckyfortune";
import Popup from "./popup";
import Footer from "./footer";
import Mobilemenu from "./mobilemenu";
import moment from 'moment';
import md5 from 'md5';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import NProgress from "nprogress";
import axios from 'axios';
import TLCBanner from "./BannerCarousel";
import JackpotSlider from './JackpotSlider';
import { NumericFormat } from 'react-number-format';
import { EightKSharp } from '@mui/icons-material';
import { showConfirmToast } from './toastConfirm';
// ความยาว path ของ SVG ที่ให้มา
let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;
class Main extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ios: true,
      lbCounter: 600,           // เหลือเวลา (วินาที) เริ่มที่ 10 นาที
      lbDurationSec: 600,       // ความยาวทั้งหมด (วินาที)
      lbStartedAt: null,        // เวลาเริ่มจริง (ms)
      finish: 0,
      clickserch: false,
      filterhistory: "DE",
      visibleCount: 10,     // โชว์ทีละ 10
      loadingMore: false,
      loading: false,
      query: "", // ค่าที่พิมพ์
      currentTime: Date.now(),
      modalbanklist: false,
      gridLoading: true,
      imagesLoaded: 0,
      TurnOverAmount: 0,
      bankselect: null,
      listserch: [],
      openDeposit: false,
      openWithdraw: false,
      modalmaintain: false,
      open: false,
      trueAccountlist: [],
      banklist: [],
      centerIdx: 0,
      tabselectdep: 0,
      scrollDir: 'up', // ค่าเริ่มต้น
      tabselection: 1,
      openLogin: false,
      openRegister: false,
      inkLeft: 0,
      inkWidth: 0,
      typepage: "",
      keywithdraw: "",
      popupprofile: false,
      webname: "",
      tabbannerlist: [],
      previewUrl: null,
      dateselect: moment(new Date()).format("YYYY/MM/DD"),
      inputTimeHour: moment(new Date()).format("HH"),
      inputTimeMin: moment(new Date()).format("mm"),
      isConfirmed: false,
      usercheck: "",
      categorylist: [],
      dropdownOpen: false,
      tabprofile: 1,
      isPopupOpen: false,
      selectedItem: null, // Store the selected item
      luckywheeldisplay: false,
      listitallgame: [],
      slotlist: [],
      sportlist: [],
      logoimg: '',
      describemain: "",
      fishinglist: [],
      gamehitlist: [],
      gamehitpglist: [],
      randomlist: [],
      gamenewlist: [],
      files: [],
      providorlist: [],
      filterlist: [],
      stats: {},
      reports: {},
      qrstep: 1,
      listacc: [],
      addhome: true,
      whellsetting: [],
      pglist: [],
      tabselectdeposit: 0,
      rewardlist: [],
      loader: false,
      recentlist: [],
      activePage: 1,
      ThmeseV: null,
      pagecount: 1,
      trueaccount: true,
      products_page_count: 1,
      isActive: false,
      activeTab: 1,
      resetpass: 0,
      paymentlist: null,
      checkcredit: false,
      refer: 1,
      showmodal: false,
      historylist: [],
      formData: {}, // Contains login form data
      errors: {}, // Contains login field errors
      formSubmitted: false, // Indicates submit status of login form
      loading: false, // Indicates in progress state of login form
      tblprofile: [],
      afficiate: [],
      cashoutSet: [],
      modal: false,
      modalpromotion: false,
      linkaff: "",
      point: 0,
      maxwithdrawstatus: 0,
      useradvice: [],
      afficiatetoday: [],
      afficiateall: [],
      balance: 0.00,
      counter: 300,
      partner: null,
      qrcodecheck: false,
      loginstate: !!localStorage.getItem('auth_token'),
      firstname: null,
      lastname: null,
      activeTab: 1,
      alert: null,
      modalOpen: false,
      handleClose: false,
      proderedeemlist: [],
      token: window.localStorage.getItem("token"),
      type: "",
      prolistx: [],
      prodetail: [],
      username: "",
      tabselect: 14,
      showpass: false,
      amount: "",
      remark: "",

      rankpic: "1.jpeg",
      rankname: null,
      rankob: null,
      rankpoint: 0,
      limit: null,
      name: "",
      password: "",
      oldpassword: "",
      passwordcf: "",
      left: false,
      pathname: "",
      linelink: "",
      mainsetting: [],
      rewardlist: [],
      activePage: 1,
      checkboxcookie: false,
      isActive: false,
      formData: {}, // Contains login form data
      errors: {}, // Contains login field errors
      formSubmitted: false, // Indicates submit status of login form
      pagecount: 1,
      picture: null,
      settingwheel: "",
      settingcheckin: "",
      userid: null,
      phoneNumber: "",
      mainacc: null,
      paymentgateway: null,
      tabselectsec: 0,
      checkcashout: false,
      stateregis: 1,
      checkboxacc: 0,
      products_page_count: 1,
      fullname: null,
      lname: null,
      link: "",
      alert: null,
      depositstate: 0,
      stateforget: 1,
      depositamount: "",
      stateopterror: "",
      btnisActive: true,
      otpphone: "",
      token: window.localStorage.getItem("token"),
      accnumber: null,
      accnumbertxt: null,
      withdrawamount: "",
      rankpoint: 0,
      changepassword: false,
      errortext: "",
      datas: null,
      otpphoneforget: "",
      affpercent: 0,
      counter: 300,
      userrecomend: "",
      useradvice: [],
      currentIndexA: 0,
      currentIndex: 0,
      cashoutlist: [],
      tblnextrank: [],
      tblrankall: [],
      maxwithdrawstatus: 0,
      tblprofile: [],
      prodetail: [],
      oldpassword: "",
      linkaff: "",
      webnamex: "",
      inviteSet: "",
      truegiftlink: "",
      proderedeem: [],
      qrcode: null,
      proderedeemlist: [],
      buttoncliam: false,
      limit: {
        min: 100,
        max: 200000,
      },
      rankname: null,
      rankob: null,
      cashoutSet: [],
      tblPopupMenu1: [],
      tblPopupMenu2: [],
      tblPopupMenu: null,
      termAndCondition: false,
      errorstatus: false,
      modalx: false,
      hours: 0,
      showPopup: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      minutes: 0,
      seconds: 0
    }
    this.timer = null; // เก็บตัวนับเวลา
    this.popupRef = createRef();
    this.order = [14, 10, 13, 17, 51, 12, 11, 18, 20];
    this.rootRef = React.createRef();
    this._mo = null;
    this._enhancedSet = new WeakSet(); // track images already enhanced
    this.onSearchKeyDown = this.onSearchKeyDown.bind(this);

  }
  _mounted = false;
  topRef = React.createRef();
  scrollerRef = React.createRef();
  resizeObs = null;
  _scrollAttached = false;  // กันผูกซ้ำ

  buildSrcSet(imageUrl) {
    const widths = [640, 750, 828, 1080, 1200, 1920, 2048, 3840];
    const hasQuery = imageUrl.includes("?");
    return widths.map(w => `${imageUrl}${hasQuery ? "&" : "?"}imwidth=${w} ${w}w`).join(", ");
  }

  handleChange = (e) => {
    this.setState({ query: e.target.value, clickserch: false });
  };

  handleClear = () => {
    this.setState({ query: "", listserch: [], clickserch: false });
    // ถ้ามี callback ให้ parent ด้วย
    if (this.props.onClear) this.props.onClear();
  };
  onSearchKeyDown = async (e) => {
    // รับเฉพาะ Enter
    if (e.key !== 'Enter') return;
    try { e.preventDefault(); } catch (_) { }

    const value = (e.currentTarget && e.currentTarget.value) ? e.currentTarget.value.trim() : '';
    console.log('[search] Enter pressed, value =', value);

    if (!value) {
      // ถ้าต้องการแจ้งผู้ใช้ ให้ใส่ notify
      // await this.notify('warning', 'กรุณากรอกคำค้นหา');
      return;
    }

    // เริ่ม loading UI
    this.setState({ loading: true });

    // create request sequence id to drop stale responses
    if (typeof this._gameReqSeq === 'undefined') this._gameReqSeq = 0;
    const reqId = ++this._gameReqSeq;
    const now = Date.now();

    // prepare payload - ปรับ field ให้ตรงกับที่ backend ต้องการ
    const payload = {
      state: "serchlist",                    // ผมใส่ value เป็น state ขอให้ปรับถ้าต้องส่งพารามิเตอร์อื่น
      System: Systems,
      serchtxt: value,
      partner: this.state.partner || '',
      game: this.state.typepage || ''   // ถ้ต้องการเปลี่ยน จะใช้ value หรือค่าอื่น
    };

    console.debug('[search] calling /api/v1/tabgamelist', payload);

    try {
      const { data } = await instance.post("/api/v1/tabgamelist", payload);

      // ถ้ามี response เก่าจาก request อื่นมาแล้ว ให้ทิ้ง
      if (reqId !== this._gameReqSeq) {
        console.log('[onSearchKeyDown] stale response dropped', reqId);
        return;
      }

      if (!data || data?.status !== 200) {
        console.error('[onSearchKeyDown] bad status', data);
        this.setState({
          listserch: [],
          clickserch: true,
          typepage: payload.game // ถ้าต้องการเก็บค่าที่ค้นหา
        });

        // แจ้งผู้ใช้ได้ถ้าต้องการ
        // await this.notify('error', data?.message || 'ไม่สามารถดึงข้อมูลเกมได้');
        return;
      }

      // Normalize structure (เหมือนโค้ดที่คุณให้มา)
      const msg = Array.isArray(data.message) ? data.message : [];
      console.log('[onSearchKeyDown] msg length=', msg.length);
      const listserch = msg;

      // update state with ALL lists
      this.setState({
        listserch,
        clickserch: true,
        typepage: payload.game // ถ้าต้องการเก็บค่าที่ค้นหา
      });

    } catch (err) {
      console.error('[onSearchKeyDown] api error', err);
      // แจ้งผู้ใช้ถ้าต้องการ: await this.notify("error", "เกิดข้อผิดพลาดในการค้นหา");
    } finally {
      // ปิด loading เสมอ
      this.setState({ loading: false });
    }
  };


  async recheccredit(evt) {

    // evt.currentTarget.className += " refresh-loading";
    const el = evt.currentTarget;
    el.classList.add('refresh-loading');
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    this.setState({
      checkcredit: true,
      userid: decoded.message.playerid,
      username: decoded.message.playerid,
      firstname: decoded.message.firstname,
      lastname: decoded.message.lastname,
      loginstate: true,
    });
    try {
      // console.log(2);
      await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'recheccredit-App.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        console.log("recheccredit", res.data)
        if (res.data.status === 200) {
          localStorage.setItem('auth_token', res.data.token)
          this.setState({
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            fullname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
            checkcredit: false,
          });
          el.classList.remove('refresh-loading');
        }
        else if (res.data.status === 401) {
          //   console.log(res.data);
          localStorage.clear();
          await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
          window.location.href = '/';
        }

      }).catch(async (err) => {
        // console.log(err);
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
          window.location.href = '/';
        }
      });
    }
    catch (ex) {
      ////////console.log(ex);
    }
  }
  loadMore = () => {
    const total = this.state.listitallgame?.length || 0;
    if (this.state.loadingMore) return;
    if (this.state.visibleCount >= total) return;

    this.setState({ loadingMore: true }, () => {
      requestAnimationFrame(() => {
        this.setState(prev => ({
          visibleCount: Math.min((prev.visibleCount || 0) + 10, total),
          loadingMore: false,
        }), this.ensureFilledViewport);
      });
    });
  };




  componentWillUnmount() {
    try { if (this._mo) this._mo.disconnect(); } catch (e) { }
  }

  enhanceAllImages = (root = document) => {
    try {
      const imgs = Array.from((root).querySelectorAll ? root.querySelectorAll('img') : []);
      imgs.forEach(img => this.enhanceImage(img));
    } catch (e) {
      console.warn('enhanceAllImages error', e);
    }
  }

  enhanceImage = (img) => {
    if (!img || !(img instanceof HTMLImageElement)) return;
    if (this._enhancedSet.has(img)) return; // already done
    // don't touch images that are part of UI controls you don't want to change (optional)
    // e.g. if (img.closest('.no-enhance')) return;

    this._enhancedSet.add(img);

    // choose placeholder source:
    // prefer data-placeholder attribute (you can add data-placeholder on server side),
    // otherwise fallback to same src (not ideal but OK). Ideally backend provides tiny thumb.
    const placeholderSrc = img.getAttribute('data-placeholder') || img.getAttribute('data-lowres') || img.src;

    // compute wrapper size: prefer width/height attributes or computed size
    const rect = img.getBoundingClientRect();
    const hasDimensions = rect && rect.width > 0 && rect.height > 0;

    // create wrapper and placeholder element
    const wrapper = document.createElement('div');
    wrapper.className = 'photo-wrap';

    // try to preserve inline size to avoid layout shift
    if (img.width) wrapper.style.width = (img.width + 'px');
    if (img.height) wrapper.style.height = (img.height + 'px');
    // if no explicit size, try computed width/height
    if (!img.width && hasDimensions) {
      wrapper.style.width = rect.width + 'px';
      wrapper.style.height = rect.height + 'px';
    }

    const phDiv = document.createElement('div');
    phDiv.className = 'photo-ph';
    phDiv.style.backgroundImage = `url("${placeholderSrc}")`;
    wrapper.appendChild(phDiv);

    // insert wrapper into DOM and move img inside it
    try {
      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
    } catch (e) {
      console.warn('Unable to wrap image', e);
      return;
    }

    // style the img to be absolute / cover
    img.style.position = 'absolute';
    img.style.inset = '0';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = img.style.objectFit || 'cover';
    // ensure image has alt preserved etc.

    // load / error handlers
    const onLoad = () => {
      img.classList.add('loaded');
      wrapper.classList.add('loaded');
      cleanup();
      // optionally remove placeholder after transition
      setTimeout(() => {
        try { phDiv.remove(); } catch (_) { }
      }, 400);
    };
    const onError = () => {
      // still remove blur but mark failed
      img.classList.add('loaded');
      wrapper.classList.add('loaded', 'image-failed');
      cleanup();
    };
    const cleanup = () => {
      img.removeEventListener('load', onLoad);
      img.removeEventListener('error', onError);
    };

    img.addEventListener('load', onLoad);
    img.addEventListener('error', onError);

    // if already loaded (cached)
    if (img.complete && img.naturalWidth) {
      // schedule microtask to apply loaded state
      setTimeout(() => onLoad(), 10);
    }
  }








  // เติมให้ "พ้น 1 จอ"
  ensureFilledViewport = () => {
    const el = this.scrollerRef.current;   // <<< เปลี่ยนตรงนี้
    if (!el) return;
    const total = this.state.listitallgame?.length || 0;
    let guard = 0;
    const step = () => {
      if (el.scrollHeight <= el.clientHeight &&
        this.state.visibleCount < total &&
        guard++ < 6) {
        this.setState(prev => ({
          visibleCount: Math.min((prev.visibleCount || 0) + 10, total)
        }), () => requestAnimationFrame(step));
      }
    };
    requestAnimationFrame(step);
  };

  // ใกล้ก้นจอ → โหลดเพิ่ม
  handleScroll = () => {
    const el = this.scrollerRef.current;   // <<< เปลี่ยนตรงนี้
    if (!el) return;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 200;
    if (nearBottom) this.loadMore();
  };
  componentWillUnmount() {
    this._mounted = false;
  }
  // lifecycle

  setStateAsync = (upd) => new Promise(res => this.setState(upd, res));

  boot = async () => {
    let loginstate = !!localStorage.getItem('auth_token');
    const token = localStorage.getItem('auth_token');
    if (token) {
      try {
        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        await this.rechecklogin(Username, token);
        loginstate = true;
      } catch { loginstate = false; }
    }

    // อัปเดตทั้ง ref และ state แต่เช็ค _mounted ก่อน
    this.loginstateRef = loginstate;
    if (this._mounted) await this.setStateAsync({ loginstate });

    // ส่ง loginOverride เข้าไปให้ navigateTo ใช้ ไม่ต้องรอ state
    await this.navigateTo(window.location.pathname, { selection: 1, loginOverride: loginstate });
  };
  componentWillUnmount() {
    const root = this.scrollerRef.current;   // <<< เปลี่ยนตรงนี้
    if (root && this._scrollAttached) {
      root.removeEventListener('scroll', this.handleScroll);
      this._scrollAttached = false;
    }
    this.resizeObs?.disconnect();
    this.resizeObs = null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.listitallgame !== this.state.listitallgame) {
      const total = this.state.listitallgame?.length || 0;
      this.setState({ visibleCount: Math.min(10, total) }, this.ensureFilledViewport);
    }

  }








  // ==== Countdown helpers (ใส่ใน class) ====
  startQrCountdown = (secs = 300) => {
    // กันซ้ำ
    clearInterval(this._qrTimer);
    this.setState({ counter: secs, qrcodeExpired: false }, () => {
      this._qrTimer = setInterval(() => {
        this.setState((s) => {
          if (s.counter <= 1) {
            clearInterval(this._qrTimer);
            return { counter: 0, qrcodeExpired: true };
          }
          return { counter: s.counter - 1 };
        });
      }, 1000);
    });
  };



  initSwiper = () => {
    // 2) ใช้ selector ที่คุณ test แล้วว่ามีจริง
    const sel = '.Home.container .Notice .swiper-container';
    const el = document.querySelector(sel);
    if (!el) return;

    // 3) ป้องกันการ init ซ้ำ
    if (el._mySwiper) return;

    // 4) init แนวนอนชัดเจน
    try {
      const inst = new window.Swiper(el, {
        direction: 'horizontal',
        allowTouchMove: true,
        simulateTouch: true,
        resistanceRatio: 0.85,
        slidesPerView: 1,
        centeredSlides: false,
        // ถ้ามี pagination/navigation ให้เติม modules/selector ตามเวอร์ชันที่ใช้
      });
      el._mySwiper = inst;
    } catch (e) {
      console.error('init Swiper failed', e);
    }
  }

  componentWillUnmount() {
    const el = document.querySelector('.Home.container .Notice .swiper-container');
    if (el && el._mySwiper && typeof el._mySwiper.destroy === 'function') {
      el._mySwiper.destroy(true, true);
      el._mySwiper = null;
    }
  }

  clearQrCountdown = () => {
    clearInterval(this._qrTimer);
  };
  PATH_LEN = 251.966;

  startLocalBankCountdown = (minutes = 10) => {
    const duration = minutes * 60;
    const startedAt = Date.now();
    const endAt = startedAt + duration * 1000;

    clearInterval(this._lbTimer);
    this.setState({
      lbDurationSec: duration,
      lbCounter: duration,
      lbStartedAt: startedAt,
    });

    this._lbTimer = setInterval(() => {
      const now = Date.now();
      const remain = Math.max(0, Math.ceil((endAt - now) / 1000));
      this.setState({ lbCounter: remain });
      if (remain <= 0) {
        clearInterval(this._lbTimer);
        // TODO: ทำอะไรตอนหมดเวลา เช่น mark expired / ปุ่มรีเฟรช
      }
    }, 1000);
  };

  formatCountdown = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  getDashOffset = () => {
    const { lbCounter, lbDurationSec } = this.state;
    const remainRatio = Math.max(0, Math.min(1, lbCounter / lbDurationSec));
    // เริ่มจากเต็ม (offset = PATH_LEN) แล้วลดลงไปหา 0
    return this.PATH_LEN * remainRatio;
  };

  componentWillUnmount() {
    this.clearQrCountdown();
  }

  setDepositTab = (idx) => {
    this.setState({
      tabselectdep: idx,
      tabselectsec: idx
    });
  };
  // helper สร้างคลาส active
  getItemClass = (idx, extra = "") => {
    const base = `methodsItem ${extra}`.trim();
    return this.state.tabselectdep === idx ? `${base} methodsItemActive` : base;
  };
  openLogin = () => this.setState({ openLogin: true });
  closeLogin = () => this.setState({ openLogin: false });
  openRegister = () => this.setState({ openRegister: true });
  closeRegister = () => this.setState({ openRegister: false });
  handleImgDone = () => {
    const total = Math.min(9, (this.state.listitallgame || []).length); // เฉพาะที่ slice(0,9)
    this.setState(prev => {
      const loaded = prev.imagesLoaded + 1;
      return {
        imagesLoaded: loaded,
        gridLoading: loaded < total // ทุกภาพเสร็จแล้วค่อยปิดโหลด
      };
    });
  };


  openWithdrawModal = () => this.setState({ openWithdraw: true });
  closeWithdrawModal = () => this.setState({ openWithdraw: false });

  openDepositModal = () => this.setState({ openDeposit: true });
  closeDepositModal = () => this.setState({ openDeposit: false });
  async modalerror(object) {
    await this.notify(object.title, object.text);
  }
  redeemlotto = (e, _id, roomid) => {
    const userAgent = navigator.userAgent;
    this.checklogin();

    if (!this.state.loginstate) {
      this.notify("error", 'คุณยังไม่ได้เข้าสู่ระบบ');
      return;
    }

    if (this.state.username) {
      instance.post("/api/v1/tablauncherlotto", {
        roomid: roomid,
        playerUsername: this.state.username,
        isMobile: isMobile,
        System: Systems,
        demo: false,
      }).then((res) => {
        if (res.data.status === 200) {
          const launcher = res.data.message.launcher;
          if (launcher) {
            if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
              window.location.href = launcher.mobile;
            } else {
              isMobile
                ? window.open(launcher.mobile, '_blank', 'height=1000,width=1000')
                : window.open(launcher.desktop, '_blank', 'height=1000,width=1000');
            }
          } else {
            toast.error(
              <div>
                <strong>error!</strong>
                <div style={{ marginTop: 6 }}>ขณะนี้เกมมีปัญหากรุณารอซักครู่</div>
              </div>,
              {
                position: 'top-center',    // หรือ 'top-right' ตามชอบ
                autoClose: 5000,           // ปิดเองหลัง 5 วินาที
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: 'colored',
              }
            );
          }
        }
      });
    }
  };
  checklogin() {
    var token = localStorage.getItem('auth_token');

    console.log(11111111, token);
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      this.rechecklogin(Username, token);
    }
    else {
      this.setState({
        loginstate: false,
      });
    }
  }
  redeem = (e, gameIdx, partner) => {
    var userAgent = navigator.userAgent
    this.checklogin();
    if (!this.state.loginstate) {
      toast.error("คุณยังไม่ได้ทำการล๊อคอิน", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
      // return document.getElementById("loginmode").click();
    }
    if (this.state.username !== null) {
      instance.post("/api/v1/tablauncher", {
        gameId: gameIdx,
        partner: partner,
        playerUsername: this.state.username,
        isMobile: isMobile,
        System: Systems,
        demo: false
      })
        .then((res) => {
          if (res.data.status === 200) {
            //////console.log(res.data.message);
            var test = res.data.message.launcher
            if (test !== undefined) {
              if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                window.location.href = test.mobile;
              }
              else {
                if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                else window.open(test.mobile);
              }
            }
            else if (test === undefined) {
              toast.error("ขณะนี้เกมมีปัญหากรุณารอซักครู่", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });

            }
          }
          else {
            //  this.CheckThisGoalError();
          }
        });
    }
    else {

    }


  }
  validatergisterForm = async (e, fname) => {
    e.preventDefault();
    const { phoneNumber, password, passwordcf, bankselect, accnumbertxt } = this.state;
    console.log(bankselect);
    console.log(this.state)
    if (accnumbertxt === "" || typeof accnumbertxt == "undefined") {
      var title = 'error'
      var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
      var object = { title, text }
      this.modalerror(object);

    }
    else if (fname === "") {

      var title = 'error'
      var text = 'คุณไม่ทำการใส่ ชื่อ-นามสกุล'
      var object = { title, text }
      this.modalerror(object);

    }
    else if (password.length > 15) {
      var title = 'error'
      var text = 'พาสเวิดสูงสุดไม่เกิน 15 ตัว'
      var object = { title, text }
      this.modalerror(object);
    }

    else {
      await instance.post("/api/v1/register", {
        User_id: phoneNumber,
        name: fname,
        password: password,
        accbank: bankselect,
        accno: accnumbertxt,
        System: Systems,
        Useradvise: this.state.userrecomend
      }).then(async (res) => {
        console.log(res.data);
        if (res.data.status === 200) {
          var title = 'success'
          var text = 'สมัครสำเร็จกำลังเปลี่ยนเส้นทาง'
          var object = { title, text }
          await this.modalerror(object);

          await instance.post("/api/v1/userlogin", {
            userid: phoneNumber,
            password: password,
            System: Systems,
            Function: 'validateLoginForm-navbar.js'
          }).then(async (res) => {
            if (res.data.status === 200) {
              await localStorage.setItem('auth_token', res.data.token);
              await this.rechecklogin(phoneNumber, res.data.token);
              this.setState({
                openRegister: false,
              });
              this.notify("success", 'คุณสมัครสำเร็จ');
              setInterval(() =>
                window.location.href = "/"
                , 2000);

            }
          });
        }
        else if (res.data.status === 203) {
          var title = 'error'
          var text = 'เลขบัญชี นี้ทำการสมัครไปแล้ว'
          var object = { title, text }
          this.modalerror(object);
        }
        else if (res.data.status === 202) {
          var title = 'error'
          var text = 'Username นี้ทำการสมัครไปแล้ว'
          var object = { title, text }
          this.modalerror(object);
        }
        else {
          var title = 'error'
          var text = 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง'
          var object = { title, text }
          this.modalerror(object);
        }
      });
    }


  };
  // แนะนำให้มี ref ใส่ที่ container: <div className="tabLists" ref={el => this.tabList = el}>
  // ต้องมี ref ที่ container: <div className="tabLists" ref={el => (this.tabList = el)}>
  // getInkLeft = (tabselect) => {
  //   const list = this.tabList || document.querySelector('.tabLists');
  //   if (!list) return 0;

  //   const tabs = Array.from(list.querySelectorAll('.tabPane_titleBox'));
  //   if (!tabs.length) return 0;

  //   const idx = Array.isArray(this.order) ? this.order.indexOf(tabselect) : -1;
  //   const el = tabs[idx >= 0 ? idx : 0];
  //   if (!el) return 0;

  //   // จุดกึ่งกลางของแท็บ (ไม่ต้องยุ่งกับ inkW แล้ว)
  //   return Math.round(el.offsetLeft + el.offsetWidth / 2);
  // };


  // repositionInkBarSafe = () => {
  //   const list = this.tabList;
  //   console.log("repositionInkBarSafe",list)
  //   if (!list) return;
  //   const ink = list.querySelector('.tabInk');
  //   if (!ink) return;

  //   const { tabselect } = this.state;
  //   const left = this.getInkLeft(tabselect);
  //   ink.style.left = `${left}px`;

  //   // ถ้าอยากให้ ink กว้างเท่ากับแท็บ:
  //   const el = list.querySelector(`.tabPane_titleBox[data-tab="${tabselect}"]`);
  //    if (el) ink.style.width = `${el.offsetWidth}px`;
  // };
  // ให้เริ่มที่ 32 เสมอถ้าคำนวณไม่ได้
  getInkLeft = (tabselect) => {
    const FALLBACK_LEFT = 32;

    const list = this.tabList || (this.tabListRef && this.tabListRef.current) || document.querySelector('.tabLists');
    if (!list) return FALLBACK_LEFT;

    const tabs = Array.from(list.querySelectorAll('.tabPane_titleBox'));
    if (!tabs.length) return FALLBACK_LEFT;

    // หา element ปัจจุบัน
    let el = list.querySelector(`.tabPane_titleBox[data-tab="${tabselect}"]`);
    if (!el) {
      const idx = Array.isArray(this.tabOrder) ? this.tabOrder.indexOf(tabselect) : -1;
      el = (idx >= 0 && tabs[idx]) ? tabs[idx] : tabs[0];
    }
    if (!el) return FALLBACK_LEFT;

    const w = el.offsetWidth;
    const x = el.offsetLeft;

    // ถ้ายังวัดไม่ได้ (เช่น display:none หรือ layout ยังไม่มา) → เริ่มที่ 32
    if (!w && !x) return FALLBACK_LEFT;

    // คิดจาก “กึ่งกลางแท็บ” (ใช้ร่วมกับ .tabInk { transform: translateX(-50%); })
    return Math.round(x + w / 2);
  };

  getTabIndex(tabselect) {
    // ลำดับ DOM ของ panes — ถ้าจริงไม่ตรง ให้แก้ array นี้ให้ตรง
    const idx = this.order.indexOf(tabselect);
    return idx === -1 ? 0 : idx;
  }

  // เรียกทุกครั้งหลัง setState เปลี่ยนแท็บ
  repositionInkBarSafe = (retry = 2) => {
    const list = this.tabList || document.querySelector('.tabLists');
    if (!list) return;

    const ink = list.querySelector('.tabInk');
    if (!ink) return;

    // ตั้งค่าเริ่มต้นกันกระตุก
    if (!ink.style.width) ink.style.width = '32px';

    const left = this.getInkLeft(this.state.tabselect);
    ink.style.left = `${left}px`; // ถ้าวัดไม่ได้จะเป็น 32

    // ถ้าได้ 32 (fallback) และยังเหลือสิทธิ์ retry → ลองใหม่ในเฟรมถัดไป
    if (left === 32 && retry > 0) {
      requestAnimationFrame(() => this.repositionInkBarSafe(retry - 1));
    }
  };

  handleBankChange = (e) => {
    const raw = e.target.value;
    const val = String(raw); // ป้องกัน type mismatch
    console.log('[handleBankChange] selected raw:', raw, 'asString:', val);

    // อัปเดต state ก่อน (เรียก radiocheck หลังจาก state แน่นอนอัปเดตแล้ว)
    this.setState({ bankselect: val }, () => {
      console.log('[handleBankChange] state.bankselect after setState:', this.state.bankselect);
      // เรียกฟังก์ชันเดิม (ถ้าจำเป็น) — ส่งค่าใหม่ตรง ๆ
      if (typeof this.radiocheck === 'function') {
        try {
          this.radiocheck(val);
        } catch (err) {
          console.error('radiocheck error:', err);
        }
      }
    });
  }


  changepass = (e) => {
    e.preventDefault();
    this.setState({
      showpass: this.state.showpass ? false : true,
    });
  }

  radiocheck(input) {
    console.log(input);
    this.setState({
      bankselect: input
    });
    if (input == 99) {
      this.setState({
        trueaccount: false
      });
    }
    else {
      this.setState({
        trueaccount: true,
        fname: ""
      });
    }
  }

  nextstep = async (e, num) => {
    e.preventDefault();
    const { stateregis, password, bankselect, passwordcf, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state
    console.log(num, stateregis, phoneNumber, password, passwordcf, bankselect, checkboxacc, fname, otpphone, accnumbertxt, "register");
    if (num === 1) {
      if (phoneNumber.length === 10) {
        const check = await this.forgetotpandregister(11);
        console.log("check", check);
        if (phoneNumber.length === 10 && check.checked) {
          if (check.otpsent.status === true) {

            if (!check.otpsent.otpcheck) {
              await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
            }
            else {
              this.setState({
                stateregis: 5
              });
            }
          }
          else {
            this.setState({
              stateregis: 2
            });
          }
        }
        else {
          if (phoneNumber.length !== 10) {
            await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
          }
          else if (!check.checked && check.status === 201) {
            await this.notify("warning", 'เบอร์นี้มีคนใช้แล้ว');
          }
          else {
            await this.notify("warning", 'คุณทำรายการถี่เกินไป โปรด 1 นาทีทำรายการใหม่');
          }
        }
      }
      else {
        await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
      }
    }
    else if (num === 2) {

      if (password !== passwordcf) {
        await this.notify("warning", 'คุณไส่พาสเวิดไม่ตรงกัน');
      }
      else {
        this.setState({
          stateregis: 3
        });
      }

    }
    else if (num === 3) {
      if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
        this.setState({
          stateregis: 3
        });
      }
      else {
        await this.notify("warning", 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน');
        //////console.log(2, stateregis, checkboxacc);
      }
    }
    else if (num === 5) {
      var check = await this.forgetotpandregister(12);
      if (otpphone !== "" && check.checked) {
        this.setState({
          stateregis: 2
        });
      }
      else if (otpphone === "" || otpphone.length < 4) {
        await this.notify("warning", 'คุณใส่ตัวเลขไม่ครบ');
        document.getElementById("otpphone").style = "border-color: #ef4444;";
        document.getElementById("checkotp").style.display = "block";
      }

      else {
        await this.notify("warning", 'รหัสผิดพลาด');
        document.getElementById("otpphone").style = "border-color: #ef4444;";
        document.getElementById("checkotp").style.display = "block";
      }



    }
    else if (num === 11) {

      console.log(1, stateregis, num);

      this.setState({
        stateregis: 1
      });
    }
    else if (num === 22) {
      //////console.log(1, stateregis, num);
      this.setState({
        stateregis: 2
      });
    }
    else if (num === 25) {
      if (accnumbertxt === "" || typeof accnumbertxt == "undefined") {
        var title = 'error'
        var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
        var object = { title, text }
        this.modalerror(object);

      }
      else if (accnumbertxt.length < 10) {
        var title = 'error'
        var text = 'คุณยังไม่ได้เลือกธนาคาร'
        var object = { title, text }
        this.modalerror(object);
      }
      else if (bankselect === 0) {
        var title = 'error'
        var text = 'คุณยังไม่ได้เลือกธนาคาร'
        var object = { title, text }
        this.modalerror(object);
      }
      else {
        this.setState({
          loading: true,
        });
        if (fname === '') {
          let check = await this.forgetotpandregister(10)
          if (check.checked) {
            console.log(302, check.verifications);
            console.log(302, check.verifications.name);
            if (check.verifications.status == 0) {
              this.setState({
                trueaccount: false,
              });
            }
            else if (check.verifications.status == 1) {
              this.setState({
                fname: check.verifications.name,
              });
              await this.validatergisterForm(e, check.verifications.name);
            }
          }
          else {
            var title = 'error'
            var text = 'เลขบัญชีไม่ถูกต้อง'
            var object = { title, text }
            this.modalerror(object);
          }
        }
        else {
          await this.validatergisterForm(e, fname)
        }
        this.setState({
          loading: false,
        });
        //console.log(302, check.verifications);
      }


    }
  };

  forgetotpandregister = async (type) => {
    const { phoneNumber, otpphoneforget, bankselect, otpphone, accnumbertxt } = this.state;
    var recheck = false;
    if (type === 4) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;
      });
    }
    else if (type === 5) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        pin: otpphoneforget,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;

      });
    }
    else if (type === 6 || type === 11) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;
      });
    }
    else if (type === 7 || type === 12) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        pin: otpphone,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;

      });
    }
    else if (type === 10) {
      return await instance.post("/api/v1/resetpassword", {
        accountnumber: accnumbertxt,
        bankid: bankselect,
        System: Systems,
        type: type
      }).then(async (res) => {
        return recheck = res.data.message;

      });
    }

    return recheck
  }

  onChangex = event => {
    console.log("event", event.target);


    if (event.target !== undefined) {
      let nam;
      let val;

      if (event.target.name === undefined) {
        nam = event.name;
        val = event.value;
      } else {
        nam = event.target.name;
        val = event.target.value;
      }
      this.setState({ [nam]: val });
    }
  };

  login = (e) => {
    e.preventDefault();
    let errors = this.validateLoginForm();
  }
  submitwithdraw = async (e) => {
    //////console.log(this.state.withdrawamount, this.state.balance);
    if (parseFloat(this.state.withdrawamount) <= parseFloat(this.state.balance)) {
      if (parseFloat(this.state.withdrawamount) >= 10) {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
          var decoded = jwt_decode(token);
          var Username = decoded.message.playerid;
          await instance.post("/api/v1/userwithdraw", {
            User_id: Username,
            System: Systems,
            amount: this.state.withdrawamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              await toast.success(
                <div>
                  <strong>Success!</strong>
                  <div style={{ marginTop: 6 }}>รายการถอนเรียบร้อย</div>
                </div>,
                {
                  position: 'top-right',
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: 'colored'
                }
              );
              window.location.href = "/";
            }
            else if (res.data.status === 203) {
              await toast.error(
                <div>
                  <strong>error!</strong>
                  <div style={{ marginTop: 6 }}>
                    ท่านติด Turnover อีก {res.data?.amountturnover ?? 0} บาท
                  </div>

                </div>,
                {
                  position: 'top-center',    // หรือ 'top-right' ตามชอบ
                  autoClose: 5000,           // ปิดเองหลัง 5 วินาที
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: 'colored',
                }
              );
            }
          });
        }
        else {
          toast.error(
            <div>
              <strong>error!</strong>
              <div style={{ marginTop: 6 }}>รายการถอนมีปัญหา โปรดติดต่อพนักงาน</div>
            </div>,
            {
              position: 'top-center',    // หรือ 'top-right' ตามชอบ
              autoClose: 5000,           // ปิดเองหลัง 5 วินาที
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: 'colored',
            }
          );
        }
      }
      else {
        toast.error(
          <div>
            <strong>error!</strong>
            <div style={{ marginTop: 6 }}>ขั้นต่ำในการถอน 50 บาท</div>
          </div>,
          {
            position: 'top-center',    // หรือ 'top-right' ตามชอบ
            autoClose: 5000,           // ปิดเองหลัง 5 วินาที
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: 'colored',
          }
        );
      }
    }
    else {
      toast.error(
        <div>
          <strong>error!</strong>
          <div style={{ marginTop: 6 }}>ยอดถอนของท่านไม่เพียงพอในการถอน</div>
        </div>,
        {
          position: 'top-center',    // หรือ 'top-right' ตามชอบ
          autoClose: 5000,           // ปิดเองหลัง 5 วินาที
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'colored',
        }
      );
    }

  }
  onChangeWithdraw = async (event) => {
    console.log(event);
    if (event.target !== undefined) {
      let nam;
      let val;
      if (event.target.name === undefined) {
        nam = event.name;
        val = event.value;
      } else {
        nam = event.target.name;
        val = event.target.value;
      }
      this.setState({ keywithdraw: "" });
      if (nam === "withdrawamount") {
        if (this.state.maxwithdrawstatus === 1) {
          this.setState({ [nam]: "", keywithdraw: 1 });

        }
        else if (Number(val) <= Number(this.state.balance)) {
          this.setState({ [nam]: val });
        }
        else {
          this.setState({ [nam]: "", keywithdraw: 2 });

        }
      } else {
        this.setState({ [nam]: val });
      }

    }
  };
  onChange = async (event) => {
    console.log(1163, event);
    if (event.target !== undefined) {
      let nam;
      let val;
      if (event.target.name === undefined) {
        nam = event.name;
        val = event.value;
      } else {
        nam = event.target.name;
        val = event.target.value;
      }
      if (nam === "withdrawamount") {
        const amount = parseFloat(this.state.balance); // แปลงเป็นตัวเลข
        const accnumber = this.state.accnumber;
        if (accnumber && accnumber[0] === 99) {
          // ดักว่า "ต้องไม่มีเศษ" → จำนวนต้องหาร 100 ลงตัว
          if (amount % 100 !== 0) {
            await this.notify("warning", 'ท่านไช้ True Wallet ต้องถอนจำนวนเต็ม 100, 200 ห้ามมีเศษสตางค์');
            return; // ❌ หยุด ไม่ให้ไปต่อ
          }
          // ✅ ผ่านเงื่อนไข → อัปเดต state
          this.setState({ [nam]: amount });
        }
        else if (this.state.maxwithdrawstatus === 1) {
          this.setState({ [nam]: this.state.balance });
          await this.notify("warning", 'บังคับถอนยอดทั้งหมด');
        }
        else if (Number(val) <= Number(this.state.balance)) {
          this.setState({ [nam]: val });
        }
        else {
          await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');

        }
      } else {
        this.setState({ [nam]: val });
      }
      if (nam === "txtsech" || nam === "txtsech2") {
        const tabselect = this.state.tabselect
        let list = []
        let step = 1
        if (this.state.filterlist.length == 0) {
          if (tabselect == 16 || tabselect == 20) {
            list = this.state.listitallgame
            step = 1
          }
          else if (tabselect == 13) {
            list = this.state.slotlist
            step = 2
          }
          else if (tabselect == 10) {
            list = this.state.categorylist
            step = 3
          }
          else if (tabselect == 14) {
            list = this.state.sportlist
            step = 4
          }
          else if (tabselect == 12) {
            list = this.state.fishinglist
            step = 5
          }
          else if (tabselect == 11) {
            list = this.state.gamehitlist
            step = 6
          }
          else if (tabselect == 18) {
            list = this.state.providorlist
            step = 7
          }
          this.setState({ filterlist: list });
        }
        else {
          list = this.state.filterlist
        }
        let retailArrays = [];
        list.forEach(
          array => {
            console.log(1231, tabselect, step, array)
            if (tabselect == 18 || tabselect == 10 || tabselect == 14) {
              if (array.providername.toLowerCase().includes(val.toLowerCase())) {
                retailArrays.push(array);
              };
            }
            else {
              if (array.description.toLowerCase().includes(val.toLowerCase())) {
                retailArrays.push(array);
              };
            }
          }
        )
        if (step == 1) this.setState({ listitallgame: retailArrays });
        else if (step == 2) this.setState({ slotlist: retailArrays });
        else if (step == 3) this.setState({ categorylist: retailArrays });
        else if (step == 4) this.setState({ sportlist: retailArrays });
        else if (step == 5) this.setState({ fishinglist: retailArrays });
        else if (step == 6) this.setState({ gamehitlist: retailArrays });
        else if (step == 7) this.setState({ providorlist: retailArrays });
      }

    }
  };

  modalRef = createRef();
  mask = null;
  wrap = null;
  // ===== Refs & scroll state =====
  topbarRef = React.createRef();        // <header ...> สำหรับใส่/ถอด zoom-out
  headerWrapRef = React.createRef();    // .common-distance-wrap (ตัวครอบ)
  headerRef = React.createRef();       // .tlc-sign-header (ตัวเนื้อหา)
  lastY = 0;

  componentDidUpdate(prevProps, prevState) {
    if (prevState.openLogin !== this.state.openLogin || prevState.openRegister !== this.state.openRegister) {
      this.updateInkBar();
    }
    if (prevState.tabselectsec !== this.state.tabselectsec && this.state.tabselectsec === 22) {
      this.startLocalBankCountdown(10);
    }
  }
  // ที่ระดับ class (property)
  // วางทับฟังก์ชัน getgame ของคุณ
  // keep your initial fields
  // แทนที่ฟังก์ชันเดิมด้วยอันนี้
  _gameCache = new Map();   // key -> { t, data, raw }
  _gameReqSeq = 0;          // ป้องกัน stale response (race condition)

  async getgamex(typepage, partner, state = "991", checked = false) {
    // normalize partner
    const partnerKey =
      partner === null || partner === undefined
        ? ""
        : (typeof partner === "object" ? (partner.id ?? partner.name ?? JSON.stringify(partner)) : String(partner));

    const key = `${typepage}|${partnerKey}|${state}|${checked ? 1 : 0}`;
    const now = Date.now();
    const TTL = 5 * 60 * 1000; // 5 นาที

    console.log('[getgame] key=', key, checked);

    if (!checked) {
      // 1) in-memory cache
      const cached = this._gameCache.get(key);
      if (cached && Number.isFinite(cached.t) && (now - cached.t) < TTL) {
        console.log('[getgame] cache hit (memory)', key);
        const { listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist } = cached.data || {};
        // restore ALL lists that we care about
        this.setState({ listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist });
        return cached.raw ?? { message: cached.data };
      }

      // 1b) sessionStorage fallback
      try {
        const raw = sessionStorage.getItem(`_gameCache:${key}`);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed?.t && (now - parsed.t) < TTL) {
            console.log('[getgame] cache hit (sessionStorage)', key);
            // promote to memory cache
            this._gameCache.set(key, parsed);
            const { listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist } = parsed.data || {};
            this.setState({ listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist });
            return parsed.raw ?? { message: parsed.data };
          } else {
            try { sessionStorage.removeItem(`_gameCache:${key}`); } catch (e) { /* ignore */ }
          }
        }
      } catch (e) {
        console.warn('[getgame] sessionStorage parse error', e);
      }
    }
    // 2) prevent race
    const reqId = ++this._gameReqSeq;

    try {
      const { data } = await instance.post("/api/v1/tabgamelist", {
        state,
        System: Systems,
        partner,
        game: typepage,
      });

      if (reqId !== this._gameReqSeq) {
        console.log('[getgame] stale response dropped', key);
        return;
      }

      if (!data || data?.status !== 200) {
        throw new Error(data?.message || "Bad status from /tabgamelist");
      }

      // Normalize structure
      const msg = Array.isArray(data.message) ? data.message : [];
      const first = msg[0] || {};
      const firstList = Array.isArray(first.list) ? first.list : [];
      const pglist = Array.isArray(first.hitlistpg) ? first.hitlistpg : [];
      const newlist = Array.isArray(first.newlist) ? first.newlist : [];
      const randomlistx = Array.isArray(first.randomlist) ? first.randomlist : [];

      console.log('[getgame] msg length=', msg);

      const listitallgame = msg;
      const providorlist = checked ? msg : firstList;
      const gamehitpglist = checked ? msg : pglist;
      const gamenewlist = checked ? msg : newlist;
      const randomlist = checked ? msg : randomlistx;

      // update state with ALL lists
      this.setState({ listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist, typepage });

      // cache object: store ALL data you will need on restore (INCLUDE randomlist)
      const cacheObj = {
        t: now,
        data: { listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist },
        raw: data
      };

      // store in-memory
      try {
        this._gameCache.set(key, cacheObj);
      } catch (e) { console.warn('[getgame] memory cache set failed', e); }

      // persist to sessionStorage (best-effort)
      try {
        sessionStorage.setItem(`_gameCache:${key}`, JSON.stringify(cacheObj));
        console.log('[getgame] sessionStorage saved', key);
      } catch (e) {
        console.warn('[getgame] sessionStorage set failed', e);
      }

      console.log('[getgame] fetched & cached', key);
      return data;
    } catch (err) {
      console.error("getgame error:", err);
      return null;
    }
  }

  async getgame(typepage, partner, state = "991", checked = false) {
    // normalize partner
    const partnerKey =
      partner === null || partner === undefined
        ? ""
        : (typeof partner === "object" ? (partner.id ?? partner.name ?? JSON.stringify(partner)) : String(partner));

    const key = `${typepage}|${partnerKey}|${state}|${checked ? 1 : 0}`;
    const now = Date.now();
    const TTL = 5 * 60 * 1000; // 5 นาที

    console.log('[getgame] ENTER', { typepage, partnerKey, state, checked, key });

    // If checked true, skip cache read path (you intentionally did that)
    if (!checked) {
      // 1) in-memory cache
      const cached = this._gameCache.get(key);
      console.log('[getgame] check memory cache ->', !!cached);
      if (cached && Number.isFinite(cached.t) && (now - cached.t) < TTL) {
        console.log('[getgame] cache hit (memory)', { key, ageMs: now - cached.t });
        const { listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist } = cached.data || {};
        this.setState({ listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist });
        return cached.raw ?? { message: cached.data };
      } else {
        if (cached) {
          console.log('[getgame] memory cache expired or invalid', { key, cachedT: cached.t, ageMs: now - (cached?.t || 0) });
        } else {
          console.log('[getgame] memory cache miss', key);
        }
      }

      // 1b) sessionStorage fallback
      try {
        const raw = sessionStorage.getItem(`_gameCache:${key}`);
        console.log('[getgame] sessionStorage raw?', !!raw);
        if (raw) {
          let parsed;
          try {
            parsed = JSON.parse(raw);
          } catch (e) {
            console.warn('[getgame] sessionStorage JSON parse failed', e);
            // remove broken entry
            try { sessionStorage.removeItem(`_gameCache:${key}`); } catch (e2) {/*ignore*/ }
          }
          if (parsed) {
            if (parsed?.t && (now - parsed.t) < TTL) {
              console.log('[getgame] cache hit (sessionStorage)', { key, ageMs: now - parsed.t });
              this._gameCache.set(key, parsed); // promote to memory
              const { listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist } = parsed.data || {};
              this.setState({ listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist });
              return parsed.raw ?? { message: parsed.data };
            } else {
              console.log('[getgame] sessionStorage expired', { key, parsedT: parsed.t, ageMs: now - (parsed?.t || 0) });
              try { sessionStorage.removeItem(`_gameCache:${key}`); } catch (e) { /* ignore */ }
            }
          }
        }
      } catch (e) {
        console.warn('[getgame] sessionStorage error', e);
      }
    } else {
      console.log('[getgame] checked === true -> skipping cache read');
    }

    // 2) prevent race
    const reqId = ++this._gameReqSeq;
    console.log('[getgame] sending request', { reqId, key });

    try {
      const { data } = await instance.post("/api/v1/tabgamelist", {
        state,
        System: Systems,
        partner,
        game: typepage,
      });

      console.log('[getgame] response received', { reqId, currentSeq: this._gameReqSeq, dataStatus: data?.status });

      if (reqId !== this._gameReqSeq) {
        console.log('[getgame] stale response dropped', { reqId, currentSeq: this._gameReqSeq, key });
        return;
      }

      if (!data || data?.status !== 200) {
        console.error('[getgame] bad status from API', { status: data?.status, message: data?.message });
        throw new Error(data?.message || "Bad status from /tabgamelist");
      }

      // Normalize structure
      const msg = Array.isArray(data.message) ? data.message : [];
      const first = msg[0] || {};
      const firstList = Array.isArray(first.list) ? first.list : [];
      const pglist = Array.isArray(first.hitlistpg) ? first.hitlistpg : [];
      const newlist = Array.isArray(first.newlist) ? first.newlist : [];
      const randomlistx = Array.isArray(first.randomlist) ? first.randomlist : [];

      console.log('[getgame] normalized lists lengths', {
        msgLen: msg.length,
        firstListLen: firstList.length,
        pglistLen: pglist.length,
        newlistLen: newlist.length,
        randomlistLen: randomlistx.length
      });

      const listitallgame = msg;
      const providorlist = checked ? msg : firstList;
      const gamehitpglist = checked ? msg : pglist;
      const gamenewlist = checked ? msg : newlist;
      const randomlist = checked ? msg : randomlistx;

      // update state with ALL lists
      this.setState({ listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist, typepage });

      // cache object: store ALL data (INCLUDE randomlist)
      const cacheObj = {
        t: now,
        data: { listitallgame, providorlist, gamehitpglist, gamenewlist, randomlist },
        raw: data
      };

      // store in-memory
      try {
        this._gameCache.set(key, cacheObj);
        console.log('[getgame] memory cache set', key);
      } catch (e) {
        console.warn('[getgame] memory cache set failed', e);
      }

      // persist to sessionStorage (best-effort)
      try {
        sessionStorage.setItem(`_gameCache:${key}`, JSON.stringify(cacheObj));
        console.log('[getgame] sessionStorage saved', key);
      } catch (e) {
        console.warn('[getgame] sessionStorage set failed', e);
      }

      console.log('[getgame] fetched & cached', key);
      return data;
    } catch (err) {
      console.error("[getgame] ERROR", err);
      return null;
    }
  }

  async calllisthistory(userid) {
    console.log("withdrawlist", userid)
    await instance.post("/api/v1/userwithdrawlist", {
      userid: userid,
      Cat_ID: 0,
      System: Systems,
      page: 1,
      type: 1
    }).then((res) => {
      if (res.data.status === 200) {
        const datas = res.data.message;
        console.log("withdrawlist", datas.withdrawlist);
        this.setState({
          historylist: datas.withdrawlist
        });

      }
      else {
        // this.CheckThisGoalError();
      }
    });

  }
  // navigateTo = async (path, { selection = 1 } = {}) => {
  //   NProgress.start();
  //   this.setState({
  //     loading: true,
  //   });
  //   console.log("navigateTo:", path, selection);

  //   // reset UI
  //   this.prev = document.body.style.backgroundColor;
  //   document.body.style.backgroundColor = '#EFEFF4';
  //   this.setState({ modalx: false, modal: false, listitallgame: [] });

  //   // --- normalize path + split
  //   // --- normalize path (ตัด # และ ? ออกก่อน) + split
  //   const raw = (path || "/").replace(/^#/, "");     // กัน HashRouter ที่ส่ง "#/..."
  //   const clean = raw.replace(/[?#].*$/, "");        // << ตัด query/hash ออกให้หมด
  //   const parts = clean.replace(/^\/+|\/+$/g, "").split("/");

  //   // log debug แบบอ่านง่าย
  //   const seg1 = decodeURIComponent(parts[0] || "");
  //   const seg2 = decodeURIComponent(parts[1] || "");
  //   const seg3 = decodeURIComponent(parts[2] || "");
  //   console.log("segs(raw):", { seg1, seg2, seg3 });

  //   // ฐาน route: รองรับ prefix /mobile/*
  //   const base = parts[0] === "mobile" ? 1 : 0;
  //   const segA = decodeURIComponent(parts[base] || ""); // route หลัก
  //   const segB = decodeURIComponent(parts[base + 1] || ""); // sub-route/พารามิเตอร์
  //   const segC = decodeURIComponent(parts[base + 2] || ""); // พารามิเตอร์ถัดไป
  //   const segD = decodeURIComponent(parts[base + 3] || "");
  //   console.log("segs(normalized):", { segA, segB, segC, segD });

  //   // ===== key ที่ใช้ map route (ยึด normalized เสมอ) =====



  //   // ====== (1) dynamic listgameall (รองรับทั้ง /listgameall/* และ /mobile/listgameall/*) ======
  //   if (segA === "listgameall") {
  //     const type = segB;      // slot / casino / sport / fishing / lotto ...
  //     const partner = segC;   // เช่น 'WAZDAN'
  //     if (type && partner) {
  //       console.log("listgameall dynamic →", type, partner);

  //       // ถ้าต้องการส่ง code ตาม type:
  //       // const codeByType = { slot: "995", casino: "993", sport: "996", fishing: "995", lotto: "lotto" };
  //       // await this.getgame(type, partner, codeByType[type]);

  //       await this.getgame(type, partner, "991", true);           // ของเดิมคุณใช้ getgame(seg2, seg3)
  //       this.setState({ tabselect: 15, partner });   // เปิดแท็บ listgameall
  //       NProgress.done();
  //       window.scrollTo(0, 0);
  //       return;
  //     } else {
  //       this.setState({ tabselect: 0 });
  //       NProgress.done();
  //       window.scrollTo(0, 0);
  //       return;
  //     }
  //   }

  //   // ====== (2) route map ปกติ ======
  //   // key ใหม่: ตัด mobile ออกก่อนประกอบ
  //   let key;
  //   // กรณี root: "/" หรือ "/mobile"
  //   if (!parts[0] || (parts[0] === "mobile" && !segA)) {
  //     key = parts[0] === "mobile" ? "mobile" : "";
  //   } else {
  //     key = [segA, segB].filter(Boolean).join("/");
  //   }

  //   const requireLogin = async (okTab) => {
  //     if (this.state.loginstate) { this.setState({ tabselect: okTab }); return true; }
  //     this.setState({ tabselect: 0 });
  //     console.log("keykey", false)
  //     return false;
  //   };

  //   const afterSetState = () => requestAnimationFrame(() => this.repositionInkBarSafe());
  //   console.log("keykey", key)
  //   // ใช้ segC (normalized) เป็นพารามิเตอร์ที่ 2 ของ getgame แทน seg3 เดิม
  //   const routeHandlers = {
  //     // "": async () => this.setState({ tabselect: 0 }, afterSetState),
  //     "": async () => {
  //       await this.getgame('sport', segC, "996");
  //       this.setState(
  //         { openLogin: false, openRegister: false, openDeposit: false, openWithdraw: false, tabselectsec: 0, tabselect: 14 },
  //         afterSetState
  //       );
  //     },
  //     "mobile": async () => {
  //       await this.getgame('sport', segC, "996");
  //       this.setState(
  //         { openLogin: false, openRegister: false, openDeposit: false, openWithdraw: false, tabselectsec: 0, tabselect: 14 },
  //         afterSetState
  //       );
  //     },


  //     "game/casino": async () => {
  //       await this.getgame('casino', segC, "993");
  //       this.setState({ tabselect: 101 }, afterSetState);
  //     },

  //     "game/hit": async () => {
  //       await this.getgame('slot', segC, "992");
  //       await this.getprovidor('slot', segC, "2255");
  //       this.setState({ tabselect: 111 }, afterSetState); // ⚠️ ต้องมีแท็บ id=11
  //     },
  //     "game/fishing": async () => {
  //       await this.getgame('fishing', segC, "995");
  //       this.setState({ tabselect: 121 }, afterSetState);
  //     },
  //     "game/slot": async () => {
  //       await this.getgame('slot', segC, "995");
  //       this.setState({ tabselect: 131 }, afterSetState);
  //     },
  //     "game/export": async () => {
  //       await this.getgame('export', segC, "11131");
  //       this.setState({ tabselect: 511 }, afterSetState);
  //     },
  //     "game/sport": async () => {
  //       await this.getgame('sport', segC, "996");
  //       this.setState({ tabselect: 141 }, afterSetState);
  //     },
  //     "game/lotto": async () => {
  //       await this.getgame('lotto', segC, "lotto", true);
  //       this.timerx = setInterval(() => {
  //         this.setState({ currentTime: new Date().getTime() });
  //       }, 1000);
  //       this.setState({ tabselect: 171 }, afterSetState);
  //     },



  //     "casinox": async () => {
  //       await this.getgame('casino', segC, "993");
  //       this.setState({ tabselect: 10, typepage: "casino" }, afterSetState);
  //     },

  //     "game/hit": async () => {
  //       await this.getgame('slot', segC, "992");
  //       await this.getprovidor('slot', segC, "2255");
  //       this.setState({ tabselect: 11, typepage: "hit" }, afterSetState); // ⚠️ ต้องมีแท็บ id=11
  //     },

  //     "game/providor": async () => {
  //       await this.getgame('casino', segC, "994");
  //       this.setState({ tabselect: 18, typepage: "providor" }, afterSetState); // ⚠️ ต้องมีแท็บ id=18
  //     },

  //     "fishingx": async () => {
  //       await this.getgame('fishing', segC, "995");
  //       this.setState({ tabselect: 12, typepage: "fishing" }, afterSetState);
  //     },

  //     "usdtinfo": async () => {
  //       this.setState({ tabselect: 98 }, afterSetState);
  //     },


  //     "slotx": async () => {
  //       await this.getgame('slot', segC, "995");
  //       this.setState({ tabselect: 13, typepage: "slot" }, afterSetState);
  //     },

  //     "exportx": async () => {
  //       await this.getgame('export', segC, "11131");
  //       this.setState({ tabselect: 51, typepage: "esport" }, afterSetState);
  //     },

  //     "sportx": async () => {
  //       await this.getgame('sport', segC, "996");
  //       this.setState({ tabselect: 14, typepage: "sport" }, afterSetState);
  //     },

  //     "bettingrecord": async () => {
  //       this.setState({ tabselect: 97 }, afterSetState);
  //     },

  //     "game/list": async () => {
  //       await this.getgame('slot', segC);
  //       this.setState({ tabselect: 20, partner: segC }, afterSetState); // ⚠️ ต้องมีแท็บ id=20
  //     },

  //     "lottox": async () => {
  //       await this.getgame('lotto', segC, "lotto");
  //       this.timerx = setInterval(() => {
  //         this.setState({ currentTime: new Date().getTime() });
  //       }, 1000);
  //       this.setState({ tabselect: 17 }, afterSetState);
  //     },

  //     "loss": async () => this.setState({ tabselect: 25 }),
  //     "manager/ranking": async () => this.setState({ tabselect: 27 }),
  //     "minigame/luckywheel": async () => this.setState({ tabselect: 28 }),
  //     "event": async () => this.setState({ tabselect: 16 }),

  //     "manager/withdraw": async () => requireLogin(2),
  //     "manager/deposit": async () => requireLogin(1),
  //     "manager/statement": async () => requireLogin(3),

  //     "userinfo": async () => {
  //       if (
  //         await requireLogin(8))
  //         this.setState({ tabselect: 8, tabselection: selection })
  //       if (selection == 5) {
  //         const token = localStorage.getItem('auth_token');
  //         if (token) {
  //           try {
  //             const decoded = jwt_decode(token);
  //             const Username = decoded.message.playerid;
  //             await this.calllisthistory(Username);
  //           }
  //           catch (ex) {

  //           }
  //         }
  //       }


  //     },
  //     "register": async () => this.setState({ tabselect: 22 }),
  //     "signin": async () => this.setState({ tabselect: 23 }),

  //     "overview": async () => this.setState({ tabselect: 4, refer: 1 }),
  //     "refer/member": async () => this.setState({ tabselect: 4, refer: 2 }),
  //     "refer/income-summary": async () => this.setState({ tabselect: 4, refer: 3 }),
  //     "refer/share-network": async () => this.setState({ tabselect: 4, refer: 4 }),

  //     "rebate": async () => this.setState({ tabselect: 5 }),
  //     "promotion": async () => this.setState({ tabselect: 7, tabselection: selection }),

  //     "rewardscentre": async () => { window.history.pushState(null, '', "/"); this.setState({ modalmaintain: true }) },
  //     "manager/diamondclub": async () => {
  //       this.setState({ tabselect: 99 });
  //       this.prev = document.body.style.backgroundColor;
  //       document.body.style.backgroundColor = '#17191c';
  //     },
  //   };

  //   try {
  //     if (routeHandlers[key]) {
  //       await routeHandlers[key]();
  //     } else {
  //       this.setState({ tabselect: 0 });
  //     }
  //   } finally {
  //     this.setState({
  //       loading: false,
  //     });
  //     NProgress.done();
  //     window.scrollTo(0, 0);
  //   }
  // };

  navigateTo = async (path, { selection = 1, headerOffset = 64, scrollTimeoutMs = 4000 } = {}) => {
    NProgress.start();
    // start loading
    try { this.setState({ loading: true, listitallgame: [], providorlist: [] }); } catch (e) { console.warn('setState loading true failed', e); }

    console.log("navigateTo:", path, selection);

    // reset UI
    this.prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#EFEFF4';
    try { this.setState({ modalx: false, modal: false, listitallgame: [] }); } catch (e) { }

    // normalize path (trim hash/query and leading/trailing slashes)
    const raw = (path || "/").replace(/^#/, "");
    const clean = raw.replace(/[?#].*$/, "");
    const parts = clean.replace(/^\/+|\/+$/g, "").split("/");

    // debug segments (raw)
    const seg1 = decodeURIComponent(parts[0] || "");
    const seg2 = decodeURIComponent(parts[1] || "");
    const seg3 = decodeURIComponent(parts[2] || "");
    console.log("segs(raw):", { seg1, seg2, seg3 });

    // normalized base for mobile prefix
    const base = parts[0] === "mobile" ? 1 : 0;
    const segA = decodeURIComponent(parts[base] || "");
    const segB = decodeURIComponent(parts[base + 1] || "");
    const segC = decodeURIComponent(parts[base + 2] || "");
    const segD = decodeURIComponent(parts[base + 3] || "");
    console.log("segs(normalized):", { segA, segB, segC, segD });

    // ----- Special-case: /listgameall/<type>/<partner> (and /mobile/listgameall/...) -----
    if (segA === "listgameall") {
      const type = segB;      // e.g. 'casino' 'slot' 'sport' ...
      const partner = segC;   // e.g. 'SEXY'
      if (type && partner) {
        console.log("listgameall dynamic →", type, partner);
        try {
          // call getgame with parameters — adjust the 3rd/4th args to match your backend if needed
          // previous code used getgame(type, partner, "991", true) — keep that unless you need a different code
          await this.getgame(type, partner, "991", true);
          // set tabselect to the listgameall tab (15 from your original)
          this.setState({ tabselect: 15, partner }, () => {
            // reposition ink bar after state update
            requestAnimationFrame(() => this.repositionInkBarSafe());
          });

          // give React a tick to render the tab content, then scroll (deterministicScrollToTab if available)
          await new Promise((resolve) => requestAnimationFrame(() => resolve()));

          // try deterministic scroll to ensure top-tab-15 visible (if you have the helper)
          const finalSelection = 15;
          if (typeof this.deterministicScrollToTab === 'function') {
            try {
              await this.deterministicScrollToTab(finalSelection, { headerOffset, timeoutMs: scrollTimeoutMs, pollInterval: 60, maxTries: 8 });
            } catch (err) {
              console.warn('[navigateTo] deterministicScrollToTab for listgameall threw', err);
              window.scrollTo(0, 0);
            }
          } else {
            window.scrollTo(0, 0);
          }

        } catch (err) {
          console.error('[navigateTo] listgameall getgame error', err);
          // fallback: show root tab
          this.setState({ tabselect: 0 });
          window.scrollTo(0, 0);
        } finally {
          NProgress.done();
          try { this.setState({ loading: false }); } catch (e) { }
        }
        return;
      } else {
        // incomplete path -> fallback to root
        this.setState({ tabselect: 0 });
        NProgress.done();
        try { this.setState({ loading: false }); } catch (e) { }
        window.scrollTo(0, 0);
        return;
      }
    }

    // build key for normal routes (normalized segA/segB)
    let key;
    if (!parts[0] || (parts[0] === "mobile" && !segA)) {
      key = parts[0] === "mobile" ? "mobile" : "";
    } else {
      key = [segA, segB].filter(Boolean).join("/");
    }

    const requireLogin = async (okTab) => {
      if (this.state.loginstate) { this.setState({ tabselect: okTab }); return true; }
      this.setState({ tabselect: 0 });
      console.log("keykey", false);
      return false;
    };

    const afterSetState = () => requestAnimationFrame(() => this.repositionInkBarSafe());
    console.log("keykey", key);

    const routeHandlers = {
      "": async () => {
        await this.getgame('sport', segC, "996");
        this.setState(
          { openLogin: false, openRegister: false, openDeposit: false, openWithdraw: false, tabselectsec: 0, tabselect: 14 },
          afterSetState
        );
      },
      "mobile": async () => {
        await this.getgame('sport', segC, "996");
        this.setState(
          { openLogin: false, openRegister: false, openDeposit: false, openWithdraw: false, tabselectsec: 0, tabselect: 14 },
          afterSetState
        );
      },
      "game/casino": async () => {
        await this.getgame('casino', segC, "993");
        this.setState({ tabselect: 101 }, afterSetState);
      },
      "game/hit": async () => {
        await this.getgame('slot', segC, "992");
        await this.getprovidor('slot', segC, "2255");
        this.setState({ tabselect: 111 }, afterSetState);
      },
      "game/fishing": async () => {
        await this.getgame('fishing', segC, "995");
        this.setState({ tabselect: 121 }, afterSetState);
      },
      "game/slot": async () => {
        await this.getgame('slot', segC, "995");
        this.setState({ tabselect: 131 }, afterSetState);
      },
      "game/export": async () => {
        await this.getgame('export', segC, "11131");
        this.setState({ tabselect: 511 }, afterSetState);
      },
      "game/sport": async () => {
        await this.getgame('sport', segC, "996");
        this.setState({ tabselect: 141 }, afterSetState);
      },
      "game/lotto": async () => {
        await this.getgame('lotto', segC, "lotto", true);
        this.timerx = setInterval(() => { this.setState({ currentTime: new Date().getTime() }); }, 1000);
        this.setState({ tabselect: 171 }, afterSetState);
      },
      "casinox": async () => {
        await this.getgame('casino', segC, "993");
        this.setState({ tabselect: 10, typepage: "casino" }, afterSetState);
      },
      "game/providor": async () => {
        await this.getgame('casino', segC, "994");
        this.setState({ tabselect: 18, typepage: "providor" }, afterSetState);
      },
      "fishingx": async () => {
        await this.getgame('fishing', segC, "995");
        this.setState({ tabselect: 12, typepage: "fishing" }, afterSetState);
      },
      "usdtinfo": async () => {
        this.setState({ tabselect: 98 }, afterSetState);
      },
      "slotx": async () => {
        await this.getgame('slot', segC, "995");
        this.setState({ tabselect: 13, typepage: "slot" }, afterSetState);
      },
      "exportx": async () => {
        await this.getgame('export', segC, "11131");
        this.setState({ tabselect: 51, typepage: "esport" }, afterSetState);
      },
      "sportx": async () => {
        await this.getgame('sport', segC, "996");
        this.setState({ tabselect: 14, typepage: "sport" }, afterSetState);
      },
      "bettingrecord": async () => {
        this.setState({ tabselect: 97 }, afterSetState);
      },
      "game/list": async () => {
        await this.getgame('slot', segC);
        this.setState({ tabselect: 20, partner: segC }, afterSetState);
      },
      "lottox": async () => {
        await this.getgame('lotto', segC, "lotto");
        this.timerx = setInterval(() => { this.setState({ currentTime: new Date().getTime() }); }, 1000);
        this.setState({ tabselect: 17 }, afterSetState);
      },
      "loss": async () => this.setState({ tabselect: 25 }),
      "manager/ranking": async () => this.setState({ tabselect: 27 }),
      "minigame/luckywheel": async () => this.setState({ tabselect: 28 }),
      "serch/sl": async () => {
        await this.getgame('slot', segC, "995");
        this.setState({ tabselect: 777, typepage: "slot" }, afterSetState);
      },
      "serch/cs": async () => {
        await this.getgame('casino', segC, "993");
        this.setState({ tabselect: 777, typepage: "casino" }, afterSetState);
      },
      "serch/fs": async () => {
        await this.getgame('fishing', segC, "995");
        this.setState({ tabselect: 777, typepage: "fishing" }, afterSetState);
      },
      "event": async () => this.setState({ tabselect: 16 }),
      "manager/withdraw": async () => requireLogin(2),
      "manager/deposit": async () => requireLogin(1),
      "manager/statement": async () => requireLogin(3),
      "userinfo": async () => {
        if (await requireLogin(8)) this.setState({ tabselect: 8, tabselection: selection });
        if (selection == 5) {
          const token = localStorage.getItem('auth_token');
          if (token) {
            try {
              const decoded = jwt_decode(token);
              const Username = decoded.message.playerid;
              await this.calllisthistory(Username);
            } catch (ex) { /* ignore */ }
          }
        }
      },
      "register": async () => this.setState({ tabselect: 22 }),
      "signin": async () => this.setState({ tabselect: 23 }),
      "overview": async () => this.setState({ tabselect: 4, refer: 1 }),
      "refer/member": async () => this.setState({ tabselect: 4, refer: 2 }),
      "refer/income-summary": async () => this.setState({ tabselect: 4, refer: 3 }),
      "refer/share-network": async () => this.setState({ tabselect: 4, refer: 4 }),
      "rebate": async () => this.setState({ tabselect: 5 }),
      "promotion": async () => this.setState({ tabselect: 7, tabselection: selection }),
      "rewardscentre": async () => { window.history.pushState(null, '', "/"); this.setState({ modalmaintain: true }); },
      "manager/diamondclub": async () => {
        this.setState({ tabselect: 99 });
        this.prev = document.body.style.backgroundColor;
        document.body.style.backgroundColor = '#17191c';
      },
    };

    // wrap in try/finally so loading/NProgress always cleared
    try {
      if (routeHandlers[key]) {
        await routeHandlers[key]();
      } else {
        this.setState({ tabselect: 0 });
      }

      // short wait to let setState callbacks and DOM changes settle
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      // determine final selection to scroll to (prefer actual state.tabselect)
      const finalSelection = (this.state && typeof this.state.tabselect !== 'undefined' && this.state.tabselect !== null)
        ? this.state.tabselect
        : selection;

      console.log('[navigateTo] finalSelection ->', finalSelection);

      // if deterministicScrollToTab exists, call it to ensure scroll happens AFTER tab is visible
      if (typeof this.deterministicScrollToTab === 'function') {
        try {
          const ok = await this.deterministicScrollToTab(finalSelection, {
            headerOffset,
            timeoutMs: scrollTimeoutMs,
            pollInterval: 60,
            maxTries: 8
          });
          console.log('[navigateTo] deterministicScrollToTab ok ->', ok);
        } catch (err) {
          console.warn('[navigateTo] deterministicScrollToTab threw', err);
        }
      } else {
        // fallback simple scroll-to-top of window for routes that don't need precise scroll
        window.scrollTo(0, 0);
      }
    } finally {
      // always reset loading and NProgress
      try { this.setState({ loading: false }); } catch (e) { console.warn('setState loading false failed', e); }
      NProgress.done();
    }
  };


  // ใส่ใน class component (ใช้ this.topRef ที่คุณมี)
  // helper: รอจน element ที่ส่ง callback คืนค่า ไม่เป็น null และ visible (optionally)
  // callback: ()=> element (ไม่ใช่ element โดยตรง) เพื่อให้เราตรวจค่าทุกรอบ
  // options.timeout in ms
  // waitUntilVisible: รับ getEl (fn) หรือ element, รอจน element exists และ visible (not display:none)



  // helper: หา ancestor ที่สามารถ scroll ได้ (overflow auto/scroll)


  // ปรับปรุง checkurl ให้ใช้ id-based target

  // --- helpers (ใส่ใน class component ของคุณ) ---

  // รอ element ปรากฏใน DOM (โดย selector หรือ factory returning element)
  // --- helpers (วางใน class component) ---
  waitForElement = (getElOrSelector, timeout = 3000) => {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const getEl = typeof getElOrSelector === 'function'
        ? getElOrSelector
        : () => document.querySelector(getElOrSelector);

      const elNow = getEl();
      if (elNow) {
        console.log('[waitForElement] found immediately', elNow);
        return resolve(elNow);
      }

      const obs = new MutationObserver(() => {
        const el = getEl();
        if (el) {
          console.log('[waitForElement] found via mutation observer', el);
          obs.disconnect();
          resolve(el);
        } else if (Date.now() - start > timeout) {
          obs.disconnect();
          reject(new Error('waitForElement timeout'));
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });

      // safety timeout
      setTimeout(() => {
        try { obs.disconnect(); } catch (e) { }
        reject(new Error('waitForElement timeout'));
      }, timeout);
    });
  };

  waitUntilVisible = (getEl, options = {}) => {
    const timeout = options.timeout ?? 3000;
    const interval = options.interval ?? 40;
    let elapsed = 0;

    return new Promise((resolve, reject) => {
      const check = () => {
        try {
          const el = typeof getEl === 'function' ? getEl() : getEl;
          if (el && el instanceof Element) {
            const style = window.getComputedStyle(el);
            const rect = el.getBoundingClientRect();
            const visibleByStyle =
              style.display !== 'none' &&
              style.visibility !== 'hidden' &&
              parseFloat(style.opacity || '1') > 0;
            const visibleByLayout = rect.width > 0 && rect.height > 0;
            if (visibleByStyle && visibleByLayout) {
              console.log('[waitUntilVisible] visible', el);
              return resolve(el);
            }
          }
        } catch (e) {
          // ignore
        }
        elapsed += interval;
        if (elapsed >= timeout) return reject(new Error('waitUntilVisible timeout'));
        setTimeout(check, interval);
      };
      check();
    });
  };

  findScrollableAncestor = (el) => {
    if (!el) return null;
    let parent = el.parentElement;
    while (parent && parent !== document.documentElement) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') return parent;
      parent = parent.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  };

  // --- main checkurl (แทนของเดิม) ---
  checkurl = async (e, url, opts = {}) => {

    if (e && typeof e.preventDefault === 'function') {
      try { e.preventDefault(); } catch (_) { }
    }
    window.history.pushState(null, null, url);
    const debug = (...a) => console.log('[checkurl]', ...a);
    const info = (...a) => console.log('[checkurl]', ...a);
    const warn = (...a) => console.log('[checkurl]', ...a);

    const timeoutMs = typeof opts.timeoutMs === 'number' ? opts.timeoutMs : 5000;
    const pollInterval = typeof opts.pollInterval === 'number' ? opts.pollInterval : 60;
    const headerOffset = typeof opts.headerOffset === 'number' ? opts.headerOffset : 0; // ปรับถ้ามี fixed header
    const instant = opts.instant !== false; // default true -> instant scroll (not smooth)
    const nudgeCount = typeof opts.nudgeCount === 'number' ? opts.nudgeCount : 3;
    const nudgeDelay = typeof opts.nudgeDelay === 'number' ? opts.nudgeDelay : 80;

    debug('start', { url, opts: { timeoutMs, pollInterval, headerOffset, instant } });

    // 1) เรียก navigateTo ถ้ามี
    if (typeof this.navigateTo === 'function') {
      debug('calling navigateTo ->', url, opts.selection ? { selection: opts.selection } : '(no selection passed)');
      try {
        await this.navigateTo(url, opts.selection ? { selection: opts.selection } : undefined);
      } catch (err) {
        warn('navigateTo threw', err);
      }
    }

    // 2) รอ tabselect update แบบเดิม (สั้น ๆ)
    const waitForStateTabselectChange = (timeout = Math.min(timeoutMs, 1200)) => new Promise((resolve) => {
      const start = Date.now();
      const initial = (this.state && typeof this.state.tabselect !== 'undefined') ? this.state.tabselect : null;
      let done = false;
      const checkNow = () => {
        const current = (this.state && typeof this.state.tabselect !== 'undefined') ? this.state.tabselect : null;
        if (current !== initial && current !== null) {
          done = true; cleanup(); resolve({ changed: true, value: current }); return;
        }
        if (Date.now() - start >= timeout) { done = true; cleanup(); resolve({ changed: false, value: current }); }
      };
      const iv = setInterval(() => { if (!done) checkNow(); }, pollInterval);
      let rafId = null;
      const rafLoop = () => { if (done) return; checkNow(); rafId = requestAnimationFrame(rafLoop); };
      rafLoop();
      const cleanup = () => { try { clearInterval(iv); } catch (_) { } try { if (rafId) cancelAnimationFrame(rafId); } catch (_) { } };
      checkNow();
    });

    await waitForStateTabselectChange();

    // 3) หา selection จริง
    const selection = (() => {
      const fromState = (this.state && typeof this.state.tabselect !== 'undefined' && this.state.tabselect !== null)
        ? this.state.tabselect
        : (this.state && typeof this.state.tabselection !== 'undefined' && this.state.tabselection !== null)
          ? this.state.tabselection
          : null;
      return fromState || opts.selection || 1;
    })();

    const tabId = `top-tab-${selection}`;
    info('resolved selection ->', selection, 'waiting for element:', tabId);

    // helper: visible check
    const isElementVisible = (el) => {
      if (!el) return false;
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) return false;
      const rects = el.getClientRects();
      return rects.length > 0 && (el.offsetWidth > 0 || el.offsetHeight > 0 || rects[0].width > 0 || rects[0].height > 0);
    };

    // helper: find scrollable ancestors up to document
    const getScrollableAncestors = (el) => {
      const anc = [];
      let node = el.parentElement;
      const overflowRegex = /(auto|scroll|overlay)/;
      while (node && node !== document.documentElement) {
        const style = window.getComputedStyle(node);
        const overflowY = `${style.overflowY}` || '';
        const isScrollable = overflowRegex.test(overflowY) && node.scrollHeight > node.clientHeight;
        if (isScrollable) anc.push(node);
        node = node.parentElement;
      }
      // finally include window/document scrolling
      anc.push(window);
      return anc;
    };

    // helper: scroll a specific ancestor so that el is visible at top (account headerOffset)
    const scrollAncestorToElement = (ancestor, el, offset = 0) => {
      if (ancestor === window) {
        const rect = el.getBoundingClientRect();
        const absoluteY = window.scrollY + rect.top - offset;
        // ensure integer
        window.scrollTo({ top: Math.max(0, Math.round(absoluteY)), behavior: instant ? 'auto' : 'smooth' });
        debug('window.scrollTo', Math.max(0, Math.round(absoluteY)));
        return;
      } else {
        // ancestor is an element with its own scroll
        const ancestorRect = ancestor.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();
        const delta = elRect.top - ancestorRect.top; // position relative to ancestor's visible top
        const target = ancestor.scrollTop + Math.round(delta) - offset;
        ancestor.scrollTop = Math.max(0, target);
        debug('ancestor.scrollTop set', ancestor, ancestor.scrollTop);
        return;
      }
    };

    // wait for visible with polling & MutationObserver
    const waitForVisible = (id, timeout = timeoutMs) => new Promise((resolve) => {
      const start = Date.now();
      let resolved = false;
      const tryResolve = () => {
        const el = document.getElementById(id);
        if (el && isElementVisible(el)) { resolved = true; cleanup(); resolve({ ok: true, el }); return; }
        if (Date.now() - start >= timeout) { resolved = true; cleanup(); resolve({ ok: false, el: document.getElementById(id) || null }); }
      };
      const pollId = setInterval(() => { if (!resolved) tryResolve(); }, pollInterval);
      const mo = new MutationObserver(() => { if (!resolved) tryResolve(); });
      const cleanup = () => { clearInterval(pollId); try { mo.disconnect(); } catch (_) { } };
      try { mo.observe(document.documentElement || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] }); } catch (e) { debug('MO fail', e); }
      tryResolve();
    });

    const { ok, el } = await waitForVisible(tabId, timeoutMs);

    if (!ok) {
      warn(`[checkurl] ${tabId} not visible within ${timeoutMs}ms. Attempting best-effort if element exists.`);
      if (!el) return false;
    }

    // ถ้ามี element ให้เลื่อนแบบ deterministic -> เลื่อน ancestor ทีละตัว
    try {
      const targetEl = el;
      const ancestors = getScrollableAncestors(targetEl);
      debug('scrollable ancestors count', ancestors.length, ancestors);

      // scroll from nearest ancestor (inner) to outer (window)
      for (let i = 0; i < ancestors.length; i++) {
        const anc = ancestors[i];
        // for headerOffset, only apply on the final window scroll to place element below header
        const applyOffset = (anc === window) ? headerOffset : 0;
        scrollAncestorToElement(anc, targetEl, applyOffset);
        // small wait to allow layout to settle (instant so short)
        await new Promise(r => setTimeout(r, 20));
      }

      // NUDGE: ทำซ้ำเล็กน้อย เพื่อให้แน่ใจว่ามันเลื่อนได้สุด (handle reflow/animations)
      for (let n = 0; n < nudgeCount; n++) {
        const rect = targetEl.getBoundingClientRect();
        const viewportH = window.innerHeight || document.documentElement.clientHeight;
        const topOk = rect.top >= 0 && rect.top <= viewportH * 0.85;
        debug('nudge check', n, { top: rect.top, inView: topOk });
        if (topOk) break;
        // nudge final scroll
        const absoluteY = window.scrollY + rect.top - headerOffset;
        window.scrollTo({ top: Math.max(0, Math.round(absoluteY)), behavior: 'auto' });
        await new Promise(r => setTimeout(r, nudgeDelay));
      }

      info(`[checkurl] done: scrolled to ${tabId}`);

      return true;
    } catch (err) {
      console.error('[checkurl] final scroll error', err);

      return false;
    }

  };






  async saveclickaff(linkid) {
    await instance.post("/api/v1/saveclickaff", {
      linkid: linkid,
      System: Systems,
    }).then((res) => {
      if (res.data.status == 200) {
        var date = new Date()
        this.setState({
          userrecomend: res.data.username,
          link: linkid
        });
        var username = res.data.username
        var object = { date, username }
        localStorage.setItem('aff', JSON.stringify(object))
      }
    }).catch(async (err) => {
    });

  }
  async saveclick(linkid) {
    await instance.post("/api/v1/saveclickaff", {
      linkid: linkid,
      System: Systems,
    }).then((res) => {
      if (res.data.status == 200) {
        var date = new Date()
        var username = res.data.username
        this.setState({
          userrecomend: username,
        });
        var object = { date, username }
        localStorage.setItem('aff', JSON.stringify(object))
      }
    }).catch(async (err) => {
    });

  }
  // ✅ componentDidMount: โหลด setting + สรุป login แล้วเรียก navigateTo ครั้งเดียว
  async componentDidMount() {
    try {

      const rootNode = this.rootRef.current || document;
      this.enhanceAllImages(rootNode);

      // observe dynamic changes (images added later)
      // this._mo = new MutationObserver(muts => {
      //   muts.forEach(m => {
      //     if (m.addedNodes && m.addedNodes.length) {
      //       m.addedNodes.forEach(node => {
      //         if (node.nodeType !== 1) return;
      //         if (node.tagName === 'IMG') this.enhanceImage(node);
      //         else this.enhanceAllImages(node);
      //       });
      //     }
      //   });
      // });

      try {
        this._mo.observe((this.rootRef.current || document.body), { childList: true, subtree: true });
      } catch (e) {
        console.warn('MutationObserver failed', e);
      }

      const search = window.location.href;
      var test = search.split("aff=")[1]
      if (test != undefined) {
        this.saveclickaff(test.split("&")[0]);
      }
      var params = search.split("reg=")[1]
      if (params != undefined) {
        this.saveclick(params);
        this.setState({
          userrecomend: params.split("&")[0],
        });
      }

      var tokenf = localStorage.getItem('aff');
      if (tokenf != null) {
        var codev = JSON.parse(tokenf)
        //   console.log(codev);
        var Username = codev.username;
        this.setState({
          userrecomend: Username,
        });
      }

      var tokenx = localStorage.getItem('register');
      if (tokenx != null) {
        var codev = JSON.parse(tokenx)
        // console.log(codev);
        var Username = codev.username;
        this.setState({
          userrecomend: Username,
        });
      }


      this.initSwiper();
      requestAnimationFrame(() => {
        setTimeout(() => {
          const root = this.scrollerRef.current;   // <<< เปลี่ยนตรงนี้
          if (!root) return;

          if (!this._scrollAttached) {
            root.addEventListener('scroll', this.handleScroll, { passive: true });
            this._scrollAttached = true;
          }

          // ใช้ ResizeObserver แค่เพื่อ "รู้ว่า container มีความสูง > 0" ครั้งแรก
          this.resizeObs = new ResizeObserver(([entry]) => {
            if (entry.contentRect.height > 0) {
              this.ensureFilledViewport();
              // ถ้าไม่อยากให้ยิงซ้ำๆ ก็ยกเลิก observe หลังพร้อมแล้ว
              this.resizeObs?.disconnect();
              this.resizeObs = null;
            }
          });
          this.resizeObs.observe(root);
        }, 0);
      });
      this.repositionInkBarSafe();
      window.addEventListener('resize', this.repositionInkBarSafe);
      this.tabList?.addEventListener('scroll', this.repositionInkBarSafe, { passive: true });

      // สีพื้นหลังเริ่มต้น
      this.prev = document.body.style.backgroundColor;
      document.body.style.backgroundColor = '#EFEFF4';
      window.addEventListener('anyScroll', this.handleAnyScroll, { passive: true });
      if (this.state.tabselectsec === 22) this.startLocalBankCountdown(10);
      const mainSettingKey = "mainSettingCache";
      const mainSettingTTL = 10 * 60 * 1000;
      const pathname = window.location.pathname;

      // ===== โหลด main setting (คงโค้ดเดิมของคุณไว้ แต่ย่อการตั้ง state) =====
      const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);
      const applyMainSetting = (data) => {
        document.title = data.tblsetting[0].title;
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/svg+xml';
        link.rel = 'icon';
        link.href = "/"
        document.getElementsByTagName('head')[0].appendChild(link);
        this.setState(prev => ({
          webname: data.tblsetting?.[0]?.Description,
          banklist: data.tblbank,
          logoimg:
            prev.logoimg === data.tblsetting?.[0]?.imglogo
              ? prev.logoimg
              : data.tblsetting?.[0]?.imglogo,
          whellsetting: data.tblwheelsetting,
          maxwithdrawstatus: data.tblcatagoryx?.[0]?.withdrawmax,
          luckywheeldisplay: data.tblwheelsetting?.[0]?.status === 1,
          linelink: data.message?.[1]?.value,
          webnamex: data.message?.[7]?.value,
          describemain: data.tblsetting?.[0]?.title,
          System: data.tblcatagoryx?.[0]?.System,
          cashoutSet: data.tblcashoutsetting?.[0],
          inviteSet: data.tblinvitedsetting?.[0],
          datas: data.message,
          limit: {
            min: data.tblcatagoryx?.[0]?.limitdeposit,
            max: data.tblcatagoryx?.[0]?.maxdeposit
          }
        }));

      };

      // ใช้แคชถ้ามี
      if (mainSettingCache) {
        applyMainSetting(mainSettingCache);
      } else {
        const token = localStorage.getItem('auth_token');
        let Playerid = null;
        if (token) {
          try {
            const decoded = jwt_decode(token);
            Playerid = decoded.message.playerid;
          } catch { }
        }

        const res = await instance.post("/api/v1/mainsetting", { System: Systems, Playerid });
        if (res?.data?.status === 200) {
          applyMainSetting(res.data);
          this.setCache(mainSettingKey, res.data);
        }
      }

      // ===== โหลด tabbannerlist แบบแคช (คงตรรกะเดิม) =====
      const cacheKey = "tabBannerListCacheMobile";
      const cacheTTL = 3 * 60 * 60 * 1000;
      const cachedData = JSON.parse(localStorage.getItem(cacheKey) || "null");
      if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
        this.setState({ tabbannerlist: cachedData.data });
      } else {
        try {
          const statusx = 2;
          const res = await instance.get('/api/v1/tabbannerlist', {
            params: {
              System: Systems,
              status: statusx,
            },
          });

          if (res?.data?.status === 200) {
            this.setState({ tabbannerlist: res.data.message });
            localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: res.data.message }));
          }
        } catch (err) {
          console.error("Error fetching tabbannerlist:", err);
        }
      }

      if (typeof window.Swiper === 'undefined') {
        console.warn('Swiper library not loaded yet');
        // รอจนโหลด (ถ้าจำเป็น)
        window.addEventListener('load', () => this.initSwiper(), { once: true });
        return;
      }

      if (this.tabListRef && this.tabListRef.current) {
        this.tabList = this.tabListRef.current;
      }
      this._mounted = true;
      this.boot().catch(console.error);
      // (ออปชัน) รองรับ back/forward
      window.onpopstate = () => this.navigateTo(window.location.pathname, { selection: 1 });

    } catch (error) {
      console.log("componentDidMount error:", error);
    }
  };


  componentWillUnmount() {
    document.body.style.backgroundColor = this.prev || '';
    window.removeEventListener('anyScroll', this.handleAnyScroll);
    clearInterval(this._lbTimer);
    try { if (this._mo) this._mo.disconnect(); } catch (e) { }
  }
  handleAnyScroll = (e) => {
    const dir = e?.detail?.dir;
    if (dir === 'up' || dir === 'down') {
      this.setState({ scrollDir: dir });
    }
  };
  // ===== refs สำหรับแท็บ/ink bar =====
  loginTabRef = React.createRef();
  registerTabRef = React.createRef();
  navScrollRef = React.createRef();

  // ===== toggle แท็บ =====
  selectLoginTab = () => this.setState({ openLogin: true, openRegister: false }, this.updateInkBar);
  selectRegisterTab = () => this.setState({ openLogin: false, openRegister: true }, this.updateInkBar);

  // ===== เปิด/ปิด modal แบบ state เดียว =====
  openLoginModal = () => this.setState({ openLogin: true, openRegister: false });
  openRegisterModal = () => this.setState({ openLogin: false, openRegister: true });
  closeAllModals = () => this.setState({ openLogin: false, openRegister: false });

  // ===== ปิดด้วย ESC =====
  onEsc = (e) => { if (e.key === "Escape") this.closeAllModals(); };


  // ===== คำนวณตำแหน่ง ink bar =====
  updateInkBar = () => {
    const activeEl = this.state.openLogin ? this.loginTabRef.current : this.registerTabRef.current;
    const container = this.navScrollRef.current;
    if (!activeEl || !container) return;

    const rectA = activeEl.getBoundingClientRect();
    const rectC = container.getBoundingClientRect();
    const left = rectA.left - rectC.left + container.scrollLeft;

    this.setState({ inkLeft: left, inkWidth: rectA.width });
  };


  openModal = () => {
    if (this.mask) this.mask.classList.remove("ant-modal-mask-hidden");
    if (this.wrap) {
      this.wrap.style.display = "block";
      // โฟกัสเพื่อตรวจจับ keydown ของ wrap (ถ้าจะใช้ onKeyDown ที่ wrap)
      this.wrap.focus?.();
    }
  };

  closeModal = () => {
    if (this.mask) this.mask.classList.add("ant-modal-mask-hidden");
    if (this.wrap) this.wrap.style.display = "none";
  };

  // ปิดเมื่อคลิกพื้นหลัง (wrap)
  onWrapClick = (e) => {
    if (e.target === e.currentTarget) this.closeModal();
  };

  fetchCacheVersion = async (System) => {
    try {
      const response = await instance.get('/api/v1/cacheversion', {
        params: {
          System: Systems
        }
      });
      console.log("📥 Fetched cache version:", response.data);
      return response.data.message.versionCaching;
    } catch (error) {
      console.error("❌ Failed to fetch cache version:", error);
      return null;
    }
  };

  async getcallprovidor(latestCacheVersion) {
    const cacheTTL = 3 * 60 * 60 * 1000; // 3 hours in milliseconds
    const cacheVersionKey = "cacheVersion";

    const fetchData = async (state, key) => {
      const cacheKey = `tabGameListCache_${state}`;
      const cachedData = JSON.parse(localStorage.getItem(cacheKey));
      const currentCacheVersion = localStorage.getItem(cacheVersionKey);

      console.log("Failed to fetch cache version 1:", latestCacheVersion, currentCacheVersion);
      // Fetch the latest cache version from the API
      // Check if the cache is valid
      if (
        cachedData &&
        currentCacheVersion === latestCacheVersion &&
        Date.now() - cachedData.timestamp < cacheTTL
      ) {
        console.log(`Using cached data for state: ${state}`);
        this.setState({ [key]: cachedData.data });
      } else {
        // Fetch new data and cache it
        await instance.post("/api/v1/tabgamelist", {
          state: state,
          System: Systems,
        }).then((res) => {
          if (res.data.status === 200) {
            this.setState({ [key]: res.data.message });
            // Save to cache
            localStorage.setItem(cacheKey, JSON.stringify({
              timestamp: Date.now(),
              data: res.data.message,
            }));
          }
        }).catch((err) => {
          console.error(`Error fetching data for state: ${state}`, err);
        });
      }
    };

    // Fetch data for each state and cache it
    await fetchData("2", "categorylist");
    await fetchData("6666", "slotlist");
    await fetchData("4444", "gamehitlist");
    await fetchData("5555", "pglist");
    await fetchData("2255", "providorlist");
    await fetchData("5", "sportlist");
    await fetchData("7777", "fishinglist");
  }

  getCache = (key, ttl) => {
    const cachedData = JSON.parse(localStorage.getItem(key));
    if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
      return cachedData.data;
    }
    return null;
  };

  setCache = (key, data) => {
    localStorage.setItem(key, JSON.stringify({
      timestamp: Date.now(),
      data: data,
    }));
  };
  validateLoginForm = async (e) => {
    const { username, password } = this.state;
    console.log(username, password);
    await instance.post("/api/v1/userlogin", {
      userid: username,
      password: password,
      System: Systems,
      Function: 'validateLoginForm-navbar.js'
    })
      .then(async (res) => {
        console.log("validateLoginForm", res.data);
        if (res.data.status === 200) {
          await localStorage.setItem('auth_token', res.data.token)
          this.setState({
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            firstname: res.data.message.firstname,
            lastname: res.data.message.lastname,
            point: res.data.message.Point,
            balance: res.databalance,
            openLogin: false,
            loginstate: true,
          });
          this.rechecklogin(res.data.message.playerid, res.data.token);
          await this.notify("success", 'เข้าสุ่ระบบเรียบร้อย');
          // setTimeout(() => { window.location.href="/" }, 2000)
        }
        else if (res.data.status === 401) {
          toast.error("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        else {
          toast.error(
            <div>
              <strong>error!</strong>
              <div style={{ marginTop: 6 }}>ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง</div>
            </div>,
            {
              position: 'top-center',    // หรือ 'top-right' ตามชอบ
              autoClose: 5000,           // ปิดเองหลัง 5 วินาที
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: 'colored',
            }
          );
          //   Bonn.alert("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง")
        }

      });
  }

  async rechecklogin(Username, token) {

    try {
      console.log(4555555555555);
      const search = window.location.href;
      const paramx = new URLSearchParams(search);
      const space = window.location.host
      var userhash = md5(Username);
      const linkaff = "https://" + space + "/register?reg=" + userhash;
      instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'rechecklogin-navbar.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {

        if (res.data.status === 200) {
          console.log(2142, res.data);
          localStorage.setItem('auth_token', res.data.token)
          var rankall = res.data.tblrankall;
          const found = rankall.find(obj => {
            return obj.checked === 1;
          });
          this.setState({
            tblrankall: res.data.tblrankall,
            buttoncliam: (found === undefined) ? true : false,
            tblnextrank: res.data.tblnextrank,
            usercheck: res.data.usercheck,
            rankpic: res.data.tblrank?.image,
            rankname: res.data.tblrank?.name,
            linkaff: linkaff,
            TurnOverAmount: res.data.message.Turnovercasino + res.data.message.Turnoverslot,
            rankob: res.data.tblrank,
            rankpoint: res.data.rankpoint,
            fullname: res.data.message.firstname,
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            tblprofile: res.data.message,
            username: res.data.message.playerid,
            fname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            afficiatetoday: res.data.userafftoday,
            afficiateall: res.data.useraffall,
            buttoncliam: (found === undefined) ? true : false,
            loginstate: true,
          });
          // this.calllisthistory(Username);
        }
        else if (res.data.status === 401) {
          localStorage.clear();
          await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
          window.location.href = "/";
        }

      }).catch(async (err) => {
        console.log(err)
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
          window.location.href = "/";
        }
      });
    }
    catch (ex) {
      //////console.log(ex);
    }

  }

  show = () => {
    if (this.state.loginstate) {
      this.setState({ open: true });
    }
  }
  hide = () => this.setState({ open: false });

  waitnotify = async () => {
    setTimeout(() => { console.log('World!') }, 5000)
  }
  notify = async (mode, msg) => {
    console.log(mode, msg);
    if (mode == "success") {
      await toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "warning") {
      await toast.warning(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "error") {
      await toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "info") {
      await toast.info(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    //  await this.waitnotify();
  }

  headerWrapRef = React.createRef();   // .common-distance-wrap
  headerRef = React.createRef();       // .tlc-sign-header
  lastY = 0;

  setVisible = (isShow) => {
    const wrap = this.headerWrapRef.current;
    const header = this.headerRef.current;
    if (!wrap || !header) return;

    wrap.style.display = isShow ? 'block' : 'none';
    header.classList.toggle('hidden', !isShow);
    header.classList.toggle('false', isShow);
  }
  // 1) state: เก็บ index ของสไลด์ตรงกลาง


  // 2) ปุ่ม next/prev
  nextSlide = () => {
    const { listitallgame = [], centerIdx } = this.state;
    const len = listitallgame.length || 1;
    this.setState({ centerIdx: (centerIdx + 1) % len });
  };

  prevSlide = () => {
    const { listitallgame = [], centerIdx } = this.state;
    const len = listitallgame.length || 1;
    this.setState({ centerIdx: (centerIdx - 1 + len) % len });
  };

  // 3) mapping offset -> style (ยึดค่าที่คุณใช้อยู่)
  coverSlotStyle = (offset) => {
    // offset: 0=center, +1=right1, +2=right2, -1=left1, -2=left2, อื่นๆ = ซ่อน
    switch (offset) {
      case 0: return { transform: "translate(-50%, -50%) scale(1)", zIndex: 2, opacity: 1, pointer: "auto" };
      case 1: return { transform: "translate(8%, -50%) scale(0.82)", zIndex: 1, opacity: 1, pointer: "none" };
      case 2: return { transform: "translate(18%, -50%) scale(0.72)", zIndex: 0, opacity: 1, pointer: "none" };
      case -1: return { transform: "translate(-108%, -50%) scale(0.82)", zIndex: 1, opacity: 1, pointer: "none" };
      case -2: return { transform: "translate(-119%, -50%) scale(0.72)", zIndex: 0, opacity: 1, pointer: "none" };
      default: return { transform: "translate(-50%, -50%) scale(0.6)", zIndex: -1, opacity: 0, pointer: "none" };
    }
  };

  // 4) คำนวณ offset แบบเวียนให้ “ใกล้ 0” ที่สุด
  calcOffset = (i, centerIdx, len) => {
    let off = i - centerIdx;
    if (off > len / 2) off -= len;
    if (off < -len / 2) off += len;
    return off;
  };
  toNumber = (s) => {
    const cleaned = String(s).replace(/[^\d]/g, "");
    return cleaned === "" ? NaN : parseInt(cleaned, 10);
  };

  onChangeAmountDep = (e) => {
    const raw = e.target.value;
    this.setState((prev) => ({
      ...prev,
      depositamount: raw,
      touched: prev.touched || true,
    }));
  };

  onBlur = () => this.setState({ touched: true });

  getErrorKey() {
    const { depositamount, touched, limit } = this.state;
    if (!touched) return null;

    const amount = this.toNumber(depositamount);
    if (Number.isNaN(amount)) return "empty";
    if (amount < limit.min) return "ltMin";
    if (amount > limit.max) return "gtMax";
    return null; // valid
  }

  isValid() {
    const key = this.getErrorKey();
    const amount = this.toNumber(this.state.depositamount);
    return key === null && !Number.isNaN(amount);
  }

  handlePaste = (e) => {
    const text = (e.clipboardData || window.clipboardData).getData("text");
    if (/[^\d]/.test(text)) {
      e.preventDefault();
      this.setState({ depositamount: text.replace(/[^\d]/g, ""), touched: true });
    }
  };

  handleSubmit = () => {
    if (!this.isValid()) return;
    const amount = this.toNumber(this.state.depositamount);
    this.props.onSubmit?.(amount);
  };
  renderError() {
    const key = this.getErrorKey();
    const { min, max } = this.state.limit;
    if (!key) return null;

    switch (key) {
      case "empty":
        return (
          <>
            <div className="inputErrMsg">กรุณากรอกจำนวนเงิน</div>
          </>
        );
      case "ltMin":
        return (
          <>
            <div className="inputErrMsg">
              จำนวนเงินต้องไม่น้อยกว่า {min.toLocaleString()} บาท
            </div>
          </>
        );
      case "gtMax":
        return (
          <>
            <div className="inputErrMsg">
              จำนวนเงินต้องไม่เกิน {max.toLocaleString()} บาท
            </div>
          </>
        );
      default:
        return null;
    }
  }
  renderErrorWithdraw() {

    const { keywithdraw } = this.state
    switch (keywithdraw.toString()) {
      case "1":
        return (
          <>
            <div className="inputErrMsg">
              คุณไม่ได้ใส่ยอดเงิน
            </div>
          </>
        );
      case "2":
        return (
          <>
            <div className="inputErrMsg">
              ยอดเงินไม่เพียงพอสำหรับการถอน
            </div>
          </>
        );
      default:
        return null;
    }
  }
  // === เดิม: ย้าย logic มาที่ core ===
  cancelDepositCore = () => {
    this.clearQrCountdown?.();
    this.setState({
      qrcode: "",
      qrcodecheck: false,
      qrcodeExpired: false,
      counter: 0,
      tabselectsec: 0,
      depositstate: 0,
    });
    this.notify?.("warning", "ยกเลิกรายการแล้ว");
  };




  confirmCancelDeposit = async () => {
    const ok = await showConfirmToast(
      "ยืนยันการยกเลิกรายการ? หากยกเลิกแล้ว คุณต้องทำรายการใหม่อีกครั้ง",
      {
        confirmText: "ยืนยัน",
        cancelText: "กลับ",
        position: "top-center"
      }
    );

    if (ok) {
      // เรียกฟังก์ชันเดิมของคุณ
      this.cancelDepositCore();

      // แจ้งสำเร็จด้วย toast (เหมือนเดิม)
      toast.success("ยกเลิกรายการแล้ว", {
        position: "top-right",
        autoClose: 1200,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    } else {
      // ยกเลิก — ทำตามเดิม (หรือไม่ต้องทำอะไร)
    }
  };


  copyText = async (text) => {
    if (!text || String(text).trim() === "") {
      this.notify?.("warning", "ไม่มีข้อมูลให้คัดลอก");
      return;
    }

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(String(text));
      } else {
        // Fallback: สร้าง textarea ชั่วคราว
        const ta = document.createElement("textarea");
        ta.value = String(text);
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      this.notify?.("success", "คัดลอกแล้ว");
    } catch (err) {
      console.error("Copy failed:", err);
      this.notify?.("error", "คัดลอกไม่สำเร็จ");
    }
  };

  confirmdeposit = async (e, num, paymentstate = 0) => {
    try {
      if (e && typeof e.preventDefault === 'function') {
        e.preventDefault();
      }
    } catch (ex) { /* ignore */ }

    // prevent double submit
    if (this.depositSubmitting) {
      console.debug('[confirmdeposit] already submitting, ignore');
      return;
    }
    this.depositSubmitting = true;

    // set loading
    try {
      this.setState({ loading: true });

      console.log(493, num);
      const token = localStorage.getItem('auth_token');
      let decoded = null;
      let Username = null;
      try {
        if (token) decoded = jwt_decode(token);
        Username = decoded ? decoded.message.playerid : null;
      } catch (e) {
        console.warn('[confirmdeposit] invalid token', e);
      }

      // num === 0 flow (get qrcode)
      if (num === 0) {
        if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
          if (token != null) {
            try {
              const res = await instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                paymentstate: paymentstate,
                amount: this.state.depositamount
              }, {
                headers: { Authorization: `Bearer ${token}` }
              });

              console.log("tblpaymentgatewayx", res.data);
              const isPaid = Number(paymentstate) === 1;
              const qrcode = res?.data?.tblpaymentgatewayx?.QRcode;

              if (isPaid) {
                if (isPaid && (qrcode ?? '').trim()) {
                  this.setState({
                    mainacc: res.data.mainacc,
                    qrcode: res.data.tblpaymentgatewayx?.QRcode,
                    paymentlist: res.data.tblpaymentgatewayx,
                    tabselectsec: 11,
                    tabselectdeposit: 0,
                    counter: 300, // 5 นาที
                    qrcodecheck: true,
                    qrcodeExpired: false,
                  }, () => {
                    // เริ่มนับหลังจาก state ถูกเซ็ตและ QR โชว์แน่ ๆ
                    this.startQrCountdown(300);
                  });
                  await this.notify("success", 'กรุณาสแกน qrcode ภายใน 5 นาที');
                } else {
                  await this.notify("error", 'ระบบปิดปรับปรุงกรุณารอ 5 นาทีทำรายการใหม่อีกครั้ง');
                }
              } else if (paymentstate == 0) {
                this.setState({
                  mainacc: res.data.mainacc,
                  tabselectsec: 22,
                  tabselectdeposit: 0,
                  counter: 4500, // 75 นาที? (คุณเขียน 4500)
                  qrcodecheck: true,
                  qrcodeExpired: false,
                }, () => {
                  // this.startQrCountdown(4500); // หากต้องการเริ่มนับให้เปิด
                });
                await this.notify("success", 'กรุณาสแกน qrcode ภายใน 5 นาที');
              }
            } catch (err) {
              console.error('[confirmdeposit] getqrcode error', err);
              await this.notify("error", 'เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง');
            }
          } else {
            console.warn('[confirmdeposit] no token');
          }

          // set depositstate regardless (ตาม logic เดิม)
          this.setState({ depositstate: 1 });
        } else {
          await this.notify("warning", 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ');
        }
      }
      // num === 1
      else if (num === 1) {
        this.setState({ depositstate: 1 });
      }
      // num === 5 (True Wallet)
      else if (num === 5) {
        try {
          if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
            const getTrueKey = `getTrueCache_${Username}_${Systems}`;
            const getTrueTTL = 30 * 60 * 1000; // 30 นาที
            const getTrueCache = this.getCache ? this.getCache(getTrueKey, getTrueTTL) : null;

            if (getTrueCache) {
              console.log("Using cached data for getTrue");
              this.setState({ trueAccountlist: getTrueCache });

              if (getTrueCache === null || (Array.isArray(getTrueCache) && getTrueCache.length === 0)) {
                await this.notify("warning", 'ยังไม่ได้เพิ่มบัญชี True Wallet กรุณาติดต่อเจ้าหน้าที่');
                return;
              }
            } else {
              try {
                const res = await instance.post("/api/v1/gettrue", {
                  userid: Username,
                  System: Systems,
                }, {
                  headers: { Authorization: `Bearer ${token}` }
                });

                if (res.data.status === 200) {
                  console.log("not Using cached getTrue", res);
                  if (!res.data.message || !res.data.message.tbltruewallet || res.data.message.tbltruewallet.length === 0) {
                    await this.notify("warning", 'ยังไม่ได้เพิ่มบัญชี True Wallet กรุณาติดต่อเจ้าหน้าที่');
                    return;
                  }

                  const trueAccountlist = res.data.message.tbltruewallet[0];
                  this.setState({
                    trueAccountlist,
                    tabselectsec: 33,
                    tabselectdeposit: 0,
                    counter: 900, // 15 นาที
                    qrcodecheck: true,
                    qrcodeExpired: false,
                  });
                  if (this.setCache) this.setCache(getTrueKey, trueAccountlist);
                  await this.notify("success", 'กรุณาทำรายการภายใน 15 นาที');
                } else {
                  await this.notify("warning", 'ยังไม่ได้เพิ่มบัญชี True Wallet กรุณาติดต่อเจ้าหน้าที่');
                  return;
                }
              } catch (err) {
                console.error("Error fetching getTrue data:", err);
                await this.notify("error", 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่ภายหลัง');
              }
            }
          } else {
            await this.notify("warning", 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ');
          }
        } catch (err) {
          console.error("Error in confirmdeposit (True Wallet):", err);
        }
      }
      // default
      else {
        this.setState({ depositstate: 0 });
      }

    } finally {
      // always clear loading and submitting flag
      try {
        this.setState({ loading: false });
        console.info('[confirmdeposit] loading:false');
      } catch (e) {
        console.warn('[confirmdeposit] setState loading false failed', e);
      }
      this.depositSubmitting = false;
    }
  };

  // confirmdeposit = async (e, num, paymentstate = 0) => {
  //   console.log(493, num)
  //   e.preventDefault();
  //   var token = localStorage.getItem('auth_token');
  //   var decoded = jwt_decode(token);
  //   var Username = decoded.message.playerid;
  //   if (num === 0) {
  //     if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
  //       if (num === 0) {
  //         if (token != null) {
  //           Username = decoded.message.playerid;
  //           instance.post("/api/v1/getqrcode", {
  //             username: Username,
  //             System: Systems,
  //             paymentstate: paymentstate,
  //             amount: this.state.depositamount
  //           }, {
  //             headers: { Authorization: `Bearer ${token}` }
  //           }).then(async (res) => {
  //             console.log("tblpaymentgatewayx", res.data)
  //             const isPaid = Number(paymentstate) === 1;
  //             const qrcode = res?.data?.tblpaymentgatewayx?.QRcode;
  //             if (isPaid) {
  //               if (isPaid && (qrcode ?? '').trim()) {
  //                 this.setState({
  //                   mainacc: res.data.mainacc,
  //                   qrcode: res.data.tblpaymentgatewayx?.QRcode,
  //                   paymentlist: res.data.tblpaymentgatewayx,
  //                   tabselectsec: 11,
  //                   tabselectdeposit: 0,
  //                   counter: 300,          // 5 นาที
  //                   qrcodecheck: true,
  //                   qrcodeExpired: false,
  //                 }, () => {
  //                   // เริ่มนับหลังจาก state ถูกเซ็ตและ QR โชว์แน่ ๆ
  //                   this.startQrCountdown(300);
  //                 });
  //                 await this.notify("success", 'กรุณาสแกน qrcode ภายใน 5 นาที');

  //               }
  //               else {
  //                 await this.notify("error", 'ระบบปิดปรับปรุงกรุณารอ 5 นาทีทำรายการใหม่อีกครั้ง');
  //               }
  //             }
  //             else if (paymentstate == 0) {
  //               this.setState({
  //                 mainacc: res.data.mainacc,
  //                 tabselectsec: 22,
  //                 tabselectdeposit: 0,
  //                 counter: 4500,          // 5 นาที
  //                 qrcodecheck: true,
  //                 qrcodeExpired: false,
  //               }, () => {
  //                 // เริ่มนับหลังจาก state ถูกเซ็ตและ QR โชว์แน่ ๆ
  //                 //  this.startQrCountdown(4500);
  //               });
  //               await this.notify("success", 'กรุณาสแกน qrcode ภายใน 5 นาที');
  //             }

  //           });

  //         }

  //         this.setState({
  //           depositstate: 1
  //         });
  //       }
  //     }
  //     else {
  //       await this.notify("warning", 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ');

  //     }
  //   }
  //   else if (num === 1) {
  //     this.setState({
  //       depositstate: 1
  //     });
  //   }
  //   else if (num === 5) {
  //     console.log(55555555555)
  //     try {

  //       if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
  //         console.log(66666666666)
  //         const getTrueKey = `getTrueCache_${Username}_${Systems}`;
  //         const getTrueTTL = 30 * 60 * 1000; // 30 นาที
  //         const getTrueCache = this.getCache(getTrueKey, getTrueTTL);

  //         if (getTrueCache) {
  //           console.log(77777777777)
  //           console.log("Using cached data for getTrue");
  //           this.setState({
  //             trueAccountlist: getTrueCache,
  //           });

  //           if (getTrueCache === null || getTrueCache.length === 0) {
  //             this.notify("warning", 'ยังไม่ได้เพิ่มบัญชี True Wallet กรุณาติดต่อเจ้าหน้าที่');
  //             return;
  //           }

  //         } else {

  //           await instance.post("/api/v1/gettrue", {
  //             userid: Username,
  //             System: Systems,
  //           }, {
  //             headers: { Authorization: `Bearer ${token}` }
  //           }).then((res) => {
  //             if (res.data.status === 200) {
  //               console.log("not Using cached getTrue", res);
  //               if (res.data.message.tbltruewallet.length === 0) {
  //                 this.notify("warning", 'ยังไม่ได้เพิ่มบัญชี True Wallet กรุณาติดต่อเจ้าหน้าที่');
  //                 return;
  //               }

  //               const trueAccountlist = res.data.message.tbltruewallet[0];

  //               this.setState({
  //                 trueAccountlist: trueAccountlist,
  //                 tabselectsec: 33,
  //                 tabselectdeposit: 0,
  //                 counter: 900,          // 15 นาที
  //                 qrcodecheck: true,
  //                 qrcodeExpired: false,
  //               });
  //               this.setCache(getTrueKey, trueAccountlist);
  //               this.notify("success", 'กรุณาทำรายการภายใน 15 นาที');
  //             }
  //             else {
  //               this.notify("warning", 'ยังไม่ได้เพิ่มบัญชี True Wallet กรุณาติดต่อเจ้าหน้าที่');
  //               return;
  //             }
  //           }).catch((err) => {
  //             console.error("Error fetching getTrue data:", err);
  //           });
  //         }
  //       }
  //       else {
  //         await this.notify("warning", 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ');

  //       }
  //     } catch (error) {
  //       console.error("Error in confirmdeposit (True Wallet):", error);
  //     }

  //   }
  //   else {
  //     this.setState({
  //       depositstate: 0
  //     });
  //   }



  // }
  calculateCountdown = (drawTime, format) => {
    const now = new Date().getTime();
    const drawTimeInMs = new Date(drawTime).getTime();
    const timeLeft = drawTimeInMs - now;

    if (timeLeft <= 0) {
      return "หมดเวลา";
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    const formattedDays = days > 0 ? `${days} วัน ` : "";
    const formattedHours = `${hours < 10 ? `0${hours}` : hours}`;

    // เงื่อนไข: ถ้ามากกว่า 1 วัน ให้แสดงแค่วันและชั่วโมง
    if (days > 1) {
      return `${formattedDays}${formattedHours} ชั่วโมง`;
    }

    // ถ้าน้อยกว่าหรือเท่ากับ 1 วัน ให้แสดงเวลาเต็ม
    if (format === "short") {
      return `${formattedHours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    }

    return `${formattedDays}${formattedHours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };
  render() {
    // ดึงทั้งหมดครั้งเดียว
    const popStyle =
      this.state.scrollDir === 'up'
        ? { right: -19, top: 176, position: 'absolute' }        // เลื่อนขึ้น: ใช้ style นี้
        : { right: 170, top: 42, position: 'absolute' };       // เลื่อนลง/ปกติ: ใช้อันเดิม

    const { depositamount, limit } = this.state;
    const placeholder = `ฝากเงินขั้นต่ำ ${Number(limit?.min).toLocaleString()} บาท สูงสุด ${Number(limit?.max).toLocaleString()} บาท ต่อรายการ`;
    const inputClass = this.getErrorKey() ? "input inputErr" : "input";
    const btnClass = this.isValid() ? "submitBtnActive" : "submitBtn";
    const {
      oldPassword, newPassword, confirmPassword, currentIndexA, currentIndex,
      isPopupOpen, query,
      balance, pathname, prolistx, categorylist, fishinglist, sportlist, slotlist,
      loginstate, listserch, clickserch, loader, userid, username, point, firstname, lastname, listgameall,
      proderedeemlist, linkaff, tblprofile,
      accnumber, usercheck, qrstep, banklist, bankselect, paymentgateway, historylist, mainacc, gamehitpglist, gamenewlist, randomlist, tabselect, providorlist,
      virtuallist, gamecardlist, // ถ้ามีใน state จะถูกดึงมาใช้ log ได้เลย
    } = this.state;
    const { listitallgame = [], centerIdx = 0 } = this.state;
    const len = listitallgame.length || 0;
    const safeIdx = len ? ((centerIdx % len) + len) % len : 0;
    const current = len ? listitallgame[safeIdx] : null;
    const HIDE_TABS = [7, 8, 99, 13, 10, 14, 51, 17, 12, 15]; // ใน render() const isMainVisible = !HIDE_TABS.includes(this.state.tabselect);
    const isMainVisible = !HIDE_TABS.includes(tabselect);
    const tabIndex = this.getTabIndex(tabselect);
    const transformStyle = { transform: `translateX(-${tabIndex * 100}%)` };
    // console.log("historylist", historylist);

    const accnumberx = accnumber?.[0]; // ถ้าไม่มีจะได้ undefined แทน error
    const { tabbannerlist, rankpoint } = this.state
    const { openLogin, openRegister, openDeposit, openWithdraw } = this.state;
    const anyOpen = openLogin || openRegister || openDeposit || openWithdraw || tabselect == 777 || tabselect == 666 || tabselect == 101 || tabselect == 121 || tabselect == 141 || tabselect == 131 || tabselect == 171 || tabselect == 511 || tabselect == 7 || tabselect == 15 || tabselect == 8 || tabselect == 99 || tabselect == 4 || tabselect == 98 || tabselect == 97; // แสดง mask ถ้ามีอันใดอันหนึ่งเปิด
    // utils สั้น ๆ สำหรับสร้าง srcSet แบบ 1x/2x ตาม pattern ?imwidth=
    const makeSrcSet = (url, w1 = 1200, w2 = 3840) => {
      if (!url) return "";
      const join = url.includes("?") ? "&" : "?";
      return `${url}${join}imwidth=${w1} 1x, ${url}${join}imwidth=${w2} 2x`;
    };

    // แปลง tabbannerlist -> items
    const items = (tabbannerlist || []).map((item, i) => ({
      href: item?.href || item?.link || item?.url || "#",                 // ถ้าไม่มีลิงก์ ให้เป็น "#" ไปก่อน
      alt: item?.alt || item?.title || `Slide ${i}`,                    // ใส่ alt จาก title/alt หรือ fallback
      src: item?.path || "",                                             // รูปหลัก
      srcSet: makeSrcSet(item?.path),                                     // สร้าง srcset อัตโนมัติ
    }));
    const banks = banklist;
    return (

      <>
<div id="__layout" data_vue_tag="transition">
  <div className="mobile-app" data_vue_tag="undefined">
    <section />
    <div
      data-v-f7eaa2a8=""
      id="loadingBlock"
      className="loading-bg"
      placeholder="Loading..."
      style={{
        backgroundColor: "rgba(0, 0, 0, 0)",
        color: "rgb(255, 255, 255)",
        display: "none"
      }}
      data_vue_tag="Loading"
    >
      <div data-v-f7eaa2a8="" className="logo" data_vue_tag="Logo">
        <img
          src={this.state.logoimg}
          alt="Loading"
        />
      </div>
    </div>
    {/**/}
    <div>
      {/**/}
      <div
        className="headerPosChange"
        configtype="[object Object]"
        data_vue_tag="Style1"
      >
        <header className="header-wrapper">
          <div className="header-top">
            <div className="header-top-fluid">
              {/**/}
              <div>
                <div className="mob_view mob-header">
                  <button className="nav-icon">
                    <span />
                    <span />
                    <span />
                  </button>
                  <div className="logo">
                    <a href="/" className="nuxt-link-active" title="Hose138">
                      <img
                        src={this.state.logoimg}
                        alt="Hose138"
                      />
                    </a>
                  </div>
                  <div className="quick-links">
                    <div className="mob-custom mob-header-icon">
                      <img
                        src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/24h-icon_535cc43.webp"
                        alt="friendLink-24h-icon"
                      />
                    </div>
                    <div className="mob-news mob-header-icon">
                      <a
                        href="/member/mailbox/news"
                        className=""
                        title="ข่าวใหม่ล่าสุด"
                      >
                        <div className="new-icon">
                          <img
                            src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/note-icon_6556c0e.webp"
                            alt="ข่าวใหม่ล่าสุด"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="login-box">
                  <div className="login-after">
                    <ul className="money-item">
                      <li className="deposit-btn">
                        <a
                          href="/member/deposit"
                          className=""
                          title="ศูนย์ฝากถอน"
                          data-analytics="dpst-link"
                        >
                          <span>ศูนย์ฝากถอน</span>
                        </a>
                      </li>
                      <li className="refreshBtn-block">
                        <i>
                          <img
                            src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/refresh-icon_ad88b9e.webp"
                            alt="รีเฟรช"
                            className=""
                          />
                        </i>
                      </li>
                      <li className="total-item">
                        <div
                          title="ยอดเงินกระเป๋า"
                          className="total-item-content"
                        >
                          <sup>฿</sup>
                          <span>0.00</span>
                        </div>
                      </li>
                    </ul>
                    <ul className="info-item web_view">
                      <li>
                        <span className="username">{username}</span>
                        <div className="level">
                          <img
                            src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/rank-crown_97b552b.webp"
                            alt="member-level"
                          />
                          <div className="vip">
                            <span>VIP</span>
                            <b>2</b>
                          </div>
                        </div>
                        {/**/}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/**/}
        </header>
        <div data-v-76ae500c="" id="mob-menu">
          <div
            data-v-76ae500c=""
            className="mob-menu-wrapper isLogin"
            style={{ display: "none", top: 90, maxHeight: 577 }}
          >
            <div data-v-76ae500c="" className="user-info">
              <img
                data-v-76ae500c=""
                src="data:image/webp;base64,UklGRg4BAABXRUJQVlA4TAEBAAAvLMALEK8gFkzmL90Xw/zPP0G2Ld4JXoJJmmo7BjUAABybBwAAOIxsNW6+kHxfkYH+i7WTfKggov8TgP/bcau73eeA+NX8Rz0lpqr/qWPE6MSVNzt1ZYmTF5KyTCiT0w+K8qwQxAMnwhRxEraITrgiNFcnbLmGiI1QIhoBnadgNt5IwcFScItyTEgQZVgFXfQ/rYjc/jkKYmXTb3Y0JKzTdp7H3JBSahumaZpaK0Ht6OY/Wz8GVlnNqXoKYzXn7/KP3B6q9bdqHr380jzh+k0sgw9vRT2lycvuSftDPG0DcOXpgHjihinThk+mjjuTwTK5eC5LVXsmRbVEIyCX5bDeAAA="
                alt="profile-icon"
                className="icon"
              />
              <div data-v-76ae500c="" className="name">
                {username}
              </div>
            </div>
            <div data-v-76ae500c="" className="menu-item-list">
              <div data-v-76ae500c="" className="menu-item">
                <a data-v-76ae500c="" href="/myCollection" className="">
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/my-collection-icon_7cd9716.webp"
                    alt="เกมโปรด"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">เกมโปรด</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a data-v-76ae500c="" href="/slotgame" className="">
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/slotgame-btn_b4689c7.webp"
                    alt="สล็อต"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">สล็อต</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a data-v-76ae500c="" href="/livegame" className="">
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/livegame-btn_b8ffcd1.webp"
                    alt="คาสิโนสด"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">คาสิโนสด</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a data-v-76ae500c="" href="/fishergame" className="">
                  <img
                    data-v-76ae500c=""
                    src="data:image/webp;base64,UklGRogDAABXRUJQVlA4WAoAAAAYAAAAYwAAYwAAVlA4TB4DAAAvY8AYEJXQkSTJkSTV/z+tRBfqyiB37/ww8AEREgAALBspZ9u2bdu2bdu2bdvG27Zt25jLCcgPaPX445UrtiKbM4nRqMEPv1zUw5/QVHHtYNcTY9wwjaTwXFu/TXHBOA+FS219V4l3mvx3Q+u/dmLDGLulRdWJbRTRN7WeMJqE2m0Fq8M4B3rE21qPzWmWwR7/CHHnDfveWhBJeD0bb2sLc1Y8rsW0PqEtki7CS8l/SIv4SWAhsY9p/deAZxk+D2p9YLsIaccfVejfGBf4ko3Qp7tO8XE0Xe2Cn/weJgWlS0JEniNFnRYJzG/AZQW+KlTyKX/aglzRyQ/fPXQ878LyzkC6j2zy9xsEoXRpJSdAB22dZXhFMaxrf/M58utMocYInMFotMv7T/XAw1Ot71yOcDnSx4O1saxW0Kl6invP/oXCNGDY+firz+ebJLzP9RPdjporrV1sSfC61uc7n11nz1XBDo9rdfEj+Nzsggb29F5AIPmCA/laXSLjdld0aM/+hdp4ia0bitYlQfRe6ICulPOLkDtW9fV/XDgF+wK/7BnmDSQYvR2jhf7ROxUkibRBbvbh7w0kWH0crkKThNd0rr7E3HBl+oLX9+EsvTAED6cuCRYPOzsqkSRaOrzpJKRB09HaQGKgwzuR5G+U6TglUdzhbSeJ63c4NwkCySSke6Oq6BpEbpKIugZTnET3GG5jeNF3Ce23vOocAsoor19XvGKQfeUzKMmulxcs49nAseQ/BjCXfcRTHrHPaX5Iy7mE5QB8whNpmHKRvo+LeUc4h2h7SHY55kZiri+FQDvHjnngsYvW5DLCuIF7sRhZyA/Gea7Qz1W8oZwnU3JlDXeJbeDZGJSgLuA07jyehnNPg2jDnBVF+PIoDxhmUZyKfX8MSN3XBtbFLv/7Ga7SztpYZfn8vt+4Z33Db/rXCttMaOcdaI7JILCBGV25y2/HNfHGuYExPbgC1iBDkhgef+PbwKxeXkDhlZF9OIfAbgMze3XKXWobGNqTEzC9WDK1O0cuMdnA3E7suSEgk1uCt/5ZYLGB2f93TQ8PrBv4UTRFWElGRAAAAE1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAGSgAwAEAAAAAQAAAGQAAAAA"
                    alt="ยิงปลา"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">ยิงปลา</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a data-v-76ae500c="" href="/sportgame" className="">
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/sportgame-btn_8571a92.webp"
                    alt="กีฬา"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">กีฬา</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a data-v-76ae500c="" href="/cockfightinggame" className="">
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/cockfightinggame-btn_0fda5ff.webp"
                    alt="ไก่ชน"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">ไก่ชน</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a data-v-76ae500c="" href="/othergame" className="">
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/othergame-btn_3040920.webp"
                    alt="เกมอื่นๆ"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">เกมอื่นๆ</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a data-v-76ae500c="" href="/promotion" className="">
                  <img
                    data-v-76ae500c=""
                    src="data:image/webp;base64,UklGRmgDAABXRUJQVlA4WAoAAAAYAAAAYwAAYwAAVlA4TP0CAAAvY8AYEHVQkm3bbttg/pNejXfxewadpJWLB1y8CDgAAJaRcubbNkbbtm3/TzZWbbZt2/+jbdu2+tdMQJ6JV4hOS278urSgTyLxBRz+StRnweUoS/O7F/BHkjMEBTeaZ3jMHLUR+pLrD5MaaO1UjmXfq7x2zoGpM+I2ar9lbHvmqP023q7IegCPNItpG6avjvQwO8JmH1z37uxbK53bZq1/41urG1s/Biu2IhjfAjKx8TYdFc8tBcaD91xAJj7BVqMy0A3zCv0Ihc14ioUGnvCu3Z6CKRZ2AfF83qCYdTKtBj5pLmCrqKAUrt0VisytNEdgdfZBBwy55nYNgT+iEVF/wVjAdq5B3X3IDAznTlwemlIZqazWw9yRI5DZh/2A7p4UFkAINM8XzNxLN7i7gMdo3MPuQnbZlPTmqfYdu6b75obvgWC1phawX0TgAWUBiVLBs4D9ppoi2APFQMsB6F6aEpj5VutlHHAHFHsgExg+IGUF5heQI5C1gAMNB3cP2AL7R5DAaIr8W+09jrAfzB7SdVOkD0hDgeIK3jyQdLUzu9QQyDqCfeAtg/sIWcHog3vgl+wB8K6aeDwHTL/B3QeCy6bsYtuXUrfM3I/NLti+dx8pOijbpPYRwVi7x77PdoVvdvpYDsqXDPx70uDal3vxy/AFhuM5DoaacBmytxqOqqAWNcmV3ZINpJhae0Ywv/bWZBEKrhqWvVWGcGowa3CCnYOnMwsc1MYveOt054LhAmzGwA7/nCpjMzORzdW1lbmRqaCurp4kDbk+CGnpdX0lzeIvsOjxFzz1C7r9r8nvLxhOfoETnb9g8voFA97e9T3wSR9ydZAnMwX4v7aH/wJaRk6uzAmjjJGEGvVyTV6MPki5GRX7uQhH3djPRc0/8oBL/pcAFvvp91E39tPnFpLg6cyOeut0kv/3icB1PVvgMa7qhtuSFq7KzAI2S7oqUdswu78m5yjbkhP0iiCMcq+oeT1+eeV+Vk6vxhq1PBJJgD5n/q7Cl0MNHGAXsBEARVhJRkQAAABNTQAqAAAACAABh2kABAAAAAEAAAAaAAAAAAADoAEAAwAAAAEAAQAAoAIABAAAAAEAAABkoAMABAAAAAEAAABkAAAAAA=="
                    alt="โปรโมชั่น"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">โปรโมชั่น</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a
                  data-v-76ae500c=""
                  href="/member/referral/invite"
                  className=""
                >
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/invite-icon_81810f8.webp"
                    alt="เชิญเพื่อน"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">เชิญเพื่อน</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a
                  data-v-76ae500c=""
                  href="/member/referral/profit"
                  className=""
                >
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/recommend-profit-icon_d2b2296.webp"
                    alt="โปรโมทแบ่งปันกำไร"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">โปรโมทแบ่งปันกำไร</span>
                  </div>
                </a>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <div data-v-76ae500c="" className="content">
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/lucky-draw-icon_5bfdaa2.webp"
                    alt="จับฉลากชิงโชค"
                    className="white"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">จับฉลากชิงโชค</span>
                  </div>
                </div>
              </div>
              <div data-v-76ae500c="" className="menu-item">
                <a data-v-76ae500c="" href="/article" className="">
                  <img
                    data-v-76ae500c=""
                    src="https://download.ocms.cloud/v2/ho/webContentIcon/icon_img.png"
                    alt="สารพันน่ารู้"
                    className="custom-icon"
                  />
                  <div data-v-76ae500c="" className="text">
                    <span data-v-76ae500c="">สารพันน่ารู้</span>
                  </div>
                </a>
              </div>
            </div>
            <div data-v-76ae500c="" className="btn-row">
              <div data-v-76ae500c="" className="lang-btn active">
                <img
                  data-v-76ae500c=""
                  src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/langselect-btn_58619ca.webp"
                  alt="ภาษา"
                />
                <span data-v-76ae500c="">ภาษา</span>
              </div>
              <div data-v-76ae500c="" className="info-btn">
                <img
                  data-v-76ae500c=""
                  src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/otherpage-btn_fbeb20a.webp"
                  alt="ข้อมูล"
                />
                <span data-v-76ae500c="">ข้อมูล</span>
              </div>
            </div>
            <div data-v-76ae500c="" className="lang-list">
              <li data-v-76ae500c="" className="lang-icon item active">
                <div className="lang-content">
                  <img
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/th_b8957b4.webp"
                    alt="flag-th"
                  />
                  <div>ภาษาไทย</div>
                </div>
              </li>
              <li data-v-76ae500c="" className="lang-icon item">
                <div className="lang-content">
                  <img
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/en_12a0ac5.webp"
                    alt="flag-en"
                  />
                  <div>English</div>
                </div>
              </li>
            </div>
            {/**/}
            <ul data-v-76ae500c="" className="service-box">
              <li>
                <div className="social-btn-block mob-friendlink-nav customerService">
                  <img
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/24h-icon_535cc43.webp"
                    alt=""
                  />
                  <span />
                  {/**/}
                </div>
              </li>
              <li>
                <div className="social-btn-block mob-friendlink-nav downloadLink">
                  <img
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/app-icon_f168288.webp"
                    alt=""
                  />
                  <span />
                  {/**/}
                </div>
              </li>
              <li>
                <div className="social-btn-block mob-friendlink-nav สมัครสมาชิก">
                  <img
                    src="https://download.ocms.cloud/v2/HO/Community.1?version=11"
                    alt=""
                  />
                  <span />
                  {/**/}
                </div>
              </li>
              <li>
                <div className="social-btn-block mob-friendlink-nav ฝาก-ถอน">
                  <img
                    src="https://download.ocms.cloud/v2/HO/Community.2?version=17"
                    alt=""
                  />
                  <span />
                  {/**/}
                </div>
              </li>
              <li>
                <div className="social-btn-block mob-friendlink-nav ติดตามข่าวสาร">
                  <img
                    src="https://download.ocms.cloud/v2/HO/Community.4.webp?version=6"
                    alt=""
                  />
                  <span />
                  {/**/}
                </div>
              </li>
              <li>
                <div className="social-btn-block mob-friendlink-nav ติดต่อแอดมิน">
                  <img
                    src="https://download.ocms.cloud/v2/HO/Community.5.gif?version=1"
                    alt=""
                  />
                  <span />
                  {/**/}
                </div>
              </li>
            </ul>
            <div data-v-76ae500c="" className="bottom-row">
              <div data-v-76ae500c="" className="logout">
                <div data-v-76ae500c="" className="logout-icon">
                  <svg
                    data-v-76ae500c=""
                    width="100%"
                    height="100%"
                    viewBox="0 0 100 100"
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M64.0162 10.3246L63.2378 10.0003V10H25.9194C25.6886 10.0567 25.4578 10.1096 25.227 10.1625C24.9676 10.2219 24.7081 10.2814 24.4486 10.3463C19.5405 11.6003 15.8649 15.7084 15.1514 20.7246L15.1513 20.7247C15.1081 20.8976 15.0649 21.0706 15 21.2436V78.7571C15.0405 78.9461 15.0789 79.1351 15.1172 79.3234C15.2014 79.7384 15.2851 80.1501 15.3892 80.5517C16.6 85.4381 20.6216 89.0922 25.573 89.849C25.7241 89.8921 25.8752 89.9353 26.0048 90H63.2383C63.3246 89.9353 63.411 89.8921 63.4973 89.849C65.1622 89.3733 66.2865 87.8382 66.2216 86.1084C66.1568 84.0544 64.427 82.4327 62.3514 82.4976H27.9081C27.5838 82.5192 27.2811 82.5192 26.9784 82.4976C24.2108 82.2382 22.1784 79.7949 22.4378 77.0273V22.9949C22.4162 22.6706 22.4162 22.3679 22.4378 22.0436C22.6973 19.276 25.1405 17.2436 27.9081 17.503H61.8973H62.7405C64.1243 17.4165 65.3568 16.5517 65.9189 15.276C66.7622 13.3733 65.9189 11.1679 64.0162 10.3246ZM84.1892 50.6706V49.4165V49.3733C83.8432 48.3138 83.2162 47.3625 82.373 46.6273C77.638 41.8924 72.9247 37.1359 68.2114 32.3793L68.2108 32.3787C67.9121 32.0799 67.6172 31.7792 67.3227 31.4789C66.6369 30.7794 65.9531 30.0821 65.227 29.4165C63.8216 28.0976 61.6378 28.076 60.2108 29.3733C58.6757 30.7787 58.5676 33.1787 59.973 34.7138C59.9938 34.7347 60.0147 34.7578 60.0363 34.7817C60.0818 34.8321 60.1305 34.8861 60.1892 34.93C63.6919 38.476 67.1946 42.0219 70.7189 45.5463C70.8524 45.6798 70.9758 45.8133 71.1378 45.9887C71.212 46.069 71.2942 46.158 71.3892 46.2598H48.6865C47.9506 46.2598 47.217 46.2574 46.4843 46.255C45.0212 46.2502 43.5614 46.2454 42.0919 46.2598C40.0162 46.303 38.3946 48.0327 38.4378 50.1084C38.4811 52.1841 40.2108 53.8057 42.2865 53.7625H42.3514H71.4108C71.3247 53.8548 71.2473 53.9383 71.1762 54.015C70.9974 54.2081 70.8582 54.3584 70.7189 54.4976L61.0108 64.2922C60.9247 64.3784 60.8372 64.4645 60.7493 64.551C60.4845 64.8118 60.2165 65.0756 59.973 65.3517C59.0432 66.3463 58.7405 67.7733 59.2162 69.0706C59.6054 70.3679 60.7081 71.3409 62.0703 71.5571C63.4108 71.7949 64.7514 71.2976 65.6378 70.2814C71.1946 64.6598 76.773 59.0382 82.373 53.4382C83.2162 52.703 83.8432 51.7517 84.1892 50.6706Z"
                    />
                  </svg>
                </div>
                <span data-v-76ae500c="">ออกจากระบบ</span>
              </div>
            </div>
          </div>
          {/**/}
        </div>
        <section data-v-077a4955="" data_vue_tag="Wallet">
          <div
            data-v-077a4955=""
            className="balancelist-fixed"
            style={{ display: "none" }}
            data_vue_tag="transition"
          >
            <div data-v-077a4955="" className="balancelist-wrapper">
              <div data-v-077a4955="" className="balancelist-bg">
                <div
                  data-v-077a4955=""
                  className="tabs-wrapper"
                  data_vue_tag="WalletTab"
                >
                  <ul className="tabs-lists notEnough">
                    <li className="tabs-list tabs-wallet active">
                      <a className="tabs-tab">
                        <div className="icon-img rounded">
                          <img src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/wallet-icon_a195b2f.webp" />
                        </div>
                        <p className="title">กระเป๋าสตางค์</p>
                        <p className="price">0.00</p>
                      </a>
                    </li>
                    <li className="tabs-list tabs-reward">
                      <a className="tabs-tab">
                        <div
                          data-v-fdd16a7e=""
                          id="pointIcon"
                          className="icon-img point-icon rounded"
                        >
                          <img
                            data-v-fdd16a7e=""
                            src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                          />
                        </div>
                        <p className="title">คืนแต้ม</p>
                        <p className="price">0</p>
                      </a>
                    </li>
                  </ul>
                </div>
                <div data-v-077a4955="" className="tabs-content">
                  <div data-v-077a4955="" className="tabs-content-panel open">
                    <div data-v-077a4955="" className="balancelist-header">
                      <div data-v-077a4955="" className="balancelist-total">
                        <div data-v-077a4955="" className="balancelist-title">
                          <div data-v-077a4955="" className="group">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/wallet-icon_a195b2f.webp"
                              alt="กระเป๋าสตางค์"
                            />
                            <span data-v-077a4955="">กระเป๋าสตางค์</span>
                          </div>
                        </div>
                        <h3 data-v-077a4955="" className="balancelist-price">
                          <span data-v-077a4955="">฿ 0.00</span>
                          <i data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/refresh-icon_ad88b9e.webp"
                              alt="รีเฟรช"
                              className=""
                              style={{ animationDuration: "1s" }}
                            />
                          </i>
                        </h3>
                        <ul data-v-077a4955="" className="balancelist-btn">
                          <li data-v-077a4955="">
                            <a
                              data-v-077a4955=""
                              href="/member/deposit"
                              className="btn btn-deposit"
                              title="ฝากเงิน"
                              data-analytics="dpst-link"
                              data_vue_tag="nuxt-link"
                            >
                              ฝากเงิน
                            </a>
                          </li>
                          <li data-v-077a4955="">
                            <a
                              data-v-077a4955=""
                              href="/member/withdraw"
                              className="btn btn-withdrawal"
                              title="ถอนเงิน"
                              data_vue_tag="nuxt-link"
                            >
                              ถอนเงิน
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div data-v-077a4955="" className="balancelist-content">
                      {/**/}
                      <div
                        data-v-077a4955=""
                        className="platform-list only-main-wallet"
                        data_vue_tag="transition"
                      >
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src={this.state.logoimg}
                                alt="เงินเหลือบัญชีหลัก"
                              />
                              <span data-v-077a4955="">เงินเหลือบัญชีหลัก</span>
                            </li>
                            <li data-v-077a4955="">{balance}</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.2.4?version=1533621019"
                                alt="PT"
                              />
                              <span data-v-077a4955="">PT</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.11.4.png?version=1533620969"
                                alt="SA"
                              />
                              <span data-v-077a4955="">SA</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/common2/Platform.15.4.png?version=1533620938"
                                alt="HB"
                              />
                              <span data-v-077a4955="">HB</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.22.4?version=1533620918"
                                alt="SEXY"
                              />
                              <span data-v-077a4955="">SEXY</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.23.4.webp?version=1533620899"
                                alt="PA"
                              />
                              <span data-v-077a4955="">PA</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.32.4?version=2"
                                alt="NT"
                              />
                              <span data-v-077a4955="">NT</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.33.4.png?version=2"
                                alt="PNG"
                              />
                              <span data-v-077a4955="">PNG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/common2/Platform.37.4.png?version=1"
                                alt="SG"
                              />
                              <span data-v-077a4955="">SG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.38.4?version=0"
                                alt="BTI"
                              />
                              <span data-v-077a4955="">BTI</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/common2/Platform.39.4.png?version=1"
                                alt="CQ9"
                              />
                              <span data-v-077a4955="">CQ9</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/common2/Platform.40.4.png?version=0"
                                alt="EVO"
                              />
                              <span data-v-077a4955="">EVO</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.51.4.png?version=0"
                                alt="MG"
                              />
                              <span data-v-077a4955="">MG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/common2/Platform.52.4.png?version=0"
                                alt="DG"
                              />
                              <span data-v-077a4955="">DG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/common2/Platform.54.4.png?version=0"
                                alt="KA"
                              />
                              <span data-v-077a4955="">KA</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/common2/Platform.55.4.png?version=0"
                                alt="JOKER"
                              />
                              <span data-v-077a4955="">JOKER</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.63.4?version=0"
                                alt="RSG"
                              />
                              <span data-v-077a4955="">RSG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.64.4?version=1"
                                alt="WM"
                              />
                              <span data-v-077a4955="">WM</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/common2/Platform.68.4.png?version=0"
                                alt="YGG"
                              />
                              <span data-v-077a4955="">YGG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.70.4?version=1"
                                alt="R88"
                              />
                              <span data-v-077a4955="">R88</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.71.4?version=1"
                                alt="PS"
                              />
                              <span data-v-077a4955="">PS</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.73.4?version=0"
                                alt="SABA"
                              />
                              <span data-v-077a4955="">SABA</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.75.4.webp?version=2"
                                alt="EZ"
                              />
                              <span data-v-077a4955="">EZ</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.78.4?version=0"
                                alt="BB"
                              />
                              <span data-v-077a4955="">BB</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/common2/Platform.81.4.png?version=0"
                                alt="EVOPLAY"
                              />
                              <span data-v-077a4955="">EVOPLAY</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.85.4?version=0"
                                alt="BP"
                              />
                              <span data-v-077a4955="">BP</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.86.4.webp?version=2"
                                alt="GCLUB"
                              />
                              <span data-v-077a4955="">GCLUB</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.91.4?version=0"
                                alt="CMD"
                              />
                              <span data-v-077a4955="">CMD</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.93.4.png?version=0"
                                alt="PG"
                              />
                              <span data-v-077a4955="">PG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.95.4?version=0"
                                alt="RELAX"
                              />
                              <span data-v-077a4955="">RELAX</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.97.4?version=0"
                                alt="UG"
                              />
                              <span data-v-077a4955="">UG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.98.4?version=1"
                                alt="SBO"
                              />
                              <span data-v-077a4955="">SBO</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.105.4?version=0"
                                alt="DIGITAIN"
                              />
                              <span data-v-077a4955="">DIGITAIN</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.106.4?version=0"
                                alt="I8"
                              />
                              <span data-v-077a4955="">I8</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.107.4.png?version=1"
                                alt="PP"
                              />
                              <span data-v-077a4955="">PP</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.108.4.png?version=1533621035"
                                alt="JDB"
                              />
                              <span data-v-077a4955="">JDB</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.110.4.png?version=0"
                                alt="JILI"
                              />
                              <span data-v-077a4955="">JILI</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.114.4?version=0"
                                alt="MT"
                              />
                              <span data-v-077a4955="">MT</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.118.4?version=0"
                                alt="HS"
                              />
                              <span data-v-077a4955="">HS</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.119.4.png?version=0"
                                alt="FC"
                              />
                              <span data-v-077a4955="">FC</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.122.4.webp?version=1"
                                alt="AE"
                              />
                              <span data-v-077a4955="">AE</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.123.4?version=0"
                                alt="DELI"
                              />
                              <span data-v-077a4955="">DELI</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.125.4?version=0"
                                alt="SPB"
                              />
                              <span data-v-077a4955="">SPB</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.127.4?version=0"
                                alt="TVBET"
                              />
                              <span data-v-077a4955="">TVBET</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.128.4?version=0"
                                alt="BGAMING"
                              />
                              <span data-v-077a4955="">BGAMING</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.129.4.webp?version=1"
                                alt="AP"
                              />
                              <span data-v-077a4955="">AP</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.130.4?version=1"
                                alt="WE"
                              />
                              <span data-v-077a4955="">WE</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.131.4?version=0"
                                alt="HRLIVE"
                              />
                              <span data-v-077a4955="">HRLIVE</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.132.4?version=0"
                                alt="BETGAMES"
                              />
                              <span data-v-077a4955="">BETGAMES</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.134.4?version=0"
                                alt="T1GAMES"
                              />
                              <span data-v-077a4955="">T1GAMES</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.135.4?version=0"
                                alt="FS"
                              />
                              <span data-v-077a4955="">FS</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.136.4?version=0"
                                alt="VR"
                              />
                              <span data-v-077a4955="">VR</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.137.4?version=0"
                                alt="V8"
                              />
                              <span data-v-077a4955="">V8</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.138.4?version=0"
                                alt="WMS"
                              />
                              <span data-v-077a4955="">WMS</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.140.4?version=0"
                                alt="BTG"
                              />
                              <span data-v-077a4955="">BTG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.143.4?version=0"
                                alt="BG"
                              />
                              <span data-v-077a4955="">BG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.144.4?version=0"
                                alt="AUX"
                              />
                              <span data-v-077a4955="">AUX</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.145.4?version=0"
                                alt="MJ"
                              />
                              <span data-v-077a4955="">MJ</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.157.4?version=0"
                                alt="SW"
                              />
                              <span data-v-077a4955="">SW</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.162.4?version=0"
                                alt="NS"
                              />
                              <span data-v-077a4955="">NS</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.168.4?version=0"
                                alt="DB"
                              />
                              <span data-v-077a4955="">DB</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.171.4?version=0"
                                alt="RT"
                              />
                              <span data-v-077a4955="">RT</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.174.4.png?version=0"
                                alt="VIA"
                              />
                              <span data-v-077a4955="">VIA</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.181.4?version=0"
                                alt="SV388"
                              />
                              <span data-v-077a4955="">SV388</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.183.4?version=0"
                                alt="HRB"
                              />
                              <span data-v-077a4955="">HRB</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.184.4?version=0"
                                alt="PLAY8"
                              />
                              <span data-v-077a4955="">PLAY8</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.185.4.png?version=0"
                                alt="DS"
                              />
                              <span data-v-077a4955="">DS</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.187.4.webp?version=1"
                                alt="KM"
                              />
                              <span data-v-077a4955="">KM</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.190.4.png?version=0"
                                alt="LS"
                              />
                              <span data-v-077a4955="">LS</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.197.4.png?version=0"
                                alt="BNG"
                              />
                              <span data-v-077a4955="">BNG</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.199.4.png?version=0"
                                alt="NLC"
                              />
                              <span data-v-077a4955="">NLC</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.200.4.webp?version=0"
                                alt="VA"
                              />
                              <span data-v-077a4955="">VA</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.202.4.webp?version=0"
                                alt="VP"
                              />
                              <span data-v-077a4955="">VP</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.204.4.webp?version=0"
                                alt="AW"
                              />
                              <span data-v-077a4955="">AW</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.209.4.webp?version=0"
                                alt="OCTOPLAY"
                              />
                              <span data-v-077a4955="">OCTOPLAY</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.211.4.webp?version=0"
                                alt="ALIZE"
                              />
                              <span data-v-077a4955="">ALIZE</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.213.4.webp?version=0"
                                alt="SABAPLAY"
                              />
                              <span data-v-077a4955="">SABAPLAY</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.214.4.png?version=0"
                                alt="1BET"
                              />
                              <span data-v-077a4955="">1BET</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.301.4.png?version=0"
                                alt="FUNKY"
                              />
                              <span data-v-077a4955="">FUNKY</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          {/**/}
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.328.4.png?version=0"
                                alt="SS"
                              />
                              <span data-v-077a4955="">SS</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          <div data-v-077a4955="" className="maintain-block">
                            <div data-v-077a4955="" className="maintain-center">
                              <i data-v-077a4955="" className="fa fa-wrench" />
                              <p data-v-077a4955="">
                                ระบบกำลังอยู่ในระหว่างการปรับปรุง
                              </p>
                            </div>
                          </div>
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.126.4?version=0"
                                alt="ZITRO"
                              />
                              <span data-v-077a4955="">ZITRO</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          <div data-v-077a4955="" className="maintain-block">
                            <div data-v-077a4955="" className="maintain-center">
                              <i data-v-077a4955="" className="fa fa-wrench" />
                              <p data-v-077a4955="">
                                ระบบกำลังอยู่ในระหว่างการปรับปรุง
                              </p>
                            </div>
                          </div>
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.179.4?version=0"
                                alt="TP"
                              />
                              <span data-v-077a4955="">TP</span>
                            </li>
                            <li data-v-077a4955="">0.00</li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          <div data-v-077a4955="" className="maintain-block">
                            <div data-v-077a4955="" className="maintain-center">
                              <i data-v-077a4955="" className="fa fa-wrench" />
                              <p data-v-077a4955="">
                                ระบบกำลังอยู่ในระหว่างการปรับปรุง
                              </p>
                            </div>
                          </div>
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.35.4?version=0"
                                alt="QS"
                              />
                              <span data-v-077a4955="">QS</span>
                            </li>
                            <li data-v-077a4955="">
                              ระบบกำลังอยู่ในระหว่างการปรับปรุง
                            </li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          <div data-v-077a4955="" className="maintain-block">
                            <div data-v-077a4955="" className="maintain-center">
                              <i data-v-077a4955="" className="fa fa-wrench" />
                              <p data-v-077a4955="">
                                ระบบกำลังอยู่ในระหว่างการปรับปรุง
                              </p>
                            </div>
                          </div>
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.44.4?version=1"
                                alt="WAMA"
                              />
                              <span data-v-077a4955="">WAMA</span>
                            </li>
                            <li data-v-077a4955="">
                              ระบบกำลังอยู่ในระหว่างการปรับปรุง
                            </li>
                          </ul>
                        </div>
                        <div data-v-077a4955="" className="balancelist-item">
                          <div data-v-077a4955="" className="maintain-block">
                            <div data-v-077a4955="" className="maintain-center">
                              <i data-v-077a4955="" className="fa fa-wrench" />
                              <p data-v-077a4955="">
                                ระบบกำลังอยู่ในระหว่างการปรับปรุง
                              </p>
                            </div>
                          </div>
                          <ul data-v-077a4955="">
                            <li data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v2/HO/Platform.104.4?version=0"
                                alt="PUSH"
                              />
                              <span data-v-077a4955="">PUSH</span>
                            </li>
                            <li data-v-077a4955="">
                              ระบบกำลังอยู่ในระหว่างการปรับปรุง
                            </li>
                          </ul>
                        </div>
                      </div>
                      {/**/}
                    </div>
                  </div>
                  <div
                    data-v-077a4955=""
                    className="tabs-content-panel"
                    style={{ display: "none" }}
                  >
                    <div data-v-077a4955="" className="balancelist-header">
                      <div data-v-077a4955="" className="balancelist-total">
                        <div data-v-077a4955="" className="balancelist-title">
                          <div data-v-077a4955="" className="group">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/loyal-icon_c81c3d1.webp"
                              alt="loyal-credit"
                            />
                            <span data-v-077a4955="">LOYAL CREDIT</span>
                          </div>
                        </div>
                        <h3 data-v-077a4955="" className="balancelist-price">
                          <span data-v-077a4955="">12,345,678.99</span>
                          <i data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/refresh-icon_ad88b9e.webp"
                              alt="รีเฟรช"
                              className=""
                              style={{ animationDuration: "1s" }}
                            />
                          </i>
                        </h3>
                      </div>
                    </div>
                    <div data-v-077a4955="" className="balancelist-content">
                      <div data-v-077a4955="" className="balancelist-item">
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/balance-main_30e9dc6.webp"
                              alt="บัญชีหลัก"
                            />
                            <span data-v-077a4955="">บัญชีหลัก</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div
                        data-v-077a4955=""
                        className="balancelist-item promote-lock"
                      >
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/balance-promotion_18a2388.webp"
                              alt="กระเป๋าเงินโบนัส"
                            />
                            <span data-v-077a4955="">กระเป๋าเงินโบนัส</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              alt="common.game.brand.all"
                            />
                            <span data-v-077a4955="">
                              common.game.brand.all
                            </span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.2.4?version=1533621019"
                              alt="PT"
                            />
                            <span data-v-077a4955="">PT</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.11.4.png?version=1533620969"
                              alt="SA"
                            />
                            <span data-v-077a4955="">SA</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/common2/Platform.15.4.png?version=1533620938"
                              alt="HB"
                            />
                            <span data-v-077a4955="">HB</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.22.4?version=1533620918"
                              alt="SEXY"
                            />
                            <span data-v-077a4955="">SEXY</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.23.4.webp?version=1533620899"
                              alt="PA"
                            />
                            <span data-v-077a4955="">PA</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.32.4?version=2"
                              alt="NT"
                            />
                            <span data-v-077a4955="">NT</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.33.4.png?version=2"
                              alt="PNG"
                            />
                            <span data-v-077a4955="">PNG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/common2/Platform.37.4.png?version=1"
                              alt="SG"
                            />
                            <span data-v-077a4955="">SG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.38.4?version=0"
                              alt="BTI"
                            />
                            <span data-v-077a4955="">BTI</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/common2/Platform.39.4.png?version=1"
                              alt="CQ9"
                            />
                            <span data-v-077a4955="">CQ9</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/common2/Platform.40.4.png?version=0"
                              alt="EVO"
                            />
                            <span data-v-077a4955="">EVO</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.51.4.png?version=0"
                              alt="MG"
                            />
                            <span data-v-077a4955="">MG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/common2/Platform.52.4.png?version=0"
                              alt="DG"
                            />
                            <span data-v-077a4955="">DG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/common2/Platform.54.4.png?version=0"
                              alt="KA"
                            />
                            <span data-v-077a4955="">KA</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/common2/Platform.55.4.png?version=0"
                              alt="JOKER"
                            />
                            <span data-v-077a4955="">JOKER</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.63.4?version=0"
                              alt="RSG"
                            />
                            <span data-v-077a4955="">RSG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.64.4?version=1"
                              alt="WM"
                            />
                            <span data-v-077a4955="">WM</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/common2/Platform.68.4.png?version=0"
                              alt="YGG"
                            />
                            <span data-v-077a4955="">YGG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.70.4?version=1"
                              alt="R88"
                            />
                            <span data-v-077a4955="">R88</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.71.4?version=1"
                              alt="PS"
                            />
                            <span data-v-077a4955="">PS</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.73.4?version=0"
                              alt="SABA"
                            />
                            <span data-v-077a4955="">SABA</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.75.4.webp?version=2"
                              alt="EZ"
                            />
                            <span data-v-077a4955="">EZ</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.78.4?version=0"
                              alt="BB"
                            />
                            <span data-v-077a4955="">BB</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/common2/Platform.81.4.png?version=0"
                              alt="EVOPLAY"
                            />
                            <span data-v-077a4955="">EVOPLAY</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.85.4?version=0"
                              alt="BP"
                            />
                            <span data-v-077a4955="">BP</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.86.4.webp?version=2"
                              alt="GCLUB"
                            />
                            <span data-v-077a4955="">GCLUB</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.91.4?version=0"
                              alt="CMD"
                            />
                            <span data-v-077a4955="">CMD</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.93.4.png?version=0"
                              alt="PG"
                            />
                            <span data-v-077a4955="">PG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.95.4?version=0"
                              alt="RELAX"
                            />
                            <span data-v-077a4955="">RELAX</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.97.4?version=0"
                              alt="UG"
                            />
                            <span data-v-077a4955="">UG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.98.4?version=1"
                              alt="SBO"
                            />
                            <span data-v-077a4955="">SBO</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.105.4?version=0"
                              alt="DIGITAIN"
                            />
                            <span data-v-077a4955="">DIGITAIN</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.106.4?version=0"
                              alt="I8"
                            />
                            <span data-v-077a4955="">I8</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.107.4.png?version=1"
                              alt="PP"
                            />
                            <span data-v-077a4955="">PP</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.108.4.png?version=1533621035"
                              alt="JDB"
                            />
                            <span data-v-077a4955="">JDB</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.110.4.png?version=0"
                              alt="JILI"
                            />
                            <span data-v-077a4955="">JILI</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.114.4?version=0"
                              alt="MT"
                            />
                            <span data-v-077a4955="">MT</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.118.4?version=0"
                              alt="HS"
                            />
                            <span data-v-077a4955="">HS</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.119.4.png?version=0"
                              alt="FC"
                            />
                            <span data-v-077a4955="">FC</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.122.4.webp?version=1"
                              alt="AE"
                            />
                            <span data-v-077a4955="">AE</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.123.4?version=0"
                              alt="DELI"
                            />
                            <span data-v-077a4955="">DELI</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.125.4?version=0"
                              alt="SPB"
                            />
                            <span data-v-077a4955="">SPB</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.127.4?version=0"
                              alt="TVBET"
                            />
                            <span data-v-077a4955="">TVBET</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.128.4?version=0"
                              alt="BGAMING"
                            />
                            <span data-v-077a4955="">BGAMING</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.129.4.webp?version=1"
                              alt="AP"
                            />
                            <span data-v-077a4955="">AP</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.130.4?version=1"
                              alt="WE"
                            />
                            <span data-v-077a4955="">WE</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.131.4?version=0"
                              alt="HRLIVE"
                            />
                            <span data-v-077a4955="">HRLIVE</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.132.4?version=0"
                              alt="BETGAMES"
                            />
                            <span data-v-077a4955="">BETGAMES</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.134.4?version=0"
                              alt="T1GAMES"
                            />
                            <span data-v-077a4955="">T1GAMES</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.135.4?version=0"
                              alt="FS"
                            />
                            <span data-v-077a4955="">FS</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.136.4?version=0"
                              alt="VR"
                            />
                            <span data-v-077a4955="">VR</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.137.4?version=0"
                              alt="V8"
                            />
                            <span data-v-077a4955="">V8</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.138.4?version=0"
                              alt="WMS"
                            />
                            <span data-v-077a4955="">WMS</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.140.4?version=0"
                              alt="BTG"
                            />
                            <span data-v-077a4955="">BTG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.143.4?version=0"
                              alt="BG"
                            />
                            <span data-v-077a4955="">BG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.144.4?version=0"
                              alt="AUX"
                            />
                            <span data-v-077a4955="">AUX</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.145.4?version=0"
                              alt="MJ"
                            />
                            <span data-v-077a4955="">MJ</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.157.4?version=0"
                              alt="SW"
                            />
                            <span data-v-077a4955="">SW</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.162.4?version=0"
                              alt="NS"
                            />
                            <span data-v-077a4955="">NS</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.168.4?version=0"
                              alt="DB"
                            />
                            <span data-v-077a4955="">DB</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.171.4?version=0"
                              alt="RT"
                            />
                            <span data-v-077a4955="">RT</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.174.4.png?version=0"
                              alt="VIA"
                            />
                            <span data-v-077a4955="">VIA</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.181.4?version=0"
                              alt="SV388"
                            />
                            <span data-v-077a4955="">SV388</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.183.4?version=0"
                              alt="HRB"
                            />
                            <span data-v-077a4955="">HRB</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.184.4?version=0"
                              alt="PLAY8"
                            />
                            <span data-v-077a4955="">PLAY8</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.185.4.png?version=0"
                              alt="DS"
                            />
                            <span data-v-077a4955="">DS</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.187.4.webp?version=1"
                              alt="KM"
                            />
                            <span data-v-077a4955="">KM</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.190.4.png?version=0"
                              alt="LS"
                            />
                            <span data-v-077a4955="">LS</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.197.4.png?version=0"
                              alt="BNG"
                            />
                            <span data-v-077a4955="">BNG</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.199.4.png?version=0"
                              alt="NLC"
                            />
                            <span data-v-077a4955="">NLC</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.200.4.webp?version=0"
                              alt="VA"
                            />
                            <span data-v-077a4955="">VA</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.202.4.webp?version=0"
                              alt="VP"
                            />
                            <span data-v-077a4955="">VP</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.204.4.webp?version=0"
                              alt="AW"
                            />
                            <span data-v-077a4955="">AW</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.209.4.webp?version=0"
                              alt="OCTOPLAY"
                            />
                            <span data-v-077a4955="">OCTOPLAY</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.211.4.webp?version=0"
                              alt="ALIZE"
                            />
                            <span data-v-077a4955="">ALIZE</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.213.4.webp?version=0"
                              alt="SABAPLAY"
                            />
                            <span data-v-077a4955="">SABAPLAY</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.214.4.png?version=0"
                              alt="1BET"
                            />
                            <span data-v-077a4955="">1BET</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.301.4.png?version=0"
                              alt="FUNKY"
                            />
                            <span data-v-077a4955="">FUNKY</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        {/**/}
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.328.4.png?version=0"
                              alt="SS"
                            />
                            <span data-v-077a4955="">SS</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        <div data-v-077a4955="" className="maintain-block">
                          <div data-v-077a4955="" className="maintain-center">
                            <i data-v-077a4955="" className="fa fa-wrench" />
                            <p data-v-077a4955="">
                              ระบบกำลังอยู่ในระหว่างการปรับปรุง
                            </p>
                          </div>
                        </div>
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.126.4?version=0"
                              alt="ZITRO"
                            />
                            <span data-v-077a4955="">ZITRO</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        <div data-v-077a4955="" className="maintain-block">
                          <div data-v-077a4955="" className="maintain-center">
                            <i data-v-077a4955="" className="fa fa-wrench" />
                            <p data-v-077a4955="">
                              ระบบกำลังอยู่ในระหว่างการปรับปรุง
                            </p>
                          </div>
                        </div>
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.179.4?version=0"
                              alt="TP"
                            />
                            <span data-v-077a4955="">TP</span>
                          </li>
                          <li data-v-077a4955="">0.00</li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        <div data-v-077a4955="" className="maintain-block">
                          <div data-v-077a4955="" className="maintain-center">
                            <i data-v-077a4955="" className="fa fa-wrench" />
                            <p data-v-077a4955="">
                              ระบบกำลังอยู่ในระหว่างการปรับปรุง
                            </p>
                          </div>
                        </div>
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.35.4?version=0"
                              alt="QS"
                            />
                            <span data-v-077a4955="">QS</span>
                          </li>
                          <li data-v-077a4955="">
                            ระบบกำลังอยู่ในระหว่างการปรับปรุง
                          </li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        <div data-v-077a4955="" className="maintain-block">
                          <div data-v-077a4955="" className="maintain-center">
                            <i data-v-077a4955="" className="fa fa-wrench" />
                            <p data-v-077a4955="">
                              ระบบกำลังอยู่ในระหว่างการปรับปรุง
                            </p>
                          </div>
                        </div>
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.44.4?version=1"
                              alt="WAMA"
                            />
                            <span data-v-077a4955="">WAMA</span>
                          </li>
                          <li data-v-077a4955="">
                            ระบบกำลังอยู่ในระหว่างการปรับปรุง
                          </li>
                        </ul>
                      </div>
                      <div data-v-077a4955="" className="balancelist-item">
                        <div data-v-077a4955="" className="maintain-block">
                          <div data-v-077a4955="" className="maintain-center">
                            <i data-v-077a4955="" className="fa fa-wrench" />
                            <p data-v-077a4955="">
                              ระบบกำลังอยู่ในระหว่างการปรับปรุง
                            </p>
                          </div>
                        </div>
                        <ul data-v-077a4955="">
                          <li data-v-077a4955="">
                            <img
                              data-v-077a4955=""
                              src="https://download.ocms.cloud/v2/HO/Platform.104.4?version=0"
                              alt="PUSH"
                            />
                            <span data-v-077a4955="">PUSH</span>
                          </li>
                          <li data-v-077a4955="">
                            ระบบกำลังอยู่ในระหว่างการปรับปรุง
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    data-v-077a4955=""
                    className="tabs-content-panel"
                    style={{ display: "none" }}
                  >
                    <div data-v-077a4955="" className="balancelist-header">
                      <div data-v-077a4955="" className="balancelist-total">
                        <div data-v-077a4955="" className="balancelist-title">
                          <div data-v-077a4955="" className="group">
                            <img
                              data-v-077a4955=""
                              src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                              alt="คืนแต้ม"
                            />
                            <span data-v-077a4955="">คืนแต้ม</span>
                          </div>
                        </div>
                        <h3 data-v-077a4955="" className="balancelist-price">
                          <div data-v-077a4955="" className="group">
                            <span data-v-077a4955="">0</span>
                            <i data-v-077a4955="">
                              <img
                                data-v-077a4955=""
                                src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/refresh-icon_ad88b9e.webp"
                                alt="รีเฟรช"
                                className=""
                                style={{ animationDuration: "1s" }}
                              />
                            </i>
                          </div>
                        </h3>
                        <ul data-v-077a4955="" className="balancelist-btn">
                          <li data-v-077a4955="">
                            <div
                              data-v-077a4955=""
                              className="btn btn-reward btn-reward-redeem active"
                            >
                              รายการแลกเปลี่ยน
                            </div>
                          </li>
                          <li data-v-077a4955="">
                            <div
                              data-v-077a4955=""
                              className="btn btn-reward btn-reward-history"
                            >
                              ประวัติ
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      data-v-077a4955=""
                      className="reward-point-redeem-wrapper"
                      data_vue_tag="WalletRewardPoint"
                    >
                      <div className="reward-point-redeem">
                        <div
                          data-v-0016e830=""
                          className="reward-list-container"
                          data_vue_tag="RewardListStyle1"
                        >
                          <div
                            data-v-0016e830=""
                            className="reward-item-container"
                          >
                            <div data-v-0016e830="" className="box">
                              <div
                                data-v-0016e830=""
                                className="reward-item-left"
                              >
                                <img
                                  data-v-0016e830=""
                                  src="https://download.ocms.cloud/v2/HO/RewardId.9_4.webp?version=0"
                                  className="reward-item-image"
                                />
                              </div>
                              <div
                                data-v-0016e830=""
                                className="reward-item-right"
                              >
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-name"
                                >
                                  💎1,000 พ้อยท์ แลก 💰100 เครดิต
                                </div>
                                {/**/}
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-redeem-button"
                                >
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-icon"
                                  >
                                    <img
                                      data-v-0016e830=""
                                      src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                                      alt=""
                                    />
                                  </div>
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-number"
                                  >
                                    1,000
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-0016e830=""
                              className="reward-item-member-rank-mob"
                            >
                              <span data-v-0016e830="">VIP 2</span>
                              <span data-v-0016e830="">VIP 3</span>
                              <span data-v-0016e830="">VIP 4</span>
                              <span data-v-0016e830="">VIP 5</span>
                              <span data-v-0016e830="">VIP 6</span>
                              <span data-v-0016e830="">VIP 7</span>
                              <span data-v-0016e830="">VIP 8</span>
                              <span data-v-0016e830="">4+</span>
                            </div>
                          </div>
                          <div
                            data-v-0016e830=""
                            className="reward-item-container"
                          >
                            <div data-v-0016e830="" className="box">
                              <div
                                data-v-0016e830=""
                                className="reward-item-left"
                              >
                                <img
                                  data-v-0016e830=""
                                  src="https://download.ocms.cloud/v2/HO/RewardId.10_4.webp?version=0"
                                  className="reward-item-image"
                                />
                              </div>
                              <div
                                data-v-0016e830=""
                                className="reward-item-right"
                              >
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-name"
                                >
                                  💎5,000 พ้อยท์ แลก 💰500 เครดิต
                                </div>
                                {/**/}
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-redeem-button"
                                >
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-icon"
                                  >
                                    <img
                                      data-v-0016e830=""
                                      src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                                      alt=""
                                    />
                                  </div>
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-number"
                                  >
                                    5,000
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-0016e830=""
                              className="reward-item-member-rank-mob"
                            >
                              <span data-v-0016e830="">VIP 2</span>
                              <span data-v-0016e830="">VIP 3</span>
                              <span data-v-0016e830="">VIP 4</span>
                              <span data-v-0016e830="">VIP 5</span>
                              <span data-v-0016e830="">VIP 6</span>
                              <span data-v-0016e830="">VIP 7</span>
                              <span data-v-0016e830="">VIP 8</span>
                              <span data-v-0016e830="">4+</span>
                            </div>
                          </div>
                          <div
                            data-v-0016e830=""
                            className="reward-item-container"
                          >
                            <div data-v-0016e830="" className="box">
                              <div
                                data-v-0016e830=""
                                className="reward-item-left"
                              >
                                <img
                                  data-v-0016e830=""
                                  src="https://download.ocms.cloud/v2/HO/RewardId.11_4.webp?version=0"
                                  className="reward-item-image"
                                />
                              </div>
                              <div
                                data-v-0016e830=""
                                className="reward-item-right"
                              >
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-name"
                                >
                                  💎10,000 พ้อยท์ แลก 💰1,000 เครดิต
                                </div>
                                {/**/}
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-redeem-button"
                                >
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-icon"
                                  >
                                    <img
                                      data-v-0016e830=""
                                      src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                                      alt=""
                                    />
                                  </div>
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-number"
                                  >
                                    10,000
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-0016e830=""
                              className="reward-item-member-rank-mob"
                            >
                              <span data-v-0016e830="">VIP 2</span>
                              <span data-v-0016e830="">VIP 3</span>
                              <span data-v-0016e830="">VIP 4</span>
                              <span data-v-0016e830="">VIP 5</span>
                              <span data-v-0016e830="">VIP 6</span>
                              <span data-v-0016e830="">VIP 7</span>
                              <span data-v-0016e830="">VIP 8</span>
                              <span data-v-0016e830="">4+</span>
                            </div>
                          </div>
                          <div
                            data-v-0016e830=""
                            className="reward-item-container"
                          >
                            <div data-v-0016e830="" className="box">
                              <div
                                data-v-0016e830=""
                                className="reward-item-left"
                              >
                                <img
                                  data-v-0016e830=""
                                  src="https://download.ocms.cloud/v2/HO/RewardId.12_4.webp?version=0"
                                  className="reward-item-image"
                                />
                              </div>
                              <div
                                data-v-0016e830=""
                                className="reward-item-right"
                              >
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-name"
                                >
                                  💎50,000 พ้อยท์ แลก 💰5,000 เครดิต
                                </div>
                                {/**/}
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-redeem-button"
                                >
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-icon"
                                  >
                                    <img
                                      data-v-0016e830=""
                                      src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                                      alt=""
                                    />
                                  </div>
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-number"
                                  >
                                    50,000
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-0016e830=""
                              className="reward-item-member-rank-mob"
                            >
                              <span data-v-0016e830="">VIP 2</span>
                              <span data-v-0016e830="">VIP 3</span>
                              <span data-v-0016e830="">VIP 4</span>
                              <span data-v-0016e830="">VIP 5</span>
                              <span data-v-0016e830="">VIP 6</span>
                              <span data-v-0016e830="">VIP 7</span>
                              <span data-v-0016e830="">VIP 8</span>
                              <span data-v-0016e830="">4+</span>
                            </div>
                          </div>
                          <div
                            data-v-0016e830=""
                            className="reward-item-container"
                          >
                            <div data-v-0016e830="" className="box">
                              <div
                                data-v-0016e830=""
                                className="reward-item-left"
                              >
                                <img
                                  data-v-0016e830=""
                                  src="https://download.ocms.cloud/v2/HO/RewardId.13_4.webp?version=0"
                                  className="reward-item-image"
                                />
                              </div>
                              <div
                                data-v-0016e830=""
                                className="reward-item-right"
                              >
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-name"
                                >
                                  💎100,000 พ้อยท์ แลก 💰10,000 เครดิต
                                </div>
                                {/**/}
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-redeem-button"
                                >
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-icon"
                                  >
                                    <img
                                      data-v-0016e830=""
                                      src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                                      alt=""
                                    />
                                  </div>
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-number"
                                  >
                                    100,000
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-0016e830=""
                              className="reward-item-member-rank-mob"
                            >
                              <span data-v-0016e830="">VIP 2</span>
                              <span data-v-0016e830="">VIP 3</span>
                              <span data-v-0016e830="">VIP 4</span>
                              <span data-v-0016e830="">VIP 5</span>
                              <span data-v-0016e830="">VIP 6</span>
                              <span data-v-0016e830="">VIP 7</span>
                              <span data-v-0016e830="">VIP 8</span>
                              <span data-v-0016e830="">4+</span>
                            </div>
                          </div>
                          <div
                            data-v-0016e830=""
                            className="reward-item-container"
                          >
                            <div data-v-0016e830="" className="box">
                              <div
                                data-v-0016e830=""
                                className="reward-item-left"
                              >
                                <img
                                  data-v-0016e830=""
                                  src="https://download.ocms.cloud/v2/HO/RewardId.6_4.webp?version=0"
                                  className="reward-item-image"
                                />
                              </div>
                              <div
                                data-v-0016e830=""
                                className="reward-item-right"
                              >
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-name"
                                >
                                  💎300,000 พ้อยท์ แลก 💰30,138 เครดิต
                                </div>
                                {/**/}
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-redeem-button"
                                >
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-icon"
                                  >
                                    <img
                                      data-v-0016e830=""
                                      src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                                      alt=""
                                    />
                                  </div>
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-number"
                                  >
                                    300,000
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-0016e830=""
                              className="reward-item-member-rank-mob"
                            >
                              <span data-v-0016e830="">VIP 2</span>
                              <span data-v-0016e830="">VIP 3</span>
                              <span data-v-0016e830="">VIP 4</span>
                              <span data-v-0016e830="">VIP 5</span>
                              <span data-v-0016e830="">VIP 6</span>
                              <span data-v-0016e830="">VIP 7</span>
                              <span data-v-0016e830="">VIP 8</span>
                              <span data-v-0016e830="">4+</span>
                            </div>
                          </div>
                          <div
                            data-v-0016e830=""
                            className="reward-item-container"
                          >
                            <div data-v-0016e830="" className="box">
                              <div
                                data-v-0016e830=""
                                className="reward-item-left"
                              >
                                <img
                                  data-v-0016e830=""
                                  src="https://download.ocms.cloud/v2/HO/RewardId.7_4.webp?version=0"
                                  className="reward-item-image"
                                />
                              </div>
                              <div
                                data-v-0016e830=""
                                className="reward-item-right"
                              >
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-name"
                                >
                                  💎800,000 พ้อยท์ แลก 💰80,388 เครดิต
                                </div>
                                {/**/}
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-redeem-button"
                                >
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-icon"
                                  >
                                    <img
                                      data-v-0016e830=""
                                      src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                                      alt=""
                                    />
                                  </div>
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-number"
                                  >
                                    800,000
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-0016e830=""
                              className="reward-item-member-rank-mob"
                            >
                              <span data-v-0016e830="">VIP 2</span>
                              <span data-v-0016e830="">VIP 3</span>
                              <span data-v-0016e830="">VIP 4</span>
                              <span data-v-0016e830="">VIP 5</span>
                              <span data-v-0016e830="">VIP 6</span>
                              <span data-v-0016e830="">VIP 7</span>
                              <span data-v-0016e830="">VIP 8</span>
                              <span data-v-0016e830="">4+</span>
                            </div>
                          </div>
                          <div
                            data-v-0016e830=""
                            className="reward-item-container"
                          >
                            <div data-v-0016e830="" className="box">
                              <div
                                data-v-0016e830=""
                                className="reward-item-left"
                              >
                                <img
                                  data-v-0016e830=""
                                  src="https://download.ocms.cloud/v2/HO/RewardId.8_4.webp?version=0"
                                  className="reward-item-image"
                                />
                              </div>
                              <div
                                data-v-0016e830=""
                                className="reward-item-right"
                              >
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-name"
                                >
                                  💎1,000,000 พ้อยท์ แลก 💰101,138 เครดิต
                                </div>
                                {/**/}
                                <div
                                  data-v-0016e830=""
                                  className="reward-item-redeem-button"
                                >
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-icon"
                                  >
                                    <img
                                      data-v-0016e830=""
                                      src="data:image/webp;base64,UklGRtABAABXRUJQVlA4TMQBAAAv+UA+EIDYNpIjifmnfe97p/V+IxDStpqPEEIIQwhhCEMYQghDCCGEEEIYQgZ/AuD2/+3/vykddeWcc24zay0cj6gEZzTak0a6VrVHI2xSDRGNsLMhos9JNkTDSTZEw0k2RGN3Q1S0Gxq7G6IXDiXphpp0Q026oSbdUIdDEQ6dcGiF0+GQh0MaToVDFk6FQxZOhkMazgvnh0MWzgvnh0O6HwZvaTGHS3+cu7OnqSNnyc0BAOFmkL88AMLnINkeADNj2P7AMlPcAGBN8QqAO0QlADVDN6AzsAGIcNYM0gD0CBaBh2PhSDgop8OpLzkTDrtZI6wIzgiIILsRnGgi8BGqATEjZAOJI3kCB2faBSwcagVgZgrsz8Gpan1U4lhveVTgYHtz1NU4miyNMi58HC5hP4K/XCqllMFLdBd03bSbgm5ONwPdeDjaTUA32o1DNkO62ZBNQjZDujHIxiGbgGyaZNMEqmkC1TSBaopANQ9OfjZjQzVFIZpx4fTnEgSiSQoLPJOgsMID+ZzCEk9jhA17PIrv2bDKY2jhUNjmAXzluQxWek2+evQ4t5kFix3CIOHtv9t/t//+KeeokVaD2/+3//+cBw=="
                                      alt=""
                                    />
                                  </div>
                                  <div
                                    data-v-0016e830=""
                                    className="reward-item-point-number"
                                  >
                                    1,000,000
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-0016e830=""
                              className="reward-item-member-rank-mob"
                            >
                              <span data-v-0016e830="">VIP 2</span>
                              <span data-v-0016e830="">VIP 3</span>
                              <span data-v-0016e830="">VIP 4</span>
                              <span data-v-0016e830="">VIP 5</span>
                              <span data-v-0016e830="">VIP 6</span>
                              <span data-v-0016e830="">VIP 7</span>
                              <span data-v-0016e830="">VIP 8</span>
                              <span data-v-0016e830="">4+</span>
                            </div>
                          </div>
                          {/**/}
                          {/**/}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-077a4955="" className="close-btn">
                  ยกเลิก
                </div>
              </div>
            </div>
          </div>
          <div
            data-v-077a4955=""
            className="balancelist-fixed-cover"
            style={{ display: "none" }}
          />
        </section>
      </div>
      <div className="index-content-wrapper" style={{ paddingTop: 90 }}>
        <section
          data-v-260f4976=""
          className="index-section"
          data_vue_tag="transition"
        >
          <div data-v-260f4976="" className="containerClass">
            <div>
              <div>
                <div className="index-banner">
                  <div className="web_banner">
                    <div className="banner-wrapper" data_vue_tag="Banner">
                      <div className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-ios">
                        {" "}
                        <div
                          className="swiper-wrapper"
                          style={{ transitionDuration: "1000ms" }}
                        >
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={13}
                          >
                            <div className="banner-content">
                              <img
                                data-id={6}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.6.4.s.webp?version=12"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.6.4.webp?version=12"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={14}
                          >
                            <div className="banner-content">
                              <img
                                data-id={40}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.40.4.s.webp?version=18"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.40.4.webp?version=18"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                            data-swiper-slide-index={15}
                          >
                            <div className="banner-content">
                              <img
                                data-id={17}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.17.4.s.webp?version=9"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.17.4.webp?version=9"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={0}
                          >
                            <div className="banner-content">
                              <img
                                data-id={68}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.68.4.s.webp?version=2"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.68.4.webp?version=2"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={1}
                          >
                            <div className="banner-content">
                              <img
                                data-id={10}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.10.4.s.webp?version=18"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.10.4.webp?version=18"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={2}
                          >
                            <div className="banner-content">
                              <img
                                data-id={45}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.45.4.s.webp?version=14"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.45.4.webp?version=14"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={3}
                          >
                            <div className="banner-content">
                              <img
                                data-id={63}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.63.4.s.webp?version=5"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.63.4.webp?version=5"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={4}
                          >
                            <div className="banner-content">
                              <img
                                data-id={20}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.20.4.s.webp?version=16"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.20.4.webp?version=16"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={5}
                          >
                            <div className="banner-content">
                              <img
                                data-id={22}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.22.4.s.webp?version=12"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.22.4.webp?version=12"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={6}
                          >
                            <div className="banner-content">
                              <img
                                data-id={32}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.32.4.s.webp?version=6"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.32.4.webp?version=6"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={7}
                          >
                            <div className="banner-content">
                              <img
                                data-id={56}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.56.4.s.webp?version=9"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.56.4.webp?version=9"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={8}
                          >
                            <div className="banner-content">
                              <img
                                data-id={46}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.46.4.s.webp?version=12"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.46.4.webp?version=12"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={9}
                          >
                            <div className="banner-content">
                              <img
                                data-id={34}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.34.4.s.webp?version=29"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.34.4.webp?version=29"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={10}
                          >
                            <div className="banner-content">
                              <img
                                data-id={48}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.48.4.s.webp?version=23"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.48.4.webp?version=23"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={11}
                          >
                            <div className="banner-content">
                              <img
                                data-id={51}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.51.4.s.webp?version=31"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.51.4.webp?version=31"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={12}
                          >
                            <div className="banner-content">
                              <img
                                data-id={60}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.60.4.s.webp?version=1"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.60.4.webp?version=1"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={13}
                          >
                            <div className="banner-content">
                              <img
                                data-id={6}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.6.4.s.webp?version=12"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.6.4.webp?version=12"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={14}
                          >
                            <div className="banner-content">
                              <img
                                data-id={40}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.40.4.s.webp?version=18"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.40.4.webp?version=18"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={15}
                          >
                            <div className="banner-content">
                              <img
                                data-id={17}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.17.4.s.webp?version=9"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.17.4.webp?version=9"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={0}
                          >
                            <div className="banner-content">
                              <img
                                data-id={68}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.68.4.s.webp?version=2"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.68.4.webp?version=2"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={1}
                          >
                            <div className="banner-content">
                              <img
                                data-id={10}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.10.4.s.webp?version=18"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.10.4.webp?version=18"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={2}
                          >
                            <div className="banner-content">
                              <img
                                data-id={45}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.45.4.s.webp?version=14"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.45.4.webp?version=14"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                        </div>{" "}
                        <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-bullets-dynamic" />{" "}
                        <span
                          className="swiper-notification"
                          aria-live="assertive"
                          aria-atomic="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mob_banner">
                    <div className="banner-wrapper" data_vue_tag="Banner">
                      <div className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-ios">
                        {" "}
                        <div
                          className="swiper-wrapper"
                          style={{
                            transitionDuration: "0ms",
                            transform: "translate3d(-3750px, 0px, 0px)"
                          }}
                        >
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={14}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={41}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.41.4.s.webp?version=20"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.41.4.webp?version=20"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={15}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={52}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.52.4.s.webp?version=11"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.52.4.webp?version=11"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={16}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={53}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.53.4.webp?version=11"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.53.4.s.webp?version=11"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={0}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={67}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.67.4.webp?version=2"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.67.4.s.webp?version=2"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={1}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={11}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.11.4.webp?version=17"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.11.4.s.webp?version=17"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={2}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={44}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.44.4.webp?version=13"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.44.4.s.webp?version=13"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={3}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={62}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.62.4.webp?version=5"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.62.4.s.webp?version=5"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={4}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={21}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.21.4.webp?version=17"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.21.4.s.webp?version=17"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={5}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={23}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.23.4.webp?version=12"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.23.4.s.webp?version=12"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-prev"
                            data-swiper-slide-index={6}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={33}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.33.4.webp?version=8"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.33.4.s.webp?version=8"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-active"
                            data-swiper-slide-index={7}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={57}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.57.4.webp?version=8"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.57.4.s.webp?version=8"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-next"
                            data-swiper-slide-index={8}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={47}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.47.4.webp?version=14"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.47.4.s.webp?version=14"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={9}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={35}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.35.4.s.webp?version=28"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.35.4.webp?version=28"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={10}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={49}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.49.4.s.webp?version=24"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.49.4.webp?version=24"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={11}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={64}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.64.4.s.webp?version=5"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.64.4.webp?version=5"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={12}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={61}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.61.4.s.webp?version=1"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.61.4.webp?version=1"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={13}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={7}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.7.4.s.webp?version=13"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.7.4.webp?version=13"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={14}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={41}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.41.4.s.webp?version=20"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.41.4.webp?version=20"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={15}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={52}
                                data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.52.4.s.webp?version=11"
                                data-srcset="https://download.ocms.cloud/v2/HO/PictureLanguage.52.4.webp?version=11"
                                alt=""
                                className="swiper-lazy"
                              />
                            </div>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                          </div>
                          <div
                            className="web swiper-slide"
                            data-swiper-slide-index={16}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={53}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.53.4.webp?version=11"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.53.4.s.webp?version=11"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={0}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={67}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.67.4.webp?version=2"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.67.4.s.webp?version=2"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={1}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={11}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.11.4.webp?version=17"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.11.4.s.webp?version=17"
                              />
                            </div>
                          </div>
                          <div
                            className="web swiper-slide swiper-slide-duplicate"
                            data-swiper-slide-index={2}
                            style={{ width: 375 }}
                          >
                            <div className="banner-content">
                              <img
                                data-id={44}
                                alt=""
                                className="swiper-lazy swiper-lazy-loaded"
                                srcSet="https://download.ocms.cloud/v2/HO/PictureLanguage.44.4.webp?version=13"
                                src="https://download.ocms.cloud/v2/HO/PictureLanguage.44.4.s.webp?version=13"
                              />
                            </div>
                          </div>
                        </div>{" "}
                        <div
                          className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-bullets-dynamic"
                          style={{ width: 140 }}
                        >
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 1"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 2"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 3"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 4"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 5"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet swiper-pagination-bullet-active-prev-prev"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 6"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet swiper-pagination-bullet-active-prev"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 7"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet swiper-pagination-bullet-active swiper-pagination-bullet-active-main"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 8"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet swiper-pagination-bullet-active-next"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 9"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet swiper-pagination-bullet-active-next-next"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 10"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 11"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 12"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 13"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 14"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 15"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 16"
                            style={{ left: "-140px" }}
                          />
                          <span
                            className="swiper-pagination-bullet"
                            tabIndex={0}
                            role="button"
                            aria-label="Go to slide 17"
                            style={{ left: "-140px" }}
                          />
                        </div>{" "}
                        <span
                          className="swiper-notification"
                          aria-live="assertive"
                          aria-atomic="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div data-v-260f4976="" className="news-wrapper">
            <div className="news-block">
              <div className="news-scroll marquee">
                <div
                  style={{
                    width: 100000,
                    transform: "translateX(375px)",
                    animation:
                      "9.394s linear 1s infinite normal none running marqueeAnimation-1528294"
                  }}
                  className="js-marquee-wrapper"
                >
                  <div
                    className="js-marquee"
                    style={{ marginRight: 0, float: "left" }}
                  >
                    <div className="marquee-content">
                      <i className="glyphicon glyphicon-thumbs-up" />
                      <span className="title">็Hose138:</span>
                      <span>❤Happy Valentine's Day❤</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-v-0a0a1071=""
            data-v-260f4976=""
            className="external-link-wrapper socialMedia"
          >
            {/**/}
            {/**/}
          </div>
          <div
            data-v-779c561c=""
            data-v-260f4976=""
            className="luckySportWidgets"
            data_vue_tag="LuckySportWidgets"
          >
            <div data-v-779c561c="" id="scorecard" className="is-soccer">
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"67091650-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">Primera LPF</div>
                    <div className="MuiBox-root css-nl7reb">2nd half</div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardHomeTeam2.png"
                          title="sr:competitor:36842"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          IRM
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f">
                      <div className="MuiGrid-root MuiGrid-container css-1afsdl2">
                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true css-1wl8dq5">
                          0
                        </div>
                        <div
                          className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-1 css-1doag2i"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: 16,
                            fontWeight: "bold",
                            color: "rgb(255, 255, 255)"
                          }}
                        >
                          -
                        </div>
                        <div
                          className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true css-kxu0dz"
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            fontSize: 16,
                            fontWeight: "bold",
                            color: "rgb(255, 255, 255)"
                          }}
                        >
                          1
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor3203.svg"
                          title="sr:competitor:3203"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">CAB</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">1.42</div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"67091652-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">Primera LPF</div>
                    <div className="MuiBox-root css-nl7reb">2nd half</div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor36833.svg"
                          title="sr:competitor:36833"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          CAT
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f">
                      <div className="MuiGrid-root MuiGrid-container css-1afsdl2">
                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true css-1wl8dq5">
                          2
                        </div>
                        <div
                          className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-1 css-1doag2i"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: 16,
                            fontWeight: "bold",
                            color: "rgb(255, 255, 255)"
                          }}
                        >
                          -
                        </div>
                        <div
                          className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true css-kxu0dz"
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            fontSize: 16,
                            fontWeight: "bold",
                            color: "rgb(255, 255, 255)"
                          }}
                        >
                          0
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:369108"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">RCU</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">75</div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"67150230-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">J1 League</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>11:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardHomeTeam2.png"
                          title="sr:competitor:3144"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          JEF
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor5127.svg"
                          title="sr:competitor:5127"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">KAW</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"67690660-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">NSW NPL 1</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>11:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardHomeTeam2.png"
                          title="sr:competitor:2940"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          WOL
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:319451"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">NSW</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"67150232-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">J1 League</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>12:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor3140.svg"
                          title="sr:competitor:3140"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          REY
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor3139.svg"
                          title="sr:competitor:3139"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">VER</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"67690898-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">NSW NPL 1</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>12:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor92210.svg"
                          title="sr:competitor:92210"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          ROC
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:2941"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">MAS</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"67150240-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">J1 League</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>13:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor3143.svg"
                          title="sr:competitor:3143"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          AVI
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor3141.svg"
                          title="sr:competitor:3141"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">CER</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"67150242-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">J1 League</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>14:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor3138.svg"
                          title="sr:competitor:3138"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          GAM
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor3136.svg"
                          title="sr:competitor:3136"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">NGE</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"62082966-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">Super League</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>15:30</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardHomeTeam2.png"
                          title="sr:competitor:47465"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          ARE
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:86066"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">SPF</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"68640764-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">
                      Philippines Footb. League
                    </div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>16:45</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor142204.svg"
                          title="sr:competitor:142204"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          STL
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:753913"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">MAH</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"61061443-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">Serie A</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>18:30</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2695.svg"
                          title="sr:competitor:2695"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          UDI
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2793.svg"
                          title="sr:competitor:2793"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">SAS</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"68746334-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">
                      Indian Super League
                    </div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>18:30</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor379404.svg"
                          title="sr:competitor:379404"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          JAM
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:118660"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">MHM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"62082968-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">Super League</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>19:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor64299.svg"
                          title="sr:competitor:64299"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          BAU
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:64295"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">PEJ</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"68640756-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">
                      Philippines Footb. League
                    </div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>19:30</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardHomeTeam2.png"
                          title="sr:competitor:1119071"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          TAG
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:1026985"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">DON</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"61623600-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">LaLiga 2</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>20:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardHomeTeam2.png"
                          title="sr:competitor:35092"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          MIR
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:6577"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">LPA</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"61624408-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">LaLiga</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>20:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2851.svg"
                          title="sr:competitor:2851"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          OVI
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2825.svg"
                          title="sr:competitor:2825"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">ATH</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">2.2</div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"61061429-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">Serie A</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>21:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2761.svg"
                          title="sr:competitor:2761"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          CRE
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardAwayTeam.png"
                          title="sr:competitor:2713"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">GEN</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"61061437-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">Serie A</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>21:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/scoreCardHomeTeam2.png"
                          title="sr:competitor:2690"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          PAR
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2701.svg"
                          title="sr:competitor:2701"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">VER</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"61624410-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">LaLiga</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>15 Feb </div>
                      <div>22:15</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2818.svg"
                          title="sr:competitor:2818"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          RVC
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2836.svg"
                          title="sr:competitor:2836"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">ATM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="himalaya-dashboard"
                data-props='{"eid":"61061441-e","type":"soccer","event_type_id":"1","count":"20","width":"","secondary_background_color":"","text_primary_color":"","text_secondary_color":"","secondary_color":"","border_color":"","quick_link_border_color":"","lang":"","team_logo_size":"","text_ratio":"","box_shadow":"","backdrop_filter":"","outside_border_radius":"","inside_border_radius":"","status_color":"","odds_width":"","odds_gap":"","team_logo_gap":"","top_row_padding":"","font_family":""}'
              >
                <section className="MuiGrid-root MuiGrid-container css-jksnjh">
                  <div className="MuiGrid-root MuiGrid-item css-1wxo0tj">
                    <div className="MuiBox-root css-134f3fl">Serie A</div>
                    <div className="MuiBox-root css-c3eog2">
                      <div>16 Feb </div>
                      <div>0:00</div>
                    </div>
                  </div>
                  <div className="MuiGrid-root MuiGrid-container css-ntmgsg">
                    <div className="MuiGrid-root MuiGrid-item css-15pxiaz">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2696.svg"
                          title="sr:competitor:2696"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div
                          style={{
                            fontSize: 12,
                            transform: "scale(calc(0.833333))",
                            color: "rgb(255, 255, 255)",
                            fontWeight: 500,
                            whiteSpace: "nowrap"
                          }}
                        >
                          TOR
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item css-12f220f" />
                    <div className="MuiGrid-root MuiGrid-item css-19lgvq3">
                      <div className="MuiGrid-root MuiGrid-container css-1qvjn8i">
                        <img
                          src="https://static.uni247.xyz/images-v3/srcompetitor2685.svg"
                          title="sr:competitor:2685"
                          style={{
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            background: "rgb(64, 64, 64)",
                            opacity: 1,
                            display: "block"
                          }}
                        />
                      </div>
                      <div className="MuiGrid-root MuiGrid-item css-ak30oj">
                        <div className="MuiBox-root css-3u7jo4">BFC</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="MuiGrid-root MuiGrid-item css-1wxaqej"
                    style={{
                      width: 238,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  />
                  <div className="MuiGrid-root MuiGrid-container css-icouo5">
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">X</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-container css-1he1fwa">
                      <div className="MuiBox-root css-l7vszl">
                        <div className="MuiBox-root css-rlq2ku">2</div>
                        <div className="MuiBox-root css-gajkrd">-</div>
                        <div className="MuiBox-root css-ky3y79">
                          <img
                            src="https://static.uni247.xyz/images-v3/suspendV3.svg"
                            alt="Locked"
                            style={{
                              width: 16,
                              height: 16,
                              filter:
                                "brightness(0) saturate(100%) invert(100%)"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div data-v-260f4976="" className="containerClass">
            <div data_vue_tag="FitLayout">
              <div>
                <div className="index-gamelist">
                  <div className="index-parallel">
                    <div className="container-mid">
                      <div
                        className="featured-game"
                        data_vue_tag="GameWrapClass"
                      >
                        <h3 className="index-title">
                          <b>เกมพิเศษ</b>
                        </h3>
                        <div className="swiper-position">
                          <div
                            className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-free-mode swiper-container-ios"
                            data_vue_tag="Swiper"
                          >
                            {" "}
                            <div
                              className="swiper-wrapper"
                              style={{
                                transform: "translate3d(0px, 0px, 0px)"
                              }}
                            >
                              <div
                                className="swiper-slide swiper-slide-active"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/UGV2/PlatformGameList.7141.4.s.webp?version=8"
                                        alt="UGV2-UG Sports"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/UGV2/PlatformGameList.7141.4.webp?version=8"
                                        src="https://download.ocms.cloud/v2/common2/UGV2/PlatformGameList.7141.4.webp?version=8"
                                        lazy="loaded"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-ugv2 brand-length4"
                                    >
                                      UG
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      UG Sports
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">13067</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide swiper-slide-next"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/RSG/PlatformGameList.35592.3.s.webp?version=20"
                                        alt="RSG-5 Dragons"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/RSG/PlatformGameList.35592.3.webp?version=20"
                                        src="https://download.ocms.cloud/v2/common2/RSG/PlatformGameList.35592.3.webp?version=20"
                                        lazy="loaded"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-rsg brand-length3"
                                    >
                                      RSG
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      5 Dragons
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">43299</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.40895.3.s.webp?version=16"
                                        alt="JILIV2-Circus Jackpot"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.40895.3.webp?version=16"
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.40895.3.webp?version=16"
                                        lazy="loaded"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-jiliv2 brand-length6"
                                    >
                                      JILI
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Circus Jackpot
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">211</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.41648.3.s.webp?version=1"
                                        alt="AWV2-Aladdin 2 Mirage"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.41648.3.webp?version=1"
                                        src="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.41648.3.s.webp?version=1"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-awv2 brand-length4"
                                    >
                                      AW
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Aladdin 2 Mirage
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">81</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/SEXY/PlatformGameList.9627.4.s.webp?version=12"
                                        alt="SEXY-SEXY Live"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/SEXY/PlatformGameList.9627.4.webp?version=12"
                                        src="https://download.ocms.cloud/v2/common2/SEXY/PlatformGameList.9627.4.s.webp?version=12"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-sexy brand-length4"
                                    >
                                      SEXY
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      SEXY Live
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">71118</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/EVO/PlatformGameList.9630_4_1.s.webp?version=2"
                                        alt="EVO-EVO Live"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/EVO/PlatformGameList.9630_4_1.webp?version=2"
                                        src="https://download.ocms.cloud/v2/common2/EVO/PlatformGameList.9630_4_1.s.webp?version=2"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-evo brand-length3"
                                    >
                                      EVO
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      EVO Live
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">27824</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.7525.4.s.webp?version=8"
                                        alt="PGV2-Legendary Monkey King"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.7525.4.webp?version=8"
                                        src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.7525.4.s.webp?version=8"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-pgv2 brand-length4"
                                    >
                                      PG
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Legendary Monkey King
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">7566</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/BNGV2/PlatformGameList.20042.3.s.webp?version=9"
                                        alt="BNGV2-Green Chilli"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/BNGV2/PlatformGameList.20042.3.webp?version=9"
                                        src="https://download.ocms.cloud/v2/common2/BNGV2/PlatformGameList.20042.3.s.webp?version=9"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-bngv2 brand-length5"
                                    >
                                      BNG
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Green Chilli
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">29</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32628.4.s.webp?version=8"
                                        alt="PGV2-Legend of Perseus"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32628.4.webp?version=8"
                                        src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32628.4.s.webp?version=8"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-pgv2 brand-length4"
                                    >
                                      PG
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Legend of Perseus
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">5968</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.20758.3.s.webp?version=8"
                                        alt="AWV2-Fortune Tree"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.20758.3.webp?version=8"
                                        src="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.20758.3.s.webp?version=8"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-awv2 brand-length4"
                                    >
                                      AW
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Fortune Tree
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">19837</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.40938.3.s.webp?version=1"
                                        alt="PPV2-Amazing Money Machine"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.40938.3.webp?version=1"
                                        src="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.40938.3.s.webp?version=1"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-ppv2 brand-length4"
                                    >
                                      PP
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Amazing Money Machine
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">27</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/MT/PlatformGameList.42945.3.s.webp?version=1"
                                        alt="MT-WAYS OF THE QILIN"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/MT/PlatformGameList.42945.3.webp?version=1"
                                        src="https://download.ocms.cloud/v2/common2/MT/PlatformGameList.42945.3.s.webp?version=1"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-mt brand-length2"
                                    >
                                      MT
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      WAYS OF THE QILIN
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">74</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                            <span
                              className="swiper-notification"
                              aria-live="assertive"
                              aria-atomic="true"
                            />
                          </div>
                          <div
                            slot="button-prev"
                            className="swiper-prev featuredSwiper-prev swiper-button-disabled"
                            tabIndex={0}
                            role="button"
                            aria-label="Previous slide"
                            aria-disabled="true"
                          />
                          <div
                            slot="button-next"
                            className="swiper-next featuredSwiper-next"
                            tabIndex={0}
                            role="button"
                            aria-label="Next slide"
                            aria-disabled="false"
                          />
                        </div>
                      </div>
                      <div
                        className="promote-game"
                        data_vue_tag="GameWrapClass"
                      >
                        <h3 className="index-title">
                          <b>เกมใหม่ล่าสุด</b>
                        </h3>
                        <div className="swiper-position">
                          <div
                            className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-free-mode swiper-container-ios"
                            data_vue_tag="Swiper"
                          >
                            {" "}
                            <div
                              className="swiper-wrapper"
                              style={{
                                transform: "translate3d(0px, 0px, 0px)"
                              }}
                            >
                              <div
                                className="swiper-slide swiper-slide-active"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.43569.3.s.webp?version=16"
                                        alt="AWV2-Mystical Forest"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.43569.3.webp?version=16"
                                        src="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.43569.3.webp?version=16"
                                        lazy="loaded"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-awv2 brand-length4"
                                    >
                                      AW
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Mystical Forest
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">22</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide swiper-slide-next"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/KA/PlatformGameList.41907.3.s.webp?version=16"
                                        alt="KA-Forest Scorpion"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/KA/PlatformGameList.41907.3.webp?version=16"
                                        src="https://download.ocms.cloud/v2/common2/KA/PlatformGameList.41907.3.webp?version=16"
                                        lazy="loaded"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-ka brand-length2"
                                    >
                                      KA
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Forest Scorpion
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">10</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.43447.3.s.webp?version=16"
                                        alt="JILIV2-3 Lucky Baozhu"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.43447.3.webp?version=16"
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.43447.3.webp?version=16"
                                        lazy="loaded"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-jiliv2 brand-length6"
                                    >
                                      JILI
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      3 Lucky Baozhu
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">47</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.40949.3.s.webp?version=3"
                                        alt="PPV2-Mustang Gold"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.40949.3.webp?version=3"
                                        src="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.40949.3.s.webp?version=3"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-ppv2 brand-length4"
                                    >
                                      PP
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Mustang Gold
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">21</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.40950.3.s.webp?version=1"
                                        alt="PPV2-Great Rhino"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.40950.3.webp?version=1"
                                        src="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.40950.3.s.webp?version=1"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-ppv2 brand-length4"
                                    >
                                      PP
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Great Rhino
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">19</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.43667.3.s.webp?version=1"
                                        alt="AWV2-Temple Of Gold"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.43667.3.webp?version=1"
                                        src="https://download.ocms.cloud/v2/common2/AWV2/PlatformGameList.43667.3.s.webp?version=1"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-awv2 brand-length4"
                                    >
                                      AW
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Temple Of Gold
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">8</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/KA/PlatformGameList.41916.3.s.webp?version=16"
                                        alt="KA-Lunar Howl"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/KA/PlatformGameList.41916.3.webp?version=16"
                                        src="https://download.ocms.cloud/v2/common2/KA/PlatformGameList.41916.3.s.webp?version=16"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-ka brand-length2"
                                    >
                                      KA
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Lunar Howl
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">10</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/FCV2/PlatformGameList.43238.3.s.webp?version=16"
                                        alt="FCV2-DJ BOOM BOOM"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/FCV2/PlatformGameList.43238.3.webp?version=16"
                                        src="https://download.ocms.cloud/v2/common2/FCV2/PlatformGameList.43238.3.s.webp?version=16"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-fcv2 brand-length4"
                                    >
                                      FC
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      DJ BOOM BOOM
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">31</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41403.3.s.webp?version=16"
                                        alt="VP-Power of Odin"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41403.3.webp?version=16"
                                        src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41403.3.s.webp?version=16"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-vp brand-length2"
                                    >
                                      VP
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Power of Odin
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">56</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.43562.3.s.webp?version=31"
                                        alt="JILIV2-Chin Shi Huang Deluxe"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.43562.3.webp?version=31"
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.43562.3.s.webp?version=31"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-jiliv2 brand-length6"
                                    >
                                      JILI
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Chin Shi Huang Deluxe
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">55</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.43306.3.s.webp?version=17"
                                        alt="VP-Mystic of Fortune 1000"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.43306.3.webp?version=17"
                                        src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.43306.3.s.webp?version=17"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-vp brand-length2"
                                    >
                                      VP
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      Mystic of Fortune 1000
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">49</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="swiper-slide"
                                data_vue_tag="SwiperSlide"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="item"
                                  data_vue_tag="GameBlock"
                                >
                                  <div
                                    data-v-1db90751=""
                                    className="game-block gamelist-img-border new"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-1db90751=""
                                        src-low="https://download.ocms.cloud/v2/common2/FCV2/PlatformGameList.43234.3.s.webp?version=16"
                                        alt="FCV2-BAD RICH WOLF"
                                        lazy-progressive="true"
                                        data-src="https://download.ocms.cloud/v2/common2/FCV2/PlatformGameList.43234.3.webp?version=16"
                                        src="https://download.ocms.cloud/v2/common2/FCV2/PlatformGameList.43234.3.s.webp?version=16"
                                        lazy="loading"
                                      />
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="brand brand-fcv2 brand-length4"
                                    >
                                      FC
                                    </div>
                                    {/**/}
                                    <div
                                      data-v-1db90751=""
                                      className="love-icon"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="glyphicon glyphicon-heart"
                                      />
                                    </div>
                                    {/**/}
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="info-block"
                                  >
                                    <div
                                      data-v-1db90751=""
                                      className="game-name"
                                    >
                                      BAD RICH WOLF
                                    </div>
                                    <div
                                      data-v-1db90751=""
                                      className="play-count"
                                    >
                                      <i
                                        data-v-1db90751=""
                                        className="fa fa-play-circle"
                                      />
                                      <span data-v-1db90751="">75</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                            <span
                              className="swiper-notification"
                              aria-live="assertive"
                              aria-atomic="true"
                            />
                          </div>
                          <div
                            slot="button-prev"
                            className="swiper-prev promoteSwiper-prev swiper-button-disabled"
                            tabIndex={0}
                            role="button"
                            aria-label="Previous slide"
                            aria-disabled="true"
                          />
                          <div
                            slot="button-next"
                            className="swiper-next promoteSwiper-next"
                            tabIndex={0}
                            role="button"
                            aria-label="Next slide"
                            aria-disabled="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/**/}
          <div data-v-260f4976="" className="containerClass">
            <div data_vue_tag="FitLayout">
              <div>
                <div className="index-gamelist">
                  <div className="container-mid">
                    <div className="hot-game" data_vue_tag="GameWrapClass">
                      <h3 className="index-title">
                        <b>เกมที่นิยม</b>
                      </h3>
                      <div className="swiper-position">
                        <div
                          className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-free-mode swiper-container-ios"
                          data_vue_tag="Swiper"
                        >
                          {" "}
                          <div
                            className="swiper-wrapper"
                            style={{ transform: "translate3d(0px, 0px, 0px)" }}
                          >
                            <div
                              className="swiper-slide swiper-slide-active"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/JDBV2/PlatformGameList.7348.4.s.webp?version=18"
                                      alt="JDBV2-Open Sesame II"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/JDBV2/PlatformGameList.7348.4.webp?version=18"
                                      src="https://download.ocms.cloud/v2/common2/JDBV2/PlatformGameList.7348.4.s.webp?version=18"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-jdbv2 brand-length5"
                                  >
                                    JDB
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Open Sesame II
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">209106</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-next"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common/RSG/PlatformGameList.31697.4.s.webp?version=25"
                                      alt="RSG-Rich Mahjong"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common/RSG/PlatformGameList.31697.4.webp?version=25"
                                      src="https://download.ocms.cloud/v2/common/RSG/PlatformGameList.31697.4.s.webp?version=25"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-rsg brand-length3"
                                  >
                                    RSG
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Rich Mahjong
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">205780</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.37017.3.s.webp?version=12"
                                      alt="JILIV2-3 Rich Pigies"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.37017.3.webp?version=12"
                                      src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.37017.3.s.webp?version=12"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-jiliv2 brand-length6"
                                  >
                                    JILI
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    3 Rich Pigies
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">205773</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/NS/PlatformGameList.33412.4.s.webp?version=18"
                                      alt="NS-Aztec Gold Treasure"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/NS/PlatformGameList.33412.4.webp?version=18"
                                      src="https://download.ocms.cloud/v2/common2/NS/PlatformGameList.33412.4.s.webp?version=18"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-ns brand-length2"
                                  >
                                    NS
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Aztec Gold Treasure
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">205055</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/RSG/PlatformGameList.31038.4.s.webp?version=17"
                                      alt="RSG-Roma"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/RSG/PlatformGameList.31038.4.webp?version=17"
                                      src="https://download.ocms.cloud/v2/common2/RSG/PlatformGameList.31038.4.s.webp?version=17"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-rsg brand-length3"
                                  >
                                    RSG
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Roma
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">204781</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.2189.4.s.webp?version=22"
                                      alt="PPV2-5 Lions Megaways™"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.2189.4.webp?version=22"
                                      src="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.2189.4.s.webp?version=22"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-ppv2 brand-length4"
                                  >
                                    PP
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    5 Lions Megaways™
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">204603</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7444.4.s.webp?version=22"
                                      alt="JILIV2-Golden Empire"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7444.4.webp?version=22"
                                      src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7444.4.s.webp?version=22"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-jiliv2 brand-length6"
                                  >
                                    JILI
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Golden Empire
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">203661</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7489.4.s.webp?version=16"
                                      alt="JILIV2-Super Ace"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7489.4.webp?version=16"
                                      src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7489.4.s.webp?version=16"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-jiliv2 brand-length6"
                                  >
                                    JILI
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Super Ace
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">201776</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/BNGV2/PlatformGameList.35482.3.s.webp?version=6"
                                      alt="BNGV2-Lucky Penny"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/BNGV2/PlatformGameList.35482.3.webp?version=6"
                                      src="https://download.ocms.cloud/v2/common2/BNGV2/PlatformGameList.35482.3.s.webp?version=6"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-bngv2 brand-length5"
                                  >
                                    BNG
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Lucky Penny
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">200609</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32616.4.s.webp?version=5"
                                      alt="PGV2-Mahjong Ways 2"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32616.4.webp?version=5"
                                      src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32616.4.s.webp?version=5"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-pgv2 brand-length4"
                                  >
                                    PG
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Mahjong Ways 2
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">192212</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/BNGV2/PlatformGameList.20005.3.s.webp?version=9"
                                      alt="BNGV2-Sun of Egypt"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/BNGV2/PlatformGameList.20005.3.webp?version=9"
                                      src="https://download.ocms.cloud/v2/common2/BNGV2/PlatformGameList.20005.3.s.webp?version=9"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-bngv2 brand-length5"
                                  >
                                    BNG
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Sun of Egypt
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">190959</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="swiper-slide"
                              data_vue_tag="SwiperSlide"
                            >
                              <div
                                data-v-1db90751=""
                                className="item"
                                data_vue_tag="GameBlock"
                              >
                                <div
                                  data-v-1db90751=""
                                  className="game-block gamelist-img-border"
                                >
                                  <div data-v-1db90751="" className="game-img">
                                    <img
                                      data-v-1db90751=""
                                      src-low="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32644.4.s.webp?version=8"
                                      alt="PGV2-Rooster Rumble"
                                      lazy-progressive="true"
                                      data-src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32644.4.webp?version=8"
                                      src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32644.4.s.webp?version=8"
                                      lazy="loading"
                                    />
                                  </div>
                                  {/**/}
                                  <div
                                    data-v-1db90751=""
                                    className="brand brand-pgv2 brand-length4"
                                  >
                                    PG
                                  </div>
                                  {/**/}
                                  <div data-v-1db90751="" className="love-icon">
                                    <i
                                      data-v-1db90751=""
                                      className="glyphicon glyphicon-heart"
                                    />
                                  </div>
                                  {/**/}
                                </div>
                                <div data-v-1db90751="" className="info-block">
                                  <div data-v-1db90751="" className="game-name">
                                    Rooster Rumble
                                  </div>
                                  <div
                                    data-v-1db90751=""
                                    className="play-count"
                                  >
                                    <i
                                      data-v-1db90751=""
                                      className="fa fa-play-circle"
                                    />
                                    <span data-v-1db90751="">190634</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>{" "}
                          <span
                            className="swiper-notification"
                            aria-live="assertive"
                            aria-atomic="true"
                          />
                        </div>
                        <div
                          slot="button-prev"
                          className="swiper-prev hotSwiper-prev swiper-button-disabled"
                          tabIndex={0}
                          role="button"
                          aria-label="Previous slide"
                          aria-disabled="true"
                        />
                        <div
                          slot="button-next"
                          className="swiper-next hotSwiper-next"
                          tabIndex={0}
                          role="button"
                          aria-label="Next slide"
                          aria-disabled="false"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-v-2a747ea7=""
            data-v-260f4976=""
            className="external-link-wrapper"
          >
            {/**/}
            {/**/}
          </div>
          <div data-v-260f4976="" className="container-footer-forDarkredStyle">
            <div
              data-v-70a82e53=""
              data-v-260f4976=""
              className="external-link-wrapper"
            >
              <div data-v-70a82e53="" className="external-box clearfix">
                <div data-v-70a82e53="" className="external-link promote_one">
                  <div data-v-70a82e53="" className="external-link-content">
                    <div data-v-70a82e53="" className="img-link">
                      <img
                        data-v-70a82e53=""
                        alt=""
                        lazy-progressive="true"
                        data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.4.4.1.webp?version=66"
                        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                        lazy="loading"
                      />
                    </div>
                  </div>
                </div>
                <div data-v-70a82e53="" className="external-link promote_two">
                  <div data-v-70a82e53="" className="external-link-content">
                    <div data-v-70a82e53="" className="img-link">
                      <img
                        data-v-70a82e53=""
                        alt=""
                        lazy-progressive="true"
                        data-src="https://download.ocms.cloud/v2/HO/PictureLanguage.5.4.1.webp?version=63"
                        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                        lazy="loading"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-v-11e30b18="" data-v-260f4976="" className="">
              <div data-v-11e30b18="" data_vue_tag="FitLayout">
                <div>
                  <div data-v-11e30b18="" className="index-goal">
                    <div data-v-11e30b18="" className="trophy">
                      <img
                        data-v-11e30b18=""
                        src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/trophy_a711eff.webp"
                        alt="อันดับวันนี้"
                      />
                    </div>
                    <div data-v-11e30b18="" className="index-goal-border">
                      <div data-v-11e30b18="" className="index-goal-content">
                        <div
                          data-v-384512b5=""
                          data-v-11e30b18=""
                          className="index-ranking-wrapper iew"
                          data_vue_tag="RankingWrapper"
                        >
                          <div data-v-384512b5="" className="today-icon">
                            <img
                              data-v-384512b5=""
                              src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/today-icon_bc4f371.webp"
                              alt="อันดับวันนี้"
                            />
                            <p data-v-384512b5="">อันดับ D&amp;T</p>
                          </div>
                          <ul data-v-384512b5="" className="ranking-grid">
                            <li
                              data-v-8d4dd9d0=""
                              data-v-384512b5=""
                              className="dragon"
                              data_vue_tag="Ranking"
                            >
                              <div data-v-8d4dd9d0="" className="ranking-img">
                                <div data-v-8d4dd9d0="" className="game-img">
                                  <img
                                    data-v-8d4dd9d0=""
                                    src="https://download.ocms.cloud/v2/common2/CQ9/PlatformGameList.4813.4.3.webp?version=8"
                                  />
                                </div>
                              </div>
                              <div data-v-8d4dd9d0="" className="web_view">
                                {/**/}
                              </div>
                              <ul data-v-8d4dd9d0="">
                                <li
                                  data-v-8d4dd9d0=""
                                  className="winner"
                                  style={{ opacity: 1 }}
                                >
                                  <div data-v-8d4dd9d0="" className="player">
                                    W*n*e****
                                  </div>
                                  <div data-v-8d4dd9d0="" className="score">
                                    132125.00
                                  </div>
                                </li>
                                <div
                                  data-v-8d4dd9d0=""
                                  className="ranking-winner-img"
                                />
                              </ul>
                            </li>
                            <li
                              data-v-8d4dd9d0=""
                              data-v-384512b5=""
                              className="tiger"
                              data_vue_tag="Ranking"
                            >
                              <div data-v-8d4dd9d0="" className="ranking-img">
                                <div data-v-8d4dd9d0="" className="game-img">
                                  <img
                                    data-v-8d4dd9d0=""
                                    src="https://download.ocms.cloud/v2/common2/JDBV2/PlatformGameList.7402.4.3.webp?version=8"
                                  />
                                </div>
                              </div>
                              <div data-v-8d4dd9d0="" className="web_view">
                                {/**/}
                              </div>
                              <ul data-v-8d4dd9d0="">
                                <li
                                  data-v-8d4dd9d0=""
                                  className="winner"
                                  style={{ opacity: 1 }}
                                >
                                  <div data-v-8d4dd9d0="" className="player">
                                    m*t*v*9***
                                  </div>
                                  <div data-v-8d4dd9d0="" className="score">
                                    345.80
                                  </div>
                                </li>
                                <div
                                  data-v-8d4dd9d0=""
                                  className="ranking-winner-img"
                                />
                              </ul>
                            </li>
                          </ul>
                        </div>
                        <div
                          data-v-11e30b18=""
                          className="winner-list-wrapper"
                          data_vue_tag="WinListWrapper"
                        >
                          <h3 className="index-title goal">
                            <b>สถานะ</b>
                            <span>ปัจจุบัน</span>
                          </h3>
                          <div className="win-news-scroll">
                            <ul>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7512.4.3.webp?version=11"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            H*s****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            War of Dragons
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 19320.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7512.4.3.webp?version=11"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            H*s****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            War of Dragons
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 10900.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7512.4.3.webp?version=11"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            H*s****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            War of Dragons
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 7700.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7512.4.3.webp?version=11"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            H*s****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            War of Dragons
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 4935.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7512.4.3.webp?version=11"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            H*s****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            War of Dragons
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 3000.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "1000ms",
                                  transform: "translateY(0px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7512.4.3.webp?version=11"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            H*s****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            War of Dragons
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 3850.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "1000ms",
                                  transform: "translateY(80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/CQ9/PlatformGameList.4813.4.3.webp?version=8"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            S*k****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Flying Cai Shen
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 5731.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "1000ms",
                                  transform: "translateY(160px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7512.4.3.webp?version=11"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            S*k****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            War of Dragons
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 4545.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "1000ms",
                                  transform: "translateY(240px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/RSG/PlatformGameList.35592.3.3.webp?version=20"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            A*0*4*1*3***
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            5 Dragons
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 3200.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/JILIV2/PlatformGameList.7512.4.3.webp?version=11"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            S*k****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            War of Dragons
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 6765.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32616.4.3.webp?version=5"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            S*u*d***
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Mahjong Ways 2
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 3780.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32616.4.3.webp?version=5"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            S*u*d***
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Mahjong Ways 2
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 3500.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/CQ9/PlatformGameList.4813.4.3.webp?version=8"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            W*n*e****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Flying Cai Shen
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 65050.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/CQ9/PlatformGameList.4813.4.3.webp?version=8"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            W*n*e****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Flying Cai Shen
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 3180.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/PPV2/PlatformGameList.2185.4.3.webp?version=6"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">P*1***</span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            The Dog House Megaways
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 7240.80
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/CQ9/PlatformGameList.4813.4.3.webp?version=8"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            W*n*e****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Flying Cai Shen
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 10755.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/CQ9/PlatformGameList.4813.4.3.webp?version=8"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            W*n*e****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Flying Cai Shen
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 11120.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/CQ9/PlatformGameList.4813.4.3.webp?version=8"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            W*n*e****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Flying Cai Shen
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 18675.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/PGV2/PlatformGameList.32616.4.3.webp?version=5"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            W*n*e****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Mahjong Ways 2
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 25888.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                              <li
                                data-v-b20af59c=""
                                className="animate"
                                style={{
                                  transitionDuration: "0ms",
                                  transform: "translateY(-80px)"
                                }}
                              >
                                <div
                                  data-v-b20af59c=""
                                  className="winner-block ranking-game-button-center"
                                >
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-img"
                                  >
                                    <div
                                      data-v-b20af59c=""
                                      className="game-img"
                                    >
                                      <img
                                        data-v-b20af59c=""
                                        src="https://download.ocms.cloud/v2/common2/CQ9/PlatformGameList.10464.4.3.webp?version=10"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    data-v-b20af59c=""
                                    className="winner-article"
                                    style={{ opacity: 1 }}
                                  >
                                    <div data-v-b20af59c="">
                                      <ul
                                        data-v-b20af59c=""
                                        className="winner-grid"
                                      >
                                        <li data-v-b20af59c="">
                                          ผู้เล่น
                                          <span data-v-b20af59c="">
                                            W*n*e****
                                          </span>
                                          ที่
                                        </li>
                                        <li data-v-b20af59c="">
                                          <span data-v-b20af59c="">
                                            Gu Gu Gu 3
                                          </span>
                                          ได้รางวัล
                                          <span
                                            data-v-b20af59c=""
                                            className="win-total"
                                          >
                                            ฿ 8250.00
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/**/}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div
        data-v-1dc9fb38=""
        className="entrance-center"
        data_vue_tag="Entrance"
      >
        <div
          data-v-1dc9fb38=""
          className="entrance-close-block"
          style={{ left: 0, top: 427 }}
        >
          <div data-v-1dc9fb38="" className="entrance-btn">
            <div
              data-v-1dc9fb38=""
              className="newtag"
              style={{ display: "none" }}
            >
              <img
                data-v-1dc9fb38=""
                src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/newtag_37ca4f2.webp"
                alt="entrance-new-tag"
                className=""
              />
            </div>
            <div data-v-1dc9fb38="" className="icon-box">
              <div data-v-1dc9fb38="" className="icon-effect" />
            </div>
          </div>
          <div data-v-1dc9fb38="" className="entrance-close" />
        </div>
        <div data-v-1dc9fb38="" className="entrance-open-block">
          <div data-v-1dc9fb38="" className="neon-block">
            <div data-v-1dc9fb38="" className="entrance-close-btn">
              <svg
                data-v-1dc9fb38=""
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 492 492"
                xmlSpace="preserve"
              >
                <g>
                  <g>
                    <path
                      d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12
C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084
c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864
l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div data-v-1dc9fb38="" className="side-content">
              <ul
                data-v-56876d76=""
                data-v-1dc9fb38=""
                className="promote-list side-list"
                data_vue_tag="PromoteGameButtonList"
              >
                <li data-v-56876d76="">
                  <div
                    data-v-1409d7c6=""
                    data-v-a86302e8=""
                    data-v-56876d76=""
                    className="debounce-button wrapper promoteGameButton circle"
                    data_vue_tag="PromoteGameButton"
                  >
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="animation-shiny"
                    />
                    <img
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/rotate-reflective_2c3e4c3.webp"
                      alt=""
                      className="rotate-reflective"
                    />
                    <img
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/reflective_aaae122.webp"
                      alt=""
                      className="reflective"
                    />
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="game-img"
                    >
                      <img
                        data-v-a86302e8=""
                        data-v-1409d7c6=""
                        src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.35801.3.3.s.webp?version=13"
                        alt=""
                        lazy-progressive="true"
                        data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.35801.3.3.webp?version=13"
                        src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.35801.3.3.s.webp?version=13"
                        lazy="loading"
                      />
                    </div>
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="icon-tag-animate icon-new"
                    >
                      <img
                        data-v-a86302e8=""
                        data-v-1409d7c6=""
                        src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/tag-vp_d1e5817.webp"
                        alt="vp"
                      />
                    </div>
                  </div>
                </li>
                <li data-v-56876d76="">
                  <div
                    data-v-1409d7c6=""
                    data-v-a86302e8=""
                    data-v-56876d76=""
                    className="debounce-button wrapper promoteGameButton circle"
                    data_vue_tag="PromoteGameButton"
                  >
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="animation-shiny"
                    />
                    <img
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/rotate-reflective_2c3e4c3.webp"
                      alt=""
                      className="rotate-reflective"
                    />
                    <img
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/reflective_aaae122.webp"
                      alt=""
                      className="reflective"
                    />
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="game-img"
                    >
                      <img
                        data-v-a86302e8=""
                        data-v-1409d7c6=""
                        src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.39332.3.3.s.webp?version=6"
                        alt=""
                        lazy-progressive="true"
                        data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.39332.3.3.webp?version=6"
                        src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.39332.3.3.s.webp?version=6"
                        lazy="loading"
                      />
                    </div>
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="icon-tag-animate icon-new"
                    >
                      <img
                        data-v-a86302e8=""
                        data-v-1409d7c6=""
                        src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/tag-vp_d1e5817.webp"
                        alt="vp"
                      />
                    </div>
                  </div>
                </li>
                <li data-v-56876d76="">
                  <div
                    data-v-1409d7c6=""
                    data-v-a86302e8=""
                    data-v-56876d76=""
                    className="debounce-button wrapper promoteGameButton circle"
                    data_vue_tag="PromoteGameButton"
                  >
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="animation-shiny"
                    />
                    <img
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/rotate-reflective_2c3e4c3.webp"
                      alt=""
                      className="rotate-reflective"
                    />
                    <img
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/reflective_aaae122.webp"
                      alt=""
                      className="reflective"
                    />
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="game-img"
                    >
                      <img
                        data-v-a86302e8=""
                        data-v-1409d7c6=""
                        src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41403.3.3.s.webp?version=16"
                        alt=""
                        lazy-progressive="true"
                        data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41403.3.3.webp?version=16"
                        src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41403.3.3.s.webp?version=16"
                        lazy="loading"
                      />
                    </div>
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="icon-tag-animate icon-hot"
                    >
                      <img
                        data-v-a86302e8=""
                        data-v-1409d7c6=""
                        src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/tag-vp_d1e5817.webp"
                        alt="vp"
                      />
                    </div>
                  </div>
                </li>
                <li data-v-56876d76="">
                  <div
                    data-v-1409d7c6=""
                    data-v-a86302e8=""
                    data-v-56876d76=""
                    className="debounce-button wrapper promoteGameButton circle"
                    data_vue_tag="PromoteGameButton"
                  >
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="animation-shiny"
                    />
                    <img
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/rotate-reflective_2c3e4c3.webp"
                      alt=""
                      className="rotate-reflective"
                    />
                    <img
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/reflective_aaae122.webp"
                      alt=""
                      className="reflective"
                    />
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="game-img"
                    >
                      <img
                        data-v-a86302e8=""
                        data-v-1409d7c6=""
                        src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41160.3.3.s.webp?version=16"
                        alt=""
                        lazy-progressive="true"
                        data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41160.3.3.webp?version=16"
                        src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41160.3.3.s.webp?version=16"
                        lazy="loading"
                      />
                    </div>
                    <div
                      data-v-a86302e8=""
                      data-v-1409d7c6=""
                      className="icon-tag-animate icon-hot"
                    >
                      <img
                        data-v-a86302e8=""
                        data-v-1409d7c6=""
                        src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/tag-vp_d1e5817.webp"
                        alt="vp"
                      />
                    </div>
                  </div>
                </li>
              </ul>
              <div data-v-1dc9fb38="" className="line" />
              <ul data-v-1dc9fb38="" className="side-list promote-brand-list">
                <li
                  data-v-61377a5b=""
                  data-v-1dc9fb38=""
                  className="promote-brand-item"
                >
                  <div data-v-61377a5b="" className="brand-wrap">
                    <div
                      data-v-63a594d5=""
                      data-v-61377a5b=""
                      className="brandImg img-logo"
                    >
                      <img
                        data-v-63a594d5=""
                        src="https://download.ocms.cloud/gameComm/logo-01/VP?version=20260215"
                      />
                      {/**/}
                    </div>
                  </div>
                </li>
              </ul>
              <div data-v-1dc9fb38="" className="line" />
              <ul data-v-1dc9fb38="" className="side-list">
                <li data-v-1dc9fb38="">
                  <div
                    data-v-1dc9fb38=""
                    className="message"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">ไอเท็มกำลังจะหมดอายุ!</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">0</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">1</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    title="กระเป๋าเป้"
                    className="menu-button icon-backpack"
                  />
                </li>
                <li data-v-1dc9fb38="">
                  <div
                    data-v-1dc9fb38=""
                    className="message"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">ไอเท็มกำลังจะหมดอายุ!</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="" />
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">1</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    title="แข่งจัดอันดับ"
                    className="menu-button icon-tournament"
                  />
                </li>
                <li data-v-1dc9fb38="">
                  <div
                    data-v-1dc9fb38=""
                    className="message"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">ไอเท็มกำลังจะหมดอายุ!</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="" />
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">1</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    title="การแข่งขันฝากเงิน"
                    className="menu-button icon-depositTournament"
                  />
                </li>
                <li data-v-1dc9fb38="">
                  <div
                    data-v-1dc9fb38=""
                    className="message"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">ไอเท็มกำลังจะหมดอายุ!</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">0</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">1</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    title="ศูนย์กิจกรรม"
                    className="menu-button icon-mission"
                  />
                </li>
                <li data-v-1dc9fb38="">
                  <div
                    data-v-1dc9fb38=""
                    className="message"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">ไอเท็มกำลังจะหมดอายุ!</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="" />
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">1</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    title="ล็อคอินต่อเนื่อง"
                    className="menu-button icon-checkIn"
                  />
                </li>
                <li data-v-1dc9fb38="">
                  <div
                    data-v-1dc9fb38=""
                    className="message"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">ไอเท็มกำลังจะหมดอายุ!</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">0</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    className="num"
                    style={{ display: "none" }}
                  >
                    <span data-v-1dc9fb38="">1</span>
                  </div>
                  <div
                    data-v-1dc9fb38=""
                    title="จับฉลากชิงโชค"
                    className="menu-button icon-luckydraw"
                  />
                </li>
                {/**/}
                {/**/}
              </ul>
            </div>
            <div data-v-1dc9fb38="" className="neon-effect">
              <div data-v-1dc9fb38="" className="neon-border" />
              <div data-v-1dc9fb38="" className="neon-light with-animation" />
            </div>
          </div>
        </div>
        {/**/}
      </div>
      <footer configtype="[object Object]">
        <div data-v-539427b9="" className="web_view">
          <div data-v-539427b9="" className="footer-wrapper-web">
            <div data-v-539427b9="" className="footer-info-web">
              <h4 data-v-539427b9="">ข้อมูล</h4>
              <ul data-v-539427b9="" className="footer-nav-web">
                <li data-v-539427b9="">
                  <a
                    data-v-539427b9=""
                    href="/footerpage/aboutUs"
                    className=""
                    title="เกี่ยวกับเรา"
                  >
                    เกี่ยวกับเรา
                  </a>
                  {/**/}
                </li>
                <li data-v-539427b9="">
                  <a
                    data-v-539427b9=""
                    href="/footerpage/commonQuestion"
                    className=""
                    title="คำถามที่พบบ่อย"
                  >
                    คำถามที่พบบ่อย
                  </a>
                  {/**/}
                </li>
              </ul>
            </div>
            {/**/}
            <div data-v-539427b9="" className="footer-brand-web">
              <h4 data-v-539427b9="">ผู้ให้บริการเกม</h4>
              <ul data-v-539427b9="" className="footer-sponsor-web">
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="PTO"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.2.4?version=1533621019"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SA"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.11.4.png?version=1533620969"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="HBN"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/Platform.15.4.png?version=1533620938"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SEXY"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.22.4?version=1533620918"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="AG"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.23.4.webp?version=1533620899"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="NT"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.32.4?version=2"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="PNG"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.33.4.png?version=2"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="QS"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.35.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SG"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/Platform.37.4.png?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="BTI"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.38.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="CQ9"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/Platform.39.4.png?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="EVO"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/Platform.40.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SV"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.44.4?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="MGP"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.51.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="DG"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/Platform.52.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="KA"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/Platform.54.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="JOKER"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/Platform.55.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="RSG"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.63.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="WM"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.64.4?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="YGG"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/Platform.68.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="R88"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.70.4?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="PS"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.71.4?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SABA"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.73.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="EZ"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.75.4.webp?version=2"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="BB"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.78.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="EVOPLAY"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/Platform.81.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="BP"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.85.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="RCG"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.86.4.webp?version=2"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="CMD"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.91.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="PGV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.93.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="RELAX"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.95.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="UGV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.97.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SBOV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.98.4?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="PUSH"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.104.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="DIGITAIN"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.105.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="I8"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.106.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="PPV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.107.4.png?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="JDBV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.108.4.png?version=1533621035"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="JILIV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.110.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="MT"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.114.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="HS"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.118.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="FCV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.119.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="RON"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.122.4.webp?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="DELI"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.123.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SPB"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.125.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="ZITRO"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.126.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="TVBET"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.127.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="BGAMING"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.128.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="PINNACLE"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.129.4.webp?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="ASIA365"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.130.4?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="HRLIVE"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.131.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="BETGAMES"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.132.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="T1GAMES"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.134.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="FS"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.135.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="VR"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.136.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="V8"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.137.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="WMS"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.138.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="BTG"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.140.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="BG"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.143.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="AUX"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.144.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="MJ"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.145.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SW"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.157.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="NS"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.162.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="DB"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.168.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="RTV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.171.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="VIA"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.174.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="TP"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.179.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SV388V2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.181.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="HRBV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.183.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="PLAY8V2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.184.4?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="DSV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.185.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="KMV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.187.4.webp?version=1"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="LS"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.190.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="BNGV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.197.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="NLCEV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.199.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="VA"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.200.4.webp?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="VP"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.202.4.webp?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="AWV2"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.204.4.webp?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="OCTOPLAY"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.209.4.webp?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="ALIZET"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.211.4.webp?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SBP"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.213.4.webp?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="1BET"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.214.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="FUNKY"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.301.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
                <li data-v-539427b9="">
                  <img
                    data-v-539427b9=""
                    alt="SS"
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/HO/Platform.328.4.png?version=0"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    lazy="loading"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div
            data-v-539427b9=""
            className="v-html-default footer-copyright-web"
          >
            Copyright © Hose138 . All rights reserved
          </div>
        </div>
        <div className="mob_view">
          <div className="footerSeo-wrapper">
            <div className="footer-info-web">
              <h4>ข้อมูล</h4>
              <ul className="footer-nav-web">
                <li>
                  <a
                    href="/footerpage/aboutUs"
                    className=""
                    title="เกี่ยวกับเรา"
                  >
                    เกี่ยวกับเรา
                  </a>
                  {/**/}
                </li>
                <li>
                  <a
                    href="/footerpage/commonQuestion"
                    className=""
                    title="คำถามที่พบบ่อย"
                  >
                    คำถามที่พบบ่อย
                  </a>
                  {/**/}
                </li>
              </ul>
            </div>
            {/**/}
          </div>
          <section className="footer-section">
            {/**/}
            <div className="footer-wrapper-mob five">
              {/**/}
              {/**/}
              <div title="หน้าหลัก" className="footer-btn active">
                <div>
                  <div className="nuxt-link-active">
                    <img
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/home-icon_9ec3fc5.webp"
                      alt="หน้าหลัก"
                    />
                    <p>หน้าหลัก</p>
                  </div>
                </div>
              </div>
              {/**/}
              {/**/}
              <div title="เกม" className="footer-btn">
                <div>
                  <img
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/games-icon_d7a7e7a.webp"
                    alt="เกม"
                  />
                  <p>เกม</p>
                </div>
              </div>
              {/**/}
              {/**/}
              <div title="โปรโมชั่น" className="footer-btn">
                <div>
                  <img
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/promotion-icon_da735d3.webp"
                    alt="โปรโมชั่น"
                  />
                  <p>โปรโมชั่น</p>
                </div>
              </div>
              {/**/}
              {/**/}
              <div title="ศูนย์สมาชิก" className="footer-btn">
                <div>
                  {/**/}
                  {/**/}
                  <div>
                    <img
                      src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/member-icon_588fcd9.webp"
                      alt="ศูนย์สมาชิก"
                    />
                    <p>ศูนย์สมาชิก</p>
                  </div>
                </div>
              </div>
              {/**/}
              {/**/}
              <div title="บริการ" className="footer-btn">
                <div>
                  <img
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/service-icon_32f662f.webp"
                    alt="บริการ"
                  />
                  <p>บริการ</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </footer>
    </div>
    <div data-v-7c6d15b0="" className="main-bg">
      <div data-v-7c6d15b0="" className="main-bg-before" />
      <div data-v-7c6d15b0="" className="main-bg-after" />
    </div>
    <div
      data-v-6a787598=""
      id="fullscreenGameOpen"
      className=""
      style={{ display: "none" }}
    >
      <iframe
        data-v-6a787598=""
        allow="screen-wake-lock; clipboard-write; autoplay;"
        src=""
        className="common-game-iframe isIos"
      />
      <div data-v-6a787598="" className="lock-block">
        <span data-v-6a787598="">
          บัญชีถูกจำกัดสิทธิ์การใช้งาน กรุณาติดต่อฝ่ายบริการลูกค้า
        </span>
      </div>
      {/**/}
      <div data-v-6a787598="" className="game-navbar-mask" />
    </div>
    <div
      data-v-3b49794c=""
      id="floating-windows-manager"
      data_vue_tag="FloatingWindowsManager"
    >
      {/**/}
      {/**/}
      <div
        data-v-17b7c31c=""
        data-v-3b49794c=""
        className="wrapper hidden"
        data_vue_tag="DepositSuccess"
      >
        <div data-v-17b7c31c="" className="top-wrapper">
          <div data-v-17b7c31c="" className="close-wrapper">
            <img
              data-v-17b7c31c=""
              src="data:image/webp;base64,UklGRqwAAABXRUJQVlA4WAoAAAAQAAAAEwAAFAAAQUxQSF4AAAABN0AgQBnLEp4oIgLXXDCqbavKBU1gA0nAiDEjIliAT/8K73leh4j+G0zapu3mL69Cy7mYelZj5ugGvWVQyaFyKIAAApfdX7h6zsXMsVrw7gaVDCo59IcCCCAoCn0AVlA4ICgAAADQAgCdASoUABUAPm0ylUekIqIhKAgAgA2JaQAAPaOgAP70apRj9QAA"
              alt=""
            />
          </div>
          <div data-v-17b7c31c="" className="icon">
            <img
              data-v-17b7c31c=""
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF83N18zMzkzNykiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSI1MCIgZmlsbD0iI0NCRjhFNiIvPgo8Y2lyY2xlIGN4PSI1MC4wMDAzIiBjeT0iNTAuMDAwMSIgcj0iMzguMjAyMiIgZmlsbD0iIzJFRTM5RCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMxLjEyOTggNTIuMDQyNkMzMC4wNzM5IDUwLjk4NjcgMzAuMDczOSA0OS4yNzQ5IDMxLjEyOTggNDguMjE5QzMyLjE4NTYgNDcuMTYzMiAzMy44OTc1IDQ3LjE2MzIgMzQuOTUzMyA0OC4yMTlMNDQuNTEyMiA1Ny43Nzc5TDY1LjU0MTYgMzYuNzQ4NEM2Ni41OTc1IDM1LjY5MjYgNjguMzA5MyAzNS42OTI2IDY5LjM2NTIgMzYuNzQ4NEM3MC40MjEgMzcuODA0MyA3MC40MjEgMzkuNTE2MSA2OS4zNjUyIDQwLjU3Mkw0Ni40MjM5IDYzLjUxMzJDNDUuMzY4MSA2NC41NjkgNDMuNjU2MiA2NC41NjkgNDIuNjAwNCA2My41MTMyTDMxLjEyOTggNTIuMDQyNloiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNzdfMzM5MzciPgo8cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"
              alt=""
            />
          </div>
          <div data-v-17b7c31c="" className="message-wrapper">
            <div data-v-17b7c31c="" className="title">
              ฝากสำเร็จ!
            </div>
            <div data-v-17b7c31c="" className="message">
              เงินฝาก <span className="highlight">฿</span>{" "}
              <span className="highlight">0</span> ได้ถูกโอนสำเร็จไปยัง
              เงินเหลือบัญชีหลัก แล้ว
            </div>
          </div>
        </div>
        <div data-v-17b7c31c="" className="bottom-wrapper">
          <ul
            data-v-56876d76=""
            data-v-17b7c31c=""
            className="promote-list"
            data_vue_tag="PromoteGameButtonList"
          >
            <li data-v-56876d76="">
              <div
                data-v-1409d7c6=""
                data-v-a86302e8=""
                data-v-56876d76=""
                className="debounce-button wrapper promoteGameButton square"
                data_vue_tag="PromoteGameButton"
              >
                {/**/}
                <div data-v-a86302e8="" data-v-1409d7c6="" className="game-img">
                  <img
                    data-v-a86302e8=""
                    data-v-1409d7c6=""
                    src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.35801.3.3.s.webp?version=13"
                    alt=""
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.35801.3.3.webp?version=13"
                    src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.35801.3.3.s.webp?version=13"
                    lazy="loading"
                  />
                </div>
                <div
                  data-v-a86302e8=""
                  data-v-1409d7c6=""
                  className="icon-tag-animate icon-new"
                >
                  <img
                    data-v-a86302e8=""
                    data-v-1409d7c6=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/tag-new_2ecc712.webp"
                    alt="icon-new"
                  />
                </div>
              </div>
            </li>
            <li data-v-56876d76="">
              <div
                data-v-1409d7c6=""
                data-v-a86302e8=""
                data-v-56876d76=""
                className="debounce-button wrapper promoteGameButton square"
                data_vue_tag="PromoteGameButton"
              >
                {/**/}
                <div data-v-a86302e8="" data-v-1409d7c6="" className="game-img">
                  <img
                    data-v-a86302e8=""
                    data-v-1409d7c6=""
                    src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.39332.3.3.s.webp?version=6"
                    alt=""
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.39332.3.3.webp?version=6"
                    src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.39332.3.3.s.webp?version=6"
                    lazy="loading"
                  />
                </div>
                <div
                  data-v-a86302e8=""
                  data-v-1409d7c6=""
                  className="icon-tag-animate icon-new"
                >
                  <img
                    data-v-a86302e8=""
                    data-v-1409d7c6=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/tag-new_2ecc712.webp"
                    alt="icon-new"
                  />
                </div>
              </div>
            </li>
            <li data-v-56876d76="">
              <div
                data-v-1409d7c6=""
                data-v-a86302e8=""
                data-v-56876d76=""
                className="debounce-button wrapper promoteGameButton square"
                data_vue_tag="PromoteGameButton"
              >
                {/**/}
                <div data-v-a86302e8="" data-v-1409d7c6="" className="game-img">
                  <img
                    data-v-a86302e8=""
                    data-v-1409d7c6=""
                    src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41403.3.3.s.webp?version=16"
                    alt=""
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41403.3.3.webp?version=16"
                    src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41403.3.3.s.webp?version=16"
                    lazy="loading"
                  />
                </div>
                <div
                  data-v-a86302e8=""
                  data-v-1409d7c6=""
                  className="icon-tag-animate icon-hot"
                >
                  <img
                    data-v-a86302e8=""
                    data-v-1409d7c6=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/tag-hot_cdf6bc6.webp"
                    alt="icon-hot"
                  />
                </div>
              </div>
            </li>
            <li data-v-56876d76="">
              <div
                data-v-1409d7c6=""
                data-v-a86302e8=""
                data-v-56876d76=""
                className="debounce-button wrapper promoteGameButton square"
                data_vue_tag="PromoteGameButton"
              >
                {/**/}
                <div data-v-a86302e8="" data-v-1409d7c6="" className="game-img">
                  <img
                    data-v-a86302e8=""
                    data-v-1409d7c6=""
                    src-low="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41160.3.3.s.webp?version=16"
                    alt=""
                    lazy-progressive="true"
                    data-src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41160.3.3.webp?version=16"
                    src="https://download.ocms.cloud/v2/common2/VP/PlatformGameList.41160.3.3.s.webp?version=16"
                    lazy="loading"
                  />
                </div>
                <div
                  data-v-a86302e8=""
                  data-v-1409d7c6=""
                  className="icon-tag-animate icon-hot"
                >
                  <img
                    data-v-a86302e8=""
                    data-v-1409d7c6=""
                    src="https://download.ocms.cloud/v3/ho/6.38.11-fc/memDesktop/img/tag-hot_cdf6bc6.webp"
                    alt="icon-hot"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span
        data-v-3b49794c=""
        aria-hidden="true"
        className="load-font-family"
        style={{ fontFamily: "Rajdhani-Medium" }}
      >
        1
      </span>
      <span
        data-v-3b49794c=""
        aria-hidden="true"
        className="load-font-family"
        style={{ fontFamily: "Rajdhani-Bold" }}
      >
        1
      </span>
      <span
        data-v-3b49794c=""
        aria-hidden="true"
        className="load-font-family"
        style={{ fontFamily: "Prompt-Bold" }}
      >
        1
      </span>
      <span
        data-v-3b49794c=""
        aria-hidden="true"
        className="load-font-family"
        style={{ fontFamily: "Prompt" }}
      >
        1
      </span>
    </div>
  </div>
</div>


      </>


    );
  }
}

export default Main;
